var PriceFormatter = {
  format: function (price) {
    if (!price) {
      return "";
    }

    price = String(price);
    price = price.padStart(3, "0");

    var amount = price.substr(0, price.length - 2);
    var decimals = price.substr(price.length - 2);

    var value = "";

    if (amount.length > 3) {
      amount = PriceFormatter.stringReverse(amount);
      amount = amount.replace(
        /(.{3})/g,
        "$1" + PriceFormatter.thousandsSeparator
      );
      amount = PriceFormatter.stringReverse(amount);
    }

    value += amount;

    if (PriceFormatter.showDecimals) {
      value += PriceFormatter.decimalSeparator + decimals;
    }

    value += PriceFormatter.currencySign;

    return value;
  },

  stringReverse: function (s) {
    var o = "";
    for (var i = s.length - 1; i >= 0; i--) o += s[i];
    return o;
  },

  showPrice: function (parentQuery, price, comparePrice) {
    PriceFormatter.showPriceByElement($(parentQuery), price, comparePrice);
  },

  showPriceByElement: function (element, price, comparePrice) {
    price = Math.trunc(price);
    comparePrice = Math.trunc(comparePrice);

    if (price == comparePrice || PriceFormatter.showComparePrice == "no") {
      comparePrice = "";
    }

    element
      .find("span.price s")
      .attr("data-compare-price", comparePrice)
      .html(PriceFormatter.format(comparePrice));
    element
      .find("span.price span")
      .attr("data-price", price)
      .html(PriceFormatter.format(price));
  },
};

$(document).ready(function () {
  function updateText() {
    var divElements = document.querySelectorAll(
      ".R-TextBody.R-TextBody--xxxxs"
    );
    var ratingElements = document.querySelectorAll(
      ".cssVar-header__subheading"
    );
    var productElements = document.querySelectorAll(
      ".R-TextBody.R-TextBody--xxxs.u-textLeft--all"
    );

    var authornameElements = document.querySelectorAll(".cssVar-authorName");

    var reviewDesc = document.querySelectorAll(
      ".R-ReviewsList__item--body.R-TextBody.R-TextBody--xxs.u-textLeft--all"
    );

    var reviewData = window.reviewSettings || {
      ratingText: "4.875",
      reviews: [
        {
          product: "Trockentuch 40 x 60 cm",
          location: "Mainz, Deutschland", 
          author: "Petra, G",
          description: "Passt zu jedem Putzbedarf und ist mega effektiv! Benutze es echt gerne! ❤️"
        },
        {
          product: "Trockentuch 50 x 80 cm",
          location: "Basel, Schweiz",
          author: "Christian, S", 
          description: "Die Größe ist ideal, ich brauche definitiv mehrere davon 😄 Mein Auto dankt mir, es ist perfekt für das Abtrocknen nach einer schönen Wäsche."
        },
        {
          product: "Trockentuch 40 x 60 cm",
          location: "Gera, Deutschland",
          author: "Sabine, W",
          description: "Ich war sofort begeistert von meinem ersten Trockentuch, die Qualität ist super! Natürlich habe ich auch für mich und meinen Partner jeweils eins besorgt, damit er mir helfen kann 😅 "
        },
        {
          product: "Trockentuch 40 x 60 cm", 
          location: "Salzburg, Österreich",
          author: "Oliver, K",
          description: "Wow! Dieses Tuch zeichnet sich durch seine hohe Saugfähigkeit aus, und dank seiner feinen Struktur hinterlässt es selbst auf empfindlichen Oberflächen, wie etwa Bildschirmen, keine Kratzer."
        }
      ]
    };

    var products = reviewData.reviews.map(review => review.product);
    var texts = reviewData.reviews.map(review => review.location);
    var authornames = reviewData.reviews.map(review => review.author);
    var reviewDecs = reviewData.reviews.map(review => review.description);

    if (ratingElements[0]) {
      ratingElements[0].textContent = "";

      ratingElements[0].appendChild(document.createTextNode("Mehr als "));

      var strongElement = document.createElement("strong");
      strongElement.textContent = reviewData.ratingText;
      ratingElements[0].appendChild(strongElement);

      ratingElements[0].appendChild(
        document.createTextNode(" positive Erfahrungen")
      );
    }

    if (ratingElements[1]) {
      ratingElements[1].remove();
    }

    if (reviewDesc.length >= 4) {
      for (let i = 0; i < 4; i++) {
        reviewDesc[i].textContent = reviewDecs[i];
      }
      observer.disconnect();
    }

    if (authornameElements.length >= 4) {
      for (let i = 0; i < 4; i++) {
        authornameElements[i].textContent = authornames[i];
      }
      observer.disconnect();
    }

    if (productElements.length >= 4) {
      for (let i = 0; i < 4; i++) {
        productElements[i].textContent = products[i];
      }
      observer.disconnect();
    }

    if (divElements.length >= 4) {
      for (let i = 0; i < 4; i++) {
        divElements[i].textContent = texts[i];
      }
      observer.disconnect();
    }
  }

  setTimeout(function() {
    $(".product-set-discounts-entry-content-product-body-out-of-stock").each(function() {
      $(this)
        .css("overflow", "visible")
        .css("height", "auto")
        .css("min-height", "20px")
        .css("white-space", "nowrap")
        .css("position", "relative")
        .css("padding-top", "3px")
        .css("padding-bottom", "3px")
        .css("z-index", "10")
        .css("margin-top", "8px")
        .find("div")
          .css("overflow", "visible")
          .css("white-space", "nowrap")
          .css("padding-right", "5px");
          
      if ($(this).closest(".product-set-discounts-entry-content-product").find("h4.animate-gratis").length > 0) {
        $(this).css("margin-top", "12px");
      }
    });
  }, 500);

  $(document).on("click", "#product-information-cart-button", function (e) {
    e.preventDefault();
    if (!$(this).attr("disabled") && $("#product-add-to-cart-form").length) {
      $("#product-add-to-cart-form").submit();
    }
  });

  var config = { childList: true, subtree: true };

  var callback = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        updateText();
      }
    }
  };

  var observer = new MutationObserver(callback);

  var reviewsContainer = document.querySelector('.reviews-section-container');
  if (reviewsContainer) {
      observer.observe(reviewsContainer, config);
  } else {
      observer.observe(document.body, config);
  }

  function updateVerifiedCustomerText() {
    var itemInnerDivs = document.querySelectorAll(".item__inner");

    for (let i = 0; i < itemInnerDivs.length && i < 4; i++) {
      var firstDivWithinItemInner =
        itemInnerDivs[i].querySelector("div:first-child");

      if (
        firstDivWithinItemInner &&
        firstDivWithinItemInner.querySelector(".revVerified") === null
      ) {
        var newDiv = document.createElement("span");
        newDiv.className = "revVerified";
        newDiv.innerHTML = `
        <svg id="fi_10620949" style="margin-left: -3px;" height="19" viewBox="0 0 128 128" width="19" xmlns="http://www.w3.org/2000/svg">
          <path d="m20.44 64c0 3.8 4.2 7 5.14 10.49s-1 8.48.78 11.65 7.1 3.9 9.71 6.51 3.29 7.84 6.5 9.7 8-.18 11.66.79 6.69 5.14 10.49 5.14 7-4.2 10.49-5.14 8.48 1 11.65-.79 3.89-7.09 6.51-9.7 7.84-3.29 9.7-6.5-.18-8 .79-11.66 5.14-6.69 5.14-10.49-4.2-7-5.14-10.49 1-8.48-.79-11.66-7.07-3.85-9.7-6.5-3.29-7.84-6.51-9.7-8 .18-11.65-.79-6.7-5.14-10.49-5.14-7 4.2-10.49 5.14-8.49-1.05-11.66.78-3.89 7.1-6.5 9.71-7.84 3.29-9.71 6.5.18 8-.78 11.66-5.14 6.69-5.14 10.49z" fill="#05b76f"></path>
          <path d="m59 80.82a4.51 4.51 0 0 0 3.18-1.32l24.63-24.64a4.5 4.5 0 0 0 -6.37-6.36l-21.44 21.5-11.44-11.48a4.5 4.5 0 1 0 -6.37 6.37l14.62 14.61a4.51 4.51 0 0 0 3.19 1.32z" fill="#fff7ed"></path>
        </svg>
        Verifizierter Kunde`;

        var secondDivWithinItemInner =
          firstDivWithinItemInner.children[0].nextElementSibling;
        if (secondDivWithinItemInner) {
          firstDivWithinItemInner.insertBefore(
            newDiv,
            secondDivWithinItemInner
          );
        } else {
          firstDivWithinItemInner.appendChild(newDiv);
        }
      }
    }
  }

  var config2 = { childList: true, subtree: true };

  var callback2 = function (mutationsList, observer2) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        updateVerifiedCustomerText();
      }
    }
  };

  var observer2 = new MutationObserver(callback2);

  if (reviewsContainer) {
    observer2.observe(reviewsContainer, config2);
  } else {
    observer2.observe(document.body, config2);
  }

  PriceFormatter.showComparePrice = $.trim(
    $("body").attr("data-show-compare-price")
  );

  var smallPP = $.trim($("body").attr("data-small-price-pattern")).replace(
    /(<([^>]+)>)/gi,
    ""
  );
  var pp = $.trim($("body").attr("data-price-pattern")).replace(
    /(<([^>]+)>)/gi,
    ""
  );
  PriceFormatter.pricePattern = pp;
  PriceFormatter.currencySignAtStart = pp.indexOf("1") != 0;
  PriceFormatter.currencySignAtEnd = !PriceFormatter.currencySignAtStart;
  PriceFormatter.showDecimals = smallPP.indexOf(3) !== -1;

  if (PriceFormatter.currencySignAtStart) {
    PriceFormatter.currencySign = pp.substr(0, pp.indexOf(1));
  } else if (PriceFormatter.currencySignAtEnd) {
    if (PriceFormatter.showDecimals) {
      PriceFormatter.currencySign = pp.substr(pp.indexOf(6) + 1).trim();
    } else {
      PriceFormatter.currencySign = smallPP
        .substr(smallPP.indexOf(22) + 2)
        .trim();
    }
  }

  PriceFormatter.thousandsSeparator = pp.substring(
    pp.indexOf(1) + 1,
    pp.indexOf(2)
  );
  if (PriceFormatter.showDecimals) {
    PriceFormatter.decimalSeparator = pp.substring(
      pp.indexOf(4) + 1,
      pp.indexOf(5)
    );
  } else {
    PriceFormatter.decimalSeparator = "";
  }

  if ($(".header-announcement-bar").attr("data-use-slideshow") == "true") {
    new Swiper(".header-announcement-bar", {
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: {
        delay:
          parseInt($(".header-announcement-bar").attr("data-slideshow-speed")) *
          1000,
        disableOnInteraction: false,
      },
    });
  }

  $("main").css("padding-top", $("#header").outerHeight());

  $(".header-menu-mobile-menu").click(openMobileMenu);
  $(".mobile-menu-header-close-icon").click(closeMobileMenu);
  $("#mobile-menu-overlay").click(closeMobileMenu);

  if ($(".mobile-menu-header img").length == 0) {
    $(".header-menu-logo img").clone().prependTo(".mobile-menu-header");
  }
  $(".mobile-menu-header img").css("height", "auto");

  $(".mobile-menu-sub-link-list").prev().removeAttr("href");
  $(".mobile-menu-sub-link-list").prev().click(openSubMobileMenu);
  $(".mobile-menu-content-submenu-header div").click(closeSubMobileMenu);

  $(".header-menu-sub-links")
    .parent()
    .hover(showSubDesktopMenu, hideSubDesktopMenu);

  $(".header-menu-cart-drawer").click(openCartDrawer);
  $("#cart-drawer-overlay").click(closeCartDrawer);

  initCart();

  $(".header-menu-search-popup").click(openSearchPopup);
  $("#search-popup-overlay").click(closeSearchPopup);

  initSearchPopup();

  $(".mobile-menu-search").click(function () {
    closeMobileMenu();
    openSearchPopup();

    $(".header-menu-search-popup input").focus();
  });

  $(".footer-column-menu h2").click(toggleFooterLinkList);

  if ($(".template-product").length > 0 || $(".product-media").length > 0) {
    handleProductPage();

    if ($('.product-text-input[data-mandatory="true"]').length > 0) {
      jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
        this.each(function () {
          $(this).css("position", "relative");
          for (var x = 1; x <= intShakes; x++) {
            $(this)
              .animate({ left: intDistance * -1 }, intDuration / intShakes / 4)
              .animate({ left: intDistance }, intDuration / intShakes / 2)
              .animate({ left: 0 }, intDuration / intShakes / 4);
          }
        });
        return this;
      };
    }
  }

  if ($(".template-collection").length > 0) {
    handleCollectionPage();
  }

  handleSections();

  document.addEventListener("shopify:section:load", function (event) {
    if (event.detail.sectionId == "cart-drawer") {
      openCartDrawer();
    }

    if (event.detail.sectionId == "search-popup") {
      openSearchPopup();
    }

    if (event.detail.sectionId == "mobile-menu") {
      openMobileMenu();

      if ($(".mobile-menu-header img").length == 0) {
        $(".header-menu-logo img").clone().prependTo(".mobile-menu-header");
      }
      $(".mobile-menu-header img").css("height", "auto");
    }

    $("#shopify-section-" + event.detail.sectionId + " .animated-element").each(
      function () {
        $(this).addClass("animated-element-show-animation");
      }
    );

    handleSections("shopify-section-" + event.detail.sectionId);
    handleProductPage("shopify-section-" + event.detail.sectionId);
  });

  if ($(".animated-element:not(.animated-element-show-animation)").length > 0) {
    var windowScrollTop = 0;
    var animatedElementFunction = function () {
      windowScrollTop =
        $(this).scrollTop() + Math.ceil(window.screen.height * 0.75);

      $(".animated-element:not(.animated-element-show-animation)").each(
        function (index, element) {
          if (windowScrollTop >= element.offsetTop) {
            $(element).addClass("animated-element-show-animation");
          }
        }
      );
    };
    $(window).scroll(animatedElementFunction);
    animatedElementFunction();
  }

  $.ajax({
    type: "GET",
    url:
      "https://api.getconrise.com/v2/store?domain=" +
      $("body").attr("data-domain") +
      "&editor=" +
      (Shopify.designMode ? "true" : "false") +
      "&role=" +
      Shopify.theme.role,
    contentType: "application/json; charset=utf-8",
    success: function (response) {
      if (!response) {
        $("#sales-view").hide();

        if (Shopify.designMode) {
          $("#help-view").css("display", "flex");
        }
        return;
      }

      (response.htmlChanges || []).forEach((entry) => {
        if (entry.attr && entry.attr != "") {
          $(entry.selector).attr(entry.attr, entry.value);
        } else {
          $(entry.selector).html(entry.value);
        }
      });

      if (!response.license) {
        $("#starter-trail-expired-popup-iframe").attr(
          "src",
          (
            $("#starter-trail-expired-popup-iframe").attr("data-src") +
            "&nolicense=true"
          ).replace("pages/purchase", "pages/purchase-expired")
        );

        if (Shopify.designMode) {
          window.trialEndDateCalculated = true;
          $("#sales-view button").click();
        } else {
          if (isGermanShop()) {
            $("body").html(
              "<div>Bitte gehe in den Theme-Editor. Du musst dort eine Handlung vornehmen.</div>"
            );
          } else {
            $("body").html(
              "<div>Please go to the theme editor. You must perform an action there.</div>"
            );
          }

          $("body div").css({
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            "text-align": "center",
          });
        }
      } else if (response.state == "ONBOARDING" && Shopify.designMode) {
        $("main").hide();
        $("#discounted-trail-welcome").show();
        $(".discounted-trail-welcome-text").html(
          $(".discounted-trail-welcome-text").text()
        );
      } else if (response.state == "PURCHASED") {
        $("#sales-view").hide();

        if (response.upselling && response.upselling == "ONE_TIME") {
          $("#sales-view").css("display", "flex");

          $("#sales-view").addClass("upgrade");
          $("#starter-trail-expired-popup").addClass("offer-upgrade");

          $("#sales-view .btn").html(
            $("#sales-view .btn").attr("data-upgrade-translation")
          );

          $(".starter-trail-expired-content-header .container h1").html(
            $(".starter-trail-expired-content-header .container h1").attr(
              "data-upgrade-translation"
            )
          );
          $(
            ".offer-expired .starter-trail-expired-content-offer-headline"
          ).html(
            $(
              ".offer-expired .starter-trail-expired-content-offer-headline"
            ).attr("data-upgrade-translation")
          );
          $(".starter-trail-expired-content-offer-advantage:eq(0) span").html(
            $(".starter-trail-expired-content-offer-advantage:eq(0) span").attr(
              "data-upgrade-translation"
            )
          );
          $(".starter-trail-expired-content-offer-advantage:eq(1) span").html(
            $(".starter-trail-expired-content-offer-advantage:eq(1) span").attr(
              "data-upgrade-translation"
            )
          );
          $(".starter-trail-expired-content-offer-advantage:eq(2) span").html(
            $(".starter-trail-expired-content-offer-advantage:eq(2) span").attr(
              "data-upgrade-translation"
            )
          );
        }
      } else if (response.state == "TRAIL" && Shopify.designMode) {
        $("#sales-view").css("display", "flex");

        var options = { month: "long", day: "2-digit" };
        var trailStartDate = new Date(response.trailStartedDate * 1000);
        var trailEndDate = new Date(response.trailStartedDate * 1000);
        trailEndDate.setDate(trailEndDate.getDate() + 30);

        $("#sales-view .sales-view-ending-date").text(
          trailEndDate.toLocaleDateString(
            $("#sales-view").attr("data-locale"),
            options
          )
        );

        var now = new Date();
        var days = 0;
        if (trailStartDate.getMonth() != now.getMonth()) {
          var lastMonthDateObject = new Date(trailStartDate);
          lastMonthDateObject.setMonth(lastMonthDateObject.getMonth() + 1);
          lastMonthDateObject.setDate(0);

          var lastMonthDays = lastMonthDateObject.getDate();
          days = lastMonthDays - trailStartDate.getDate();
          days += now.getDate();
        } else {
          days = now.getDate() - trailStartDate.getDate();
        }

        days = 30 - days;

        if (days < 0) {
          days = 0;
        }

        if (days == 0) {
          $("#sales-view .sales-view-header span").text(
            $("#sales-view .sales-view-header span").attr(
              "data-ending-today-translation"
            )
          );
        } else if (days == 1) {
          $("#sales-view .sales-view-header span").text(
            $("#sales-view .sales-view-header span").attr(
              "data-ending-tomorrow-translation"
            )
          );
        } else if (days < 28) {
          $("#sales-view .sales-view-header span").text(
            $("#sales-view .sales-view-header span")
              .attr("data-ending-translation")
              .replace("{days}", days)
          );
        }

        $("#starter-trail-expired-popup-iframe").attr(
          "src",
          $("#starter-trail-expired-popup-iframe").attr("data-src") +
            "&trailenddate=" +
            trailEndDate.getTime()
        );

        window.trialEndDateCalculated = true;
        $(document).trigger("trialEndDateCalculated");
      } else if (response.state == "TRAIL_EXPIRED" && Shopify.designMode) {
        $("#sales-view").css({
          display: "flex",
          "background-color": "#b71b00",
        });

        $("#sales-view .sales-view-header span").text(
          $("#sales-view .sales-view-header span").attr(
            "data-expired-translation"
          )
        );
        $("#sales-view .sales-view-ending").html(
          $("#sales-view .sales-view-ending").attr("data-expired-translation")
        );
        $("#sales-view .sales-view-info").html(
          $("#sales-view .sales-view-info").attr("data-expired-translation")
        );

        $("#starter-trail-expired-popup-iframe").attr(
          "src",
          $("#starter-trail-expired-popup-iframe").attr("data-src") +
            "&trailexpired=true"
        );

        window.trialEndDateCalculated = true;
        $(document).trigger("trialEndDateCalculated");
      }

      if (
        Shopify.designMode &&
        (response.state == "TRAIL" ||
          response.state == "TRAIL_EXPIRED" ||
          response.state == "PURCHASED")
      ) {
        $("#help-view").css("display", "flex");
      }

      if (Shopify.designMode && response.zoom) {
        var zoomDate = new Date(response.zoom.date);
        var zoomDateString =
          zoomDate.getHours().toString().padStart(2, "0") +
          ":" +
          zoomDate.getMinutes().toString().padStart(2, "0");
        var title = response.zoom.title[
          $("body").attr("data-language")
        ].replace("{date}", zoomDateString);

        if (zoomDate.getTime() <= Date.now()) {
          $("#zoom-call-button").addClass("on-air");
        } else {
          setTimeout(function () {
            $("#zoom-call-button").addClass("on-air");
          }, zoomDate.getTime() - Date.now());
        }

        $("#zoom-call-button").css("display", "flex");
        $(".zoom-call-button-title").html(title);

        $("#zoom-call-popup").attr(
          "src",
          $("#zoom-call-popup").attr("data-src") +
            "date=" +
            response.zoom.date +
            "&title=" +
            title +
            "&link=" +
            response.zoom.link
        );
      }
    },
    error: function () {
      $("#sales-view").hide();

      if (Shopify.designMode) {
        $("#help-view").css("display", "flex");
      }
    },
  });

  if (!Shopify.designMode) {
    return;
  }

  $("#zoom-call-button").click(function () {
    $("#zoom-call-popup").show();

    window.scrollTo(0, 0);

    $("main").hide();
  });

  // $("#starter-trail-expired-popup .btn").click(function () {
  //   apiT(3);
  // });

  $("#discounted-trail-welcome .btn").click(function () {
  // no global loader while cart drawer is open

    var url = $(this).attr("data-url");

    $.ajax({
      type: "PUT",
      url:
        "https://api.getconrise.com/v2/trail?domain=" +
        $("body").attr("data-domain") +
        "&t=d",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        if (!response || !response.success) {
          if (isGermanShop()) {
            alert(
              "Es ist ein Fehler aufgetreten: " +
                response.message +
                "\nBitte wende dich an unseren Support: support@getconrise.com."
            );
          } else {
            alert(
              "An error has occurred: " +
                response.message +
                "\nPlease contact our support: support@getconrise.com."
            );
          }

          return;
        }

        if (!url) {
          hideLoadingIndicator();

          $("main").show();
          $("#discounted-trail-welcome").hide();
        } else {
          window.location.href = url;
        }
      },
    });
  });

  $("#sales-view button").click(function (e) {
    var openFunc = function () {
      hideLoadingIndicator();

      $("#starter-trail-expired-popup-iframe").show();
      $("#starter-trail-expired-popup-overlay").show();

      window.scrollTo(0, 0);

      $("main").hide();

      // apiT(2);
    };

    if (window.trialEndDateCalculated) {
      openFunc();
    } else {
      showLoadingIndicator();
      $(document).on("trialEndDateCalculated", openFunc);
    }
  });

  $("#sales-view .sales-view-header img").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($("#sales-view").hasClass("collapsed")) {
      $("#sales-view").click();
      return;
    }

    $(".sales-view-ending").hide();
    $(".sales-view-info").hide();
    $("#sales-view .btn").hide();

    $("#sales-view").addClass("collapsed");

    if (localStorage) {
      localStorage.setItem("sales_view_collapsed", true);
    }
  });

  $("#sales-view").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (!$(this).hasClass("collapsed")) {
      return;
    }

    $(".sales-view-ending").show();
    $(".sales-view-info").show();
    $("#sales-view .btn").show();

    $("#sales-view").removeClass("collapsed");

    if (localStorage) {
      localStorage.setItem("sales_view_collapsed", false);
    }
  });

  if (localStorage && localStorage.getItem("sales_view_collapsed") == "true") {
    $("#sales-view .sales-view-header img").click();
  }

  $("#help-view").click(function () {
    $("#help-dashboard").show();
    $("#help-dashboard-overlay").show();

    window.scrollTo(0, 0);

    $("main").hide();
  });

  window.addEventListener("message", (evt) => {
    if (evt && evt.data === "conrise:close-sales-view") {
      $("#starter-trail-expired-popup-iframe").hide();
      $("#starter-trail-expired-popup-iframe").removeClass("animate");

      $("#starter-trail-expired-popup-overlay").hide();
      $("#starter-trail-expired-popup-overlay").removeClass("animate");

      $("main").show();
    }

    if (evt && evt.data === "conrise:close-help-center") {
      $("main").show();
      $("#help-dashboard").hide();
      $("#help-dashboard").removeClass("animate");

      $("#help-dashboard-overlay").hide();
      $("#help-dashboard-overlay").removeClass("animate");
    }

    if (
      evt &&
      typeof evt.data === "object" &&
      evt.data.event_id &&
      evt.data.event_id === "conrise:help-center-mailto"
    ) {
      $("#conrise-mailto-link").remove();
      $("body").append(
        '<a href="' +
          evt.data.data.href +
          '" id="conrise-mailto-link" style="display:none"></a>'
      );
      document.getElementById("conrise-mailto-link").click();
    }

    if (evt && evt.data === "conrise:close-zoom-view") {
      $("#zoom-call-popup").hide();
      $("main").show();
    }
  });

  if (Shopify && Shopify.theme && Shopify.theme.name) {
    Shopify.theme.name = "conrise => https://getconrise.com";
  }

  if ($(".template-product").length > 0) {
    setTimeout(function () {
      if (!$("#product-information-cart-button").attr("disabled")) {
        $("#product-information-cart-button span").text(
          $("#product-information-cart-button").attr("data-text-normal")
        );
      } else {
        $("#product-information-cart-button span").text(
          $("#product-information-cart-button").attr("data-text-disabled")
        );
      }
    }, 100);
  }

  var hasSizeVariant = false;
  if (window.cr_product && window.cr_product.options) {
    hasSizeVariant = window.cr_product.options.some(function (option) {
      return (
        option.toLowerCase().includes("size") ||
        option.toLowerCase().includes("größe")
      );
    });
  }

  if (
    hasSizeVariant &&
    $("#product-information-cart-button").attr("disabled")
  ) {
    var anyAvailable = false;

    if (window.cr_variantStock) {
      for (var variantId in window.cr_variantStock) {
        if (window.cr_variantStock[variantId] > 0) {
          anyAvailable = true;
          break;
        }
      }
    }

    if (anyAvailable) {
      $("#product-information-cart-button").removeAttr("disabled");
      $(".product-information-quantity").css("opacity", "1");
      $("#product-information-cart-button span").text(
        $("#product-information-cart-button").attr("data-text-normal")
      );
    }
  }

  $("#product-information-cart-button")
    .off("click")
    .on("click", function () {
      if (!$(this).attr("disabled")) {
        $("#product-add-to-cart-form").submit();
      }
    });



  setTimeout(function() {
    if ($(".product-set-discounts-entry").length > 0) {
      
      var selectedBundle = $(".product-set-discounts-entry.selected");
      
      if (selectedBundle.length === 0) {
        $(".product-set-discounts-entry").first().addClass("selected");
      } else if (selectedBundle.length > 1) {
        selectedBundle.not(selectedBundle.first()).removeClass("selected");
      }
      
      $(".product-set-discounts-entry:not(.selected)").each(function() {
        $(this).removeClass("selected");
      });
      
    }
  }, 500);

  $(document).on(
    "change",
    ".product-upsell-container .product-set-discounts-entry-content-product-body-select select",
    function () {
      const selectedOption = $(this).find("option:selected");
      const variantId = selectedOption.attr("data-variant-id");
      const imageUrl = selectedOption.attr("data-image-url");
      const price = selectedOption.attr("data-price");
      const compareAtPrice = selectedOption.attr("data-compare-at-price");

      const upsellContainer = $(this).closest(".product-upsell-container");
      const checkbox = upsellContainer.find(
        'input[type="checkbox"][id^="upsell-checkbox"]'
      );
      checkbox.val(variantId);

      if (imageUrl) {
        const image = upsellContainer.find(".product-upsell-image img");
        image.attr("src", imageUrl);
      }

    }
  );

  (function() {
    let startX, startY, isCartDrawerOpen = false;
    
    const originalOpenCartDrawer = openCartDrawer;
    const originalCloseCartDrawer = closeCartDrawer;
    
    window.openCartDrawer = function() {
      isCartDrawerOpen = true;
      originalOpenCartDrawer.apply(this, arguments);
    };
    
    window.closeCartDrawer = function() {
      isCartDrawerOpen = false;
      originalCloseCartDrawer.apply(this, arguments);
    };
    
    // Add touch event listeners for mobile swipe detection
    document.addEventListener('touchstart', function(e) {
      if (!isCartDrawerOpen) return;
      
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, {passive: true});
    
    document.addEventListener('touchend', function(e) {
      if (!isCartDrawerOpen || !startX) return;
      
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const deltaX = endX - startX;
      const deltaY = endY - startY;
      
      // Detect horizontal swipe (more horizontal than vertical movement)
      // and swipe to the right (deltaX > 50) while cart is open
      if (Math.abs(deltaX) > Math.abs(deltaY) && deltaX > 50) {
        // User swiped right, likely closing the cart
        setTimeout(function() {
          // Check if cart is still visually open but state might be inconsistent
          const cartVisible = $("#cart-drawer").css("visibility") === "visible";
          const overlayVisible = parseFloat($("#cart-drawer-overlay").css("opacity")) > 0;
          
          if (!cartVisible || !overlayVisible) {
            // Cart was closed by swipe gesture, ensure state is synchronized
            isCartDrawerOpen = false;
            reloadCart();
          }
        }, 100);
      }
      
      startX = startY = null;
    }, {passive: true});

    // Fallback: Monitor cart drawer visibility changes
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const visibility = cartDrawer.style.visibility;
            const isHidden = visibility === 'hidden' || 
                            cartDrawer.style.display === 'none' ||
                            parseFloat(window.getComputedStyle(cartDrawer).opacity) === 0;
            
            if (isHidden && mutation.oldValue && !mutation.oldValue.includes('hidden')) {
              // Cart drawer was just hidden, ensure cart state is fresh
              setTimeout(function() {
                reloadCart();
              }, 300);
            }
          }
        });
      });
      
      observer.observe(cartDrawer, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['style']
      });
    }
  })();

  // CART DRAWER DIFF MODE (feature-flagged)
  window.__CART_DRAWER_DIFF_MODE__ = (window.__CART_DRAWER_DIFF_MODE__ !== undefined) ? window.__CART_DRAWER_DIFF_MODE__ : true;

  var CartDrawerState = (function(){
  	var state = {
  		lastCartJson: null,
  		lineKeyToEl: new Map(),
        isInitialized: false,
        pendingOp: null
  	};
  	function snapshotDom() {
  		try {
  			state.lineKeyToEl.clear();
  			$(".cart-drawer-content .cart-drawer-item").each(function(){
  				var key = this.getAttribute("data-line-key");
  				if (key) state.lineKeyToEl.set(key, this);
  			});
  		} catch(e) {}
  	}
  	function setCart(cartJson){ state.lastCartJson = cartJson; }
  	function getCart(){ return state.lastCartJson; }
  	function initOnce(){ if (state.isInitialized) return; snapshotDom(); state.isInitialized = true; }
    return { initOnce: initOnce, snapshotDom: snapshotDom, setCart: setCart, getCart: getCart, state: state };
  })();

  function initCartDrawerDiffMode(){
  	if (!window.__CART_DRAWER_DIFF_MODE__) return;
  	CartDrawerState.initOnce();
  }

  // Hook into existing cart init/render flows
  (function(){
  	var originalRenderCartDrawer = typeof renderCartDrawer === 'function' ? renderCartDrawer : null;
  	if (originalRenderCartDrawer && !originalRenderCartDrawer.__wrappedForDiff){
  		renderCartDrawer = function(sectionsHtml, callback){
  			return originalRenderCartDrawer.call(this, sectionsHtml, function(){
  				try { initCartDrawerDiffMode(); CartDrawerState.snapshotDom(); } catch(e) {}
  				if (typeof callback === 'function') callback();
  			});
  		};
  		renderCartDrawer.__wrappedForDiff = true;
  	}

  	var originalReloadCart = typeof reloadCart === 'function' ? reloadCart : null;
  	if (originalReloadCart && !originalReloadCart.__wrappedForDiff){
  		reloadCart = function(cb, options){
  			if (!window.__CART_DRAWER_DIFF_MODE__) return originalReloadCart.call(this, cb, options);
  			// In diff mode we still fall back to original behavior for now, but capture latest DOM mapping after
  			return originalReloadCart.call(this, function(){
  				try { CartDrawerState.snapshotDom(); } catch(e) {}
  				if (typeof cb === 'function') cb();
  			}, options);
  		};
  		reloadCart.__wrappedForDiff = true;
  	}
  })();

  // Placeholder for optimistic quantity/update/remove in future phases
  function cartDrawerOptimisticUpdate(type, payload){
  	try {
  		if (type === 'qty' && payload && payload.el && typeof payload.toQty !== 'undefined') {
  			optimisticSetQtyUI(payload.el, payload.toQty);
  		}
  		if (type === 'remove' && payload && payload.el) {
  			optimisticRemoveHint(payload.el);
  		}
  	} catch(e) {}
  }

  // (moved into initCart)

  // Attempt minimal reconcile to avoid full reload
  function attemptCartReconcileOrReload(afterCart, fallbackCb){
    if (!window.__CART_DRAWER_DIFF_MODE__) { reloadCart(fallbackCb, { suppressTransitions: true }); return; }
    try {
      CartDrawerState.setCart(afterCart);
      var op = CartDrawerState.state.pendingOp;
      var itemsByKey = {};
      (afterCart.items||[]).forEach(function(it){ itemsByKey[it.key] = it; });
      var handled = false;
      if (op && op.type === 'qty' && op.lineKey) {
        if (itemsByKey[op.lineKey]) {
          var $el = $(".cart-drawer-content .cart-drawer-item[data-line-key='"+op.lineKey+"']");
          if ($el.length) {
          var lineIndex = $el.attr('data-line-index');
            var $input = $("#cart-drawer-item-quantity-input-" + lineIndex);
          if ($input.length) { $input.val(itemsByKey[op.lineKey].quantity); }
          try { window.setCartItemLoading?.(lineIndex, false); } catch(e) {}
            // Update price in line if present
            try {
              if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                var linePriceCents = (itemsByKey[op.lineKey].final_line_price != null) ? itemsByKey[op.lineKey].final_line_price : (itemsByKey[op.lineKey].line_price);
                if (linePriceCents != null) {
                  $el.find('.cart-drawer-item-price [data-price], .cart-drawer-item-price').each(function(){
                    if (this.hasAttribute('data-price')) { this.textContent = Shopify.formatMoney(linePriceCents); }
                  });
                }
              }
            } catch(e) {}
          try { $el.addClass('modified-flash'); setTimeout(function(){ $el.removeClass('modified-flash'); }, 500); } catch(e) {}
            handled = true;
          }
        }
      }
      if (op && op.type === 'remove' && op.lineKey) {
        if (!itemsByKey[op.lineKey]) {
          var $el = $(".cart-drawer-content .cart-drawer-item[data-line-key='"+op.lineKey+"']");
          if ($el.length) { setTimeout(function(){ $el.remove(); }, 260); handled = true; }
        }
      }
      // Update subtotal/total in footer
      try {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          var subtotal = afterCart.items_subtotal_price;
          var total = afterCart.total_price;
          if (subtotal != null) {
            $('.cart-drawer-footer-subtotal').text(Shopify.formatMoney(subtotal));
          }
          if (total != null) {
            $('.cart-drawer-footer-total').text(Shopify.formatMoney(total));
          }
        }
      } catch(e) {}
      // Brief highlight on affected line
      try { if (op && op.lineKey) { var $hl = $(".cart-drawer-content .cart-drawer-item[data-line-key='"+op.lineKey+"']"); $hl.addClass('modified-flash'); setTimeout(function(){ $hl.removeClass('modified-flash'); }, 420); } } catch(e) {}
      if (handled) {
        try { openCartDrawer(); } catch(e) {}
        hideLoadingIndicator();
        CartDrawerState.state.pendingOp = null;
        return;
      }
    } catch(e) {}
    reloadCart(function(){ try { showCartDrawerWithoutTransition(); } catch(e) {} if (typeof fallbackCb === 'function') fallbackCb(); }, { suppressTransitions: true });
  }


  function safeReconcile(afterCart, cb){
    try {
      if (typeof window.attemptCartReconcileOrReload === 'function') {
        return window.attemptCartReconcileOrReload(afterCart, cb);
      }
      if (typeof attemptCartReconcileOrReload === 'function') {
        return attemptCartReconcileOrReload(afterCart, cb);
      }
    } catch(e) {}
    try { reloadCart(function(){ try { showCartDrawerWithoutTransition(); } catch(e) {} if (typeof cb === 'function') cb(); }, { suppressTransitions: true }); } catch(_) {}
  }

  try { 
      window.safeReconcile = safeReconcile;
      window.attemptCartReconcileOrReload = attemptCartReconcileOrReload;
      window.animateCollapseLineByIndex = animateCollapseLineByIndex;
      window.animateCollapseVariantLines = animateCollapseVariantLines;
      window.setCartItemLoading = setCartItemLoading;
      window.setCartItemLoadingByKey = setCartItemLoadingByKey;
      window.setCartItemLoadingEl = setCartItemLoadingEl;
      window.setVariantLoading = setVariantLoading;
    } catch(e) {}
  
});

function isGermanShop() {
  return $("body").attr("data-language") == "de";
}

function handleTickInit(tick) {
  // Setup translations.
  var locale = {
    YEAR_PLURAL: "Jahre",
    YEAR_SINGULAR: "Jahr",
    MONTH_PLURAL: "Monate",
    MONTH_SINGULAR: "Monat",
    WEEK_PLURAL: "Wochen",
    WEEK_SINGULAR: "Woche",
    DAY_PLURAL: "Tage",
    DAY_SINGULAR: "Tag",
    HOUR_PLURAL: "Stunden",
    HOUR_SINGULAR: "Stunde",
    MINUTE_PLURAL: "Minuten",
    MINUTE_SINGULAR: "Minute",
    SECOND_PLURAL: "Sekunden",
    SECOND_SINGULAR: "Sekunde",
    MILLISECOND_PLURAL: "Millisekunden",
    MILLISECOND_SINGULAR: "Millisekunde",
  };

  for (var key in locale) {
    if (!locale.hasOwnProperty(key)) {
      continue;
    }
    tick.setConstant(key, locale[key]);
  }

  // Setup handler.
  window.countdownTicker = tick;
  $(document).trigger("TickerInit");
}

// function apiT(type) {
//   $.ajax({
//     type: "POST",
//     url: "https://api.getconrise.com/t",
//     data: JSON.stringify({
//       type: type,
//       d: $("body").attr("data-download-id"),
//     }),
//     contentType: "application/json; charset=utf-8",
//   });
// }

function openMobileMenu() {
  $("#mobile-menu").css("visibility", "visible");

  $("#mobile-menu-overlay").css("opacity", "0.5");
  $("#mobile-menu-content").css("transform", "translateX(0%)");
}

function closeMobileMenu() {
  setTimeout(function () {
    $("#mobile-menu").css("visibility", "hidden");
  }, 200);

  $("#mobile-menu-overlay").css("opacity", "0");
  $("#mobile-menu-content").css("transform", "translateX(-100%)");
}

function openSubMobileMenu() {
  $(this).next().attr("data-open", "true");

  $("#mobile-menu-content-submenu").css({
    transform: "translateX(0%)",
  });

  // Title.
  $("#mobile-menu-content-submenu h3").text($(this).find("span").text());

  // Menu list.
  $(
    "#mobile-menu-content-submenu .mobile-menu-content-submenu-content"
  ).empty();

  var cloned = $(this).next().clone();
  cloned.appendTo(
    "#mobile-menu-content-submenu .mobile-menu-content-submenu-content"
  );
  cloned.show();
}

function closeSubMobileMenu() {
  $("#mobile-menu-content-submenu").css({
    transform: "translateX(100%)",
  });
}

function showSubDesktopMenu() {
  $(this).find("ul").show();
}

function hideSubDesktopMenu() {
  $(this).find("ul").hide();
}

function openCartDrawer() {
  if ($(document).width() < 768) {
    $("#cart-drawer .cart-drawer-content").css("width", "100%");
  } else {
    $("#cart-drawer .cart-drawer-content").css("width", "35%");
  }

  $("#cart-drawer").css("visibility", "visible");

  $("#cart-drawer-overlay").css("opacity", "0.5");
  $("#cart-drawer .cart-drawer-content").css("transform", "translateX(0%)");
  
  // Prevent body scrolling on mobile when cart is open
  $("body").css({
    "overflow": "hidden",
    "position": "fixed",
    "width": "100%"
  });
}

// Show cart drawer content without animation, syncing overlay visibility
function showCartDrawerWithoutTransition() {
  $("#cart-drawer").css("visibility", "visible");
  $("#cart-drawer-overlay").css("opacity", "0.5");
  var $content = $("#cart-drawer .cart-drawer-content");
  $content.addClass("no-transition");
  $content.css("transform", "translateX(0%)");
  setTimeout(function(){ $content.removeClass("no-transition"); }, 10);
}

function closeCartDrawer() {
  setTimeout(function () {
    $("#cart-drawer").css("visibility", "hidden");
  }, 200);

  $("#cart-drawer-overlay").css("opacity", "0");
  $("#cart-drawer .cart-drawer-content").css("transform", "translateX(100%)");
  
  // Re-enable body scrolling
  $("body").css({
    "overflow": "",
    "position": "",
    "width": ""
  });

  // FIX: Always refresh cart state when drawer is closed
  // This ensures the header cart count and cart content stay in sync
  setTimeout(function() {
    reloadCart();
  }, 250); // Slight delay to ensure visual closing animation completes
}

function openSearchPopup() {
  if ($(document).width() < 768) {
    $("#search-popup .search-popup-content").css("width", "100%");
  } else {
    $("#search-popup .search-popup-content").css("width", "400px");
  }

  $("#search-popup").css("visibility", "visible");

  $("#search-popup-overlay").css("opacity", "0.5");
  $("#search-popup .search-popup-content").css("transform", "translateX(0%)");
}

function closeSearchPopup() {
  setTimeout(function () {
    $("#search-popup").css("visibility", "hidden");
  }, 200);

  $("#search-popup-overlay").css("opacity", "0");
  $("#search-popup .search-popup-content").css("transform", "translateX(100%)");
}

function toggleFooterLinkList() {
  if ($(document).width() >= 768) {
    return;
  }

  var ul = $(this).next();

  if (ul.css("display") == "none") {
    if ($(this).parents(".footer-column-menu-show-centered").length > 0) {
      $(this).find("span:last-child svg").css("transform", "rotate(90deg)");
    } else {
      $(this).find("span:last-child").text("-");
    }

    ul.show();
  } else {
    if ($(this).parents(".footer-column-menu-show-centered").length > 0) {
      $(this).find("span:last-child svg").css("transform", "rotate(0deg)");
    } else {
      $(this).find("span:last-child").text("+");
    }

    ul.hide();
  }
}

function showLoadingIndicator() {
  try {
    var cartVisible = $("#cart-drawer").css("visibility") === "visible";
    var overlayVisible = (parseFloat($("#cart-drawer-overlay").css("opacity")) || 0) > 0.01;
    if (cartVisible || overlayVisible) {
      return; // Do not show global loader while cart drawer is open
    }
  } catch(e) {}
  $("#loading-indicator").css({ display: "flex", "z-index": 10002 });
}

function hideLoadingIndicator() {
  $("#loading-indicator").css({ display: "none", "z-index": "" });
}

/* ======================================= */
/* =============== PRODUCT =============== */
/* ======================================= */

function handleProductPage(containerId) {
  if (containerId) {
    containerId = "#" + containerId + " ";
  } else {
    containerId = "";
  }

  // Swiper.
  var showThumbnails = $(containerId + ".product-media-main").attr(
    "data-thumbnails"
  );
  var mobileVertical = $(containerId + ".product-media-main").attr(
    "data-mobile-vertical"
  );
  var mobileFullWidth = $(containerId + ".product-media-main").attr(
    "data-mobile-full-width"
  );
  var spaceBetweenThumbnails = parseInt(
    $(containerId + ".product-media-main").attr("data-space-between-thumbnails")
  );
  var mainSwiperSpaceBetween = 10;

  if (spaceBetweenThumbnails > 0) {
    mainSwiperSpaceBetween = spaceBetweenThumbnails;
  }

  var mainSwiperOptions = {
    pagination: {
      el: containerId + ".product-media-main .swiper-pagination",
    },
    slidesPerView: 1,
    spaceBetween: 0,
  };

  if (mobileFullWidth != "true") {
    mainSwiperOptions.spaceBetween = mainSwiperSpaceBetween;
  }
  if (showThumbnails == "true") {
    mainSwiperOptions.thumbs = {
      swiper: new Swiper(containerId + ".product-media-thumbnail", {
        slidesPerView: 5,
        spaceBetween: spaceBetweenThumbnails,
        slideToClickedSlide: true,
      }),
    };
  }
  if (mobileVertical == "true") {
    mainSwiperOptions.direction = "vertical";
    mainSwiperOptions.touchReleaseOnEdges = true;
    mainSwiperOptions.resistanceRatio = 0;
    mainSwiperOptions.mousewheel = {
      releaseOnEdges: true,
    };
    mainSwiperOptions.breakpoints = {
      768: {
        direction: "horizontal",
        spaceBetween: mainSwiperSpaceBetween,
      },
    };

    $(containerId + ".product-media-main").height(
      $(containerId + ".product-media-main").width()
    );
  } else {
    mainSwiperOptions.breakpoints = {
      768: {
        spaceBetween: mainSwiperSpaceBetween,
      },
    };
  }

  window.mainSwiper = new Swiper(
    containerId + ".product-media-main",
    mainSwiperOptions
  );

  $(containerId + ".product-media-main img").click(function () {
    window.mainSwiper.slideNext();
  });

  // Quantity.
  $(containerId + '.product-information-quantity button[name="minus"]').click(
    function () {
      if ($("#product-information-cart-button").attr("disabled")) {
        return;
      }

      var input = $(containerId + ".product-information-quantity-field");
      var span = $(containerId + ".product-information-quantity-input");
      var value = Math.max(1, parseInt(input.val()) - 1);
      span.text(value);
      input.val(value);

      if (value == 1) {
        $(
          containerId +
            '.product-information-quantity button[name="minus"] svg path'
        ).css("stroke", "var(--color-border)");
      }
    }
  );
  $(containerId + '.product-information-quantity button[name="plus"]').click(
    function () {
      if ($("#product-information-cart-button").attr("disabled")) {
        return;
      }

      var input = $(containerId + ".product-information-quantity-field");
      var span = $(containerId + ".product-information-quantity-input");
      var value = parseInt(input.val()) + 1;

      if ($(this)[0].hasAttribute("data-stock")) {
        value = Math.min(value, $(this).attr("data-stock"));
      }

      span.text(value);
      input.val(value);

      $(
        containerId +
          '.product-information-quantity button[name="minus"] svg path'
      ).css("stroke", "var(--color-text)");
    }
  );

  // Variant.
  $(containerId + ".product-variant-select").change(setupSelectedVariant);
  $(containerId + ".product-variant-radio").change(setupSelectedVariant);

  $(
    containerId + ".product-information-variant-picker-button-variant-option"
  ).click(function () {
    var radio = $(this).find(".product-variant-radio");
    $(
      containerId + '.product-variant-radio[name="' + radio.attr("name") + '"]'
    ).removeAttr("checked");
    radio.attr("checked", true);

    setupSelectedVariant();

    // Force button text update
    if (!$("#product-information-cart-button").attr("disabled")) {
      $("#product-information-cart-button span").text(
        $("#product-information-cart-button").attr("data-text-normal")
      );
    }
  });

  $(containerId + ".product-information-variant-picker-button-box").click(
    function (e) {
      var variants = $(this).find(
        ".product-information-variant-picker-button-variants"
      );
      if (variants.css("display") == "none") {
        variants.css("display", "flex");
        $(this).find("label svg").css("rotate", "90deg");
        return;
      }

      if (
        $(e.target).is(
          ".product-information-variant-picker-button-variant label"
        ) ||
        $(e.target).is(
          ".product-information-variant-picker-button-variant label *"
        )
      ) {
        variants.css("display", "none");
        $(this).find("label svg").css("rotate", "0deg");
      }
    }
  );

  setupSelectedVariant(true);

  // Form.
  $("#product-add-to-cart-form").submit(function (event) {
    event.preventDefault();

    if ($("#product-information-cart-button").attr("disabled")) {
      return;
    }

    // Handle text mandatory fields.
    var allMandatoryFieldsFilled = true;
    $('.product-text-input[data-mandatory="true"]').each(function () {
      if ($(this).val() == "") {
        $(this).shake(2, 5, 300);
        allMandatoryFieldsFilled = false;
        return;
      }
    });

    if (!allMandatoryFieldsFilled) {
      return;
    }

    // Start loading.
    showLoadingIndicator();

    // Check if we're dealing with a bundle product or a standard product
    if ($(".product-set-discounts").length > 0 && $(".product-set-discounts-entry.selected").length > 0) {
      // --- This is the bundle logic that was deleted ---
      var properties = {};
       $(this)
         .serializeArray()
         .forEach(function (entry) {
           if (entry.name.indexOf("properties[") !== -1) {
             var name = entry.name.replace("properties[", "");
             name = name.substring(0, name.length - 1);
             properties[name] = entry.value;
           }
         });

      var selectedEntry = $(".product-set-discounts-entry.selected");
      var productCount = parseInt(selectedEntry.attr("data-product-count")) || 0;
      var freeProductCount = parseInt(selectedEntry.attr("data-free-product-count")) || 0;
      var nonFreeProductCount = productCount - freeProductCount;
      
      var selectedOptions = [];
      
      $(".product-set-discounts-entry.selected .product-set-discounts-entry-content-product-body-select").each(function (slotIndex) {
        
        var options = [];
        $(this).find("select").each(function () {
          var optionName = $(this).attr("name");
          var optionValue = $(this).val();
          var optionKey = "option" + (cr_product.options.indexOf(optionName) + 1);
          
          
            options.push({
            key: optionKey,
            value: optionValue,
            });
        });
        
('✅ Slot ' + (slotIndex + 1) + ' options:', options);
        selectedOptions.push(options);
      });
      
('🎯 FINAL selectedOptions array:', selectedOptions);
('   Should have', productCount, 'option sets, actually has', selectedOptions.length);

      var customPrice = selectedEntry.attr("data-custom-price");
      var customComparePrice = selectedEntry.attr("data-custom-compare-price");

      var bundleConfigParts = [];
      $(".product-set-discounts-entry").each(function () {
        var productCount = $(this).attr("data-product-count");
        var customPrice = $(this).attr("data-custom-price") || "";
        var customComparePrice = $(this).attr("data-custom-compare-price") || "";
        var freeCount = $(this).attr("data-free-product-count") || "0";
        var attachedProductId = $(this).attr("data-attached-product-id") || "";
        var attachedProductDiscount = $(this).attr("data-attached-product-discount") || "0";
        
        // ENHANCED: Include individual item pricing in bundle config
        var itemPrice = $(this).attr("data-item-price") || "";
        var itemComparePrice = $(this).attr("data-item-compare-price") || "";
        
        // Extended format: totalQty:bundlePrice:bundleCompare:freeCount:attachedId:attachedDiscount:itemPrice:itemCompare
        bundleConfigParts.push(productCount + ":" + customPrice + ":" + customComparePrice + ":" + freeCount + ":" + attachedProductId + ":" + attachedProductDiscount + ":" + itemPrice + ":" + itemComparePrice);
        
('📊 BUNDLE CONFIG GENERATED:', {
          productCount: productCount,
          customPrice: customPrice,
          customComparePrice: customComparePrice,
          itemPrice: itemPrice,
          itemComparePrice: itemComparePrice,
          freeCount: freeCount,
          attachedProductId: attachedProductId,
          fullConfig: productCount + ":" + customPrice + ":" + customComparePrice + ":" + freeCount + ":" + attachedProductId + ":" + attachedProductDiscount + ":" + itemPrice + ":" + itemComparePrice
        });
      });
      var bundleConfigsString = bundleConfigParts.join("|");

      var paidVariants = [];
      var attachedProducts = [];
      
      // Add individual paid variants (separate line item for each color)
      if (nonFreeProductCount > 0 && selectedOptions.length >= nonFreeProductCount) {
('🎯 PAID VARIANT SELECTION:');
('   nonFreeProductCount:', nonFreeProductCount);
('   selectedOptions.length:', selectedOptions.length);
('   selectedOptions:', selectedOptions);
        
        for (var paidIndex = 0; paidIndex < nonFreeProductCount; paidIndex++) {
('🔍 Looking for paid variant ' + (paidIndex + 1) + ' with options:', selectedOptions[paidIndex]);
          
        var variant = cr_product.variants.find(function (v) {
            var matchResult = selectedOptions[paidIndex].every(function (val) {
              var optionMatch = v[val.key] === val.value;
              // REMOVED: ('     Checking ' + val.key + ': "' + v[val.key] + '" === "' + val.value + '" → ' + optionMatch);
              return optionMatch;
            });
('   Variant ' + v.id + ' overall match:', matchResult);
            return matchResult;
          });
          
          if (variant) {
('✅ Found paid variant ' + (paidIndex + 1) + ':', {
              id: variant.id,
              option1: variant.option1,
              option2: variant.option2,
              option3: variant.option3
            });
          } else {
('❌ No variant found for paid index ' + (paidIndex + 1));
          }


        if (variant) {
          var itemProperties = { ...properties };
            if (customPrice && customPrice !== "") itemProperties["_custom_price"] = customPrice;
            if (customComparePrice && customComparePrice !== "") itemProperties["_custom_compare_price"] = customComparePrice;
          if (bundleConfigsString) itemProperties["_bundle_configs"] = bundleConfigsString;
          
          // CRITICAL: Add unique identifiers to prevent unwanted consolidation with attached items
          var uniqueTimestamp = Date.now();
          var uniqueId = uniqueTimestamp + '_paid_' + paidIndex + '_' + Math.random().toString(36).substr(2, 9);
          itemProperties["_bundle_unique_id"] = uniqueId;
          itemProperties["_bundle_session"] = uniqueTimestamp.toString();
          itemProperties["_bundle_paid_slot"] = (paidIndex + 1).toString(); // Track which paid slot this is

            paidVariants.push({ id: variant.id, quantity: 1, properties: itemProperties });
          }
        }
      }

      // NO CONSOLIDATION: Keep all paid items separate to maintain 1:1 paid-to-attached relationships
      // Each paid item will have its own unique properties preventing Shopify consolidation
      var itemsArray = paidVariants; // Direct assignment, no consolidation
      
('📋 Keeping', paidVariants.length, 'paid variants separate (no consolidation)');
('🎯 Paid variants details:', paidVariants.map(function(item) {
        return {
          id: item.id,
          quantity: item.quantity,
          uniqueId: item.properties._bundle_unique_id,
          paidSlot: item.properties._bundle_paid_slot
        };
      }));
      
      // --- CHECK IF ATTACHED PRODUCTS ARE CONFIGURED ---
      const selectedBundle = $('.product-set-discounts-entry.selected');
      var hasAttachedProducts = false;
      if (selectedBundle.length > 0) {
        const attachedProductId = selectedBundle.attr('data-attached-product-id');
        hasAttachedProducts = attachedProductId && attachedProductId !== '' && attachedProductId !== '0';
      }
      
      // --- ADD FREE ITEMS OF MAIN PRODUCT (ONLY IF NO ATTACHED PRODUCTS) ---
      if (freeProductCount > 0 && !hasAttachedProducts) {
        // Add free items of the main product with their selected variants
        $('.product-set-discounts-entry.selected .product-set-discounts-entry-content-product').each(function(index) {
          var freeProductIndex = index - nonFreeProductCount;
          
          // Only process actual free items (not paid items, not attached products)
          if (freeProductIndex >= 0 && freeProductIndex < freeProductCount) {
            var freeItemVariantOptions = [];
            $(this).find('select').each(function() {
              var selectName = $(this).attr('name');
              var selectValue = $(this).val();
              freeItemVariantOptions.push({
                key: "option" + (cr_product.options.indexOf(selectName) + 1),
                value: selectValue
              });
            });
            
            // Find matching variant for this free item
            var freeItemVariantId = (cr_product.selected_or_first_available_variant && cr_product.selected_or_first_available_variant.id) || cr_product.variants[0].id; // Safe default
            if (freeItemVariantOptions.length > 0) {
              var matchingVariant = cr_product.variants.find(function(variant) {
                return freeItemVariantOptions.every(function(option) {
                  return variant[option.key] === option.value;
                });
              });
              
              if (matchingVariant) {
                freeItemVariantId = matchingVariant.id;
              }
            }
            
            // Add this free item
          itemsArray.push({
              id: freeItemVariantId,
            quantity: 1,
            properties: {
                _is_free_item: "true",
                _free_item_index: (freeProductIndex + 1).toString()
            }
          });
        }
        });
      }
      
      // --- ADD ATTACHED PRODUCTS (REPLACES FREE ITEMS) ---
      if (hasAttachedProducts && freeProductCount > 0) {
        const attachedProductId = selectedBundle.attr('data-attached-product-id');
        const attachedProductDiscount = selectedBundle.attr('data-attached-product-discount') || 0;
        
('🔗 ADDING ATTACHED PRODUCTS - freeProductCount:', freeProductCount, 'paidVariants.length:', paidVariants.length);
        
        // FIXED: Use USER-SELECTED variants directly instead of trying to "match"
        for (var freeIndex = 1; freeIndex <= freeProductCount; freeIndex++) {
          var currentAttachedVariantId = parseInt(attachedProductId); // Default fallback
          var correspondingPaidVariant = null;
          var userSelectedAttachedOptions = null;
          
          // Find the corresponding paid variant for this free slot
          if (paidVariants[freeIndex - 1]) {
            correspondingPaidVariant = paidVariants[freeIndex - 1];
          }
          
          // CRITICAL FIX: Use the user's ACTUAL selection for the attached item
          // For 3+3 bundle: slots 1-3 are paid, slots 4-6 are attached
          var attachedSlotIndex = nonFreeProductCount + freeIndex - 1; // Index for attached slot in selectedOptions
          
('🎯 Looking for attached slot ' + freeIndex + ' at selectedOptions index ' + attachedSlotIndex);
('   selectedOptions total length:', selectedOptions.length);
('   nonFreeProductCount:', nonFreeProductCount, 'freeIndex:', freeIndex);
('   Expected attached slot in selectedOptions:', attachedSlotIndex);
          
          // Filter out bundle selectors (they only have 1 option and contain "Set")
          var productVariantSlots = selectedOptions.filter(function(optionSet) {
            return optionSet.length > 1 || (optionSet.length === 1 && !optionSet[0].value.includes("Set"));
          });
          
('🔍 FILTERED product variant slots (excluding bundle selectors):');
          productVariantSlots.forEach(function(slot, index) {
('   Product slot ' + index + ':', slot);
          });
          
          // Recalculate attached slot index based on filtered slots
          var actualAttachedSlotIndex = nonFreeProductCount + freeIndex - 1;
          
          if (productVariantSlots[actualAttachedSlotIndex] && productVariantSlots[actualAttachedSlotIndex].length > 1) {
            userSelectedAttachedOptions = productVariantSlots[actualAttachedSlotIndex];
            
('✅ USER SELECTED attached variant for slot ' + freeIndex + ':', userSelectedAttachedOptions);
            
            // Find the exact variant the user selected for the attached item
              if (window.cr_attached_product_variants) {
              var userSelectedAttachedVariant = window.cr_attached_product_variants.find(function(attachedVariant) {
                return userSelectedAttachedOptions.every(function(option) {
                  var match = attachedVariant[option.key] === option.value;
                  // REMOVED: ('     Checking user selected ' + option.key + ': "' + attachedVariant[option.key] + '" === "' + option.value + '" → ' + match);
                  return match;
                });
              });
              
              if (userSelectedAttachedVariant && userSelectedAttachedVariant.available) {
                currentAttachedVariantId = userSelectedAttachedVariant.id;
('✅ USING USER SELECTED attached variant:', {
                  attachedId: userSelectedAttachedVariant.id,
                  option1: userSelectedAttachedVariant.option1,
                  option2: userSelectedAttachedVariant.option2,
                  option3: userSelectedAttachedVariant.option3
                });
              } else {
('⚠️ User selected attached variant not available, using default:', currentAttachedVariantId);
              }
            }
          } else {
('⚠️ No user selection found for attached slot ' + freeIndex + ' in filtered slots');
('   Looking at filtered slot index:', actualAttachedSlotIndex);
('   Available at that index:', productVariantSlots[actualAttachedSlotIndex]);
            
            // FALLBACK: Only if no user selection, try to match the paid variant
            if (correspondingPaidVariant) {
              var paidVariant = cr_product.variants.find(function(v) {
                return v.id === correspondingPaidVariant.id;
              });
              
              if (paidVariant && window.cr_attached_product_variants) {
                var matchingAttachedVariant = window.cr_attached_product_variants.find(function(attachedVariant) {
                  var optionsMatch = true;
                  
                  if (paidVariant.option1 && attachedVariant.option1) {
                    optionsMatch = optionsMatch && (paidVariant.option1 === attachedVariant.option1);
                  }
                  if (paidVariant.option2 && attachedVariant.option2) {
                    optionsMatch = optionsMatch && (paidVariant.option2 === attachedVariant.option2);
                  }
                  if (paidVariant.option3 && attachedVariant.option3) {
                    optionsMatch = optionsMatch && (paidVariant.option3 === attachedVariant.option3);
                  }
                  
                  return optionsMatch && attachedVariant.available;
                });
                
                if (matchingAttachedVariant) {
                  currentAttachedVariantId = matchingAttachedVariant.id;
('✅ FALLBACK - Found matching attached variant:', matchingAttachedVariant.id);
                }
              }
            }
          }
          
          // Add individual attached product with variant-specific properties
          // CRITICAL: Add unique properties to prevent Shopify cart consolidation with paid items
          var uniqueTimestamp = Date.now();
          var uniqueId = uniqueTimestamp + '_attached_' + freeIndex + '_' + Math.random().toString(36).substr(2, 9);
          
          itemsArray.push({
            id: currentAttachedVariantId,
            quantity: 1, // Always 1 per free item
            properties: {
              _attached_product: "true",
              _attached_discount: attachedProductDiscount + "%",
                _source_product_id: cr_product.id.toString(),  // Link to source product
                _source_variant_id: correspondingPaidVariant ? correspondingPaidVariant.id.toString() : "", // Link to specific paid variant
                _attached_for_free_slot: freeIndex.toString(), // Track which free slot this fulfills
                _attached_unique_id: uniqueId, // CRITICAL: Prevents Shopify from consolidating with paid items
                _attached_timestamp: uniqueTimestamp.toString(), // Additional uniqueness
                _user_selected_variant: "true", // Mark this as user-selected, not auto-matched
                _attached_variant_id: currentAttachedVariantId.toString() // Store the specific attached variant ID
              }
          });
          
('📦 Added attached item:', {
            attachedVariantId: currentAttachedVariantId,
            forFreeSlot: freeIndex,
            sourceVariantId: correspondingPaidVariant ? correspondingPaidVariant.id : 'none'
          });
        }
      }
      // --- END ADD ATTACHED PRODUCTS ---
      
      // Check for upsell checkbox ONLY in the selected/qualifying bundle entry
      const selectedBundleEntry = $(".product-set-discounts-entry.selected");
      const upsellCheckbox = selectedBundleEntry.find('input[type="checkbox"][id^="upsell-checkbox"]:checked');
      
      if (upsellCheckbox.length > 0) {
        const upsellVariantId = upsellCheckbox.val();
        if (upsellVariantId) {
          // Get upsell discount from container  
          const upsellContainer = upsellCheckbox.closest('.product-upsell-container');
          const discountType = upsellContainer.attr('data-discount-type') || 'percentage';
          const discountPercentage = upsellContainer.attr('data-discount-percentage') || 0;
          const discountAmount = upsellContainer.attr('data-discount-amount') || 0;
          const discountName = upsellContainer.attr('data-discount-name') || 'Upsell Rabatt';
          
          // Format discount value based on type
          const discountValue = discountType === 'percentage' ? discountPercentage + "%" : discountAmount;
          
          
          // Add upsell from selected tier only
          itemsArray.push({
            id: parseInt(upsellVariantId),
            quantity: 1,
            properties: {
              "_is_upsell": "true",
              "_upsell_discount_type": discountType,
              "_upsell_discount": discountValue,
              "_upsell_name": discountName,
              "_upsell_source_product_id": cr_product.id.toString()
            }
          });
        }
      }
      
      if (itemsArray.length > 0) {
        // Check for existing cart items to consolidate with
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: function(cart) {
            // NO CONSOLIDATION: Keep all items completely separate
            // Each item has unique properties preventing any Shopify cart consolidation
            var consolidatedItems = [];
            var updates = {};
            var hasActualItemsToAdd = false;
            
            itemsArray.forEach(function(newItem) {
              // ENHANCED: NO consolidation for ANY items - keep all separate
              // This prevents paid and attached items from mixing even with same variant ID
              
('➕ Adding item to cart with NO consolidation:', {
                variantId: newItem.id,
                isAttached: !!newItem.properties._attached_product,
                isFree: !!newItem.properties._is_free_item,
                isUpsell: !!newItem.properties._is_upsell,
                uniqueId: newItem.properties._bundle_unique_id || newItem.properties._attached_unique_id,
                paidSlot: newItem.properties._bundle_paid_slot,
                freeSlot: newItem.properties._attached_for_free_slot
              });
              
              // Always add as separate item - unique properties prevent unwanted consolidation
                consolidatedItems.push(newItem);
                hasActualItemsToAdd = true;
            });
            
            // If nothing to add or update, just reload cart
            if (!hasActualItemsToAdd) {
              var $content = $(".cart-drawer-content");
              var hadNoTransition = $content.hasClass("no-transition");
              if (!hadNoTransition) { $content.addClass("no-transition"); }
              reloadCart(function() {
                openCartDrawer();
                hideLoadingIndicator();
                if (!hadNoTransition) { setTimeout(function(){ $content.removeClass("no-transition"); }, 60); }
              });
              return;
            }
            
            // If we have updates, apply them first, then add remaining items
            if (Object.keys(updates).length > 0) {
              $.ajax({
                type: "POST",
                url: "/cart/update.js",
                dataType: "json",
                data: JSON.stringify({ updates: updates }),
                contentType: "application/json",
                success: function() {
                  // Then add remaining new items
                  if (consolidatedItems.length > 0) {
                    addRemainingItems(consolidatedItems);
                  } else {
                    var $content = $(".cart-drawer-content");
                    var hadNoTransition = $content.hasClass("no-transition");
                    if (!hadNoTransition) { $content.addClass("no-transition"); }
                    reloadCart(function() {
                      openCartDrawer();
                      hideLoadingIndicator();
                      if (!hadNoTransition) { setTimeout(function(){ $content.removeClass("no-transition"); }, 60); }
                    });
                  }
                },
                error: function() {
                  // Fallback to adding all items (if any are actually new)
                  if (consolidatedItems.length > 0) {
                    addRemainingItems(consolidatedItems);
              } else {
                var $content = $(".cart-drawer-content");
                var hadNoTransition = $content.hasClass("no-transition");
                if (!hadNoTransition) { $content.addClass("no-transition"); }
                reloadCart(function() {
                  openCartDrawer();
                  hideLoadingIndicator();
                  if (!hadNoTransition) { setTimeout(function(){ $content.removeClass("no-transition"); }, 60); }
                });
              }
            }
        });
      } else {
              // No consolidation needed, add all items
              addRemainingItems(consolidatedItems);
            }
            
            function addRemainingItems(items) {
              if (items.length === 0) {
                var $content = $(".cart-drawer-content");
                var hadNoTransition = $content.hasClass("no-transition");
                if (!hadNoTransition) { $content.addClass("no-transition"); }
                reloadCart(function() {
                  openCartDrawer();
                  hideLoadingIndicator();
                  if (!hadNoTransition) { setTimeout(function(){ $content.removeClass("no-transition"); }, 60); }
                });
                return;
              }
              
        // Already validated above, but double-check
        if (!items || items.length === 0) {
          hideLoadingIndicator();
          return;
        }
        
        var data = {
          form_type: "product",
          items: items
        };
        
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: data,
          success: function () {
            let hasBundleItems = false;
            items.forEach(function(item) {
              if (item.properties && (item.properties._bundle_configs || item.properties._custom_price)) {
                hasBundleItems = true;
              }
            });
            
            if (hasBundleItems) {
              optimizeBundleTiers(function() {
                reloadCart(function() {
                  openCartDrawer();
                  hideLoadingIndicator();
                });
              });
            } else {
              reloadCart(function() {
                openCartDrawer();
                hideLoadingIndicator();
              });
            }
          },
          error: function (xhr) {
            hideLoadingIndicator();
          }
        });
        }
        },
          error: function() {
            // Fallback to original logic if we have items
            if (itemsArray.length > 0) {
              var data = {
                form_type: "product",
                items: itemsArray
              };
              
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: data,
                success: function () {
                  reloadCart(function () {
                    openCartDrawer();
                    hideLoadingIndicator();
                  });
                },
                error: function (xhr) {
                  hideLoadingIndicator();
                }
              });
            } else {
              hideLoadingIndicator();
            }
          }
        });
      } else {
        hideLoadingIndicator();
      }
      return; // Always return after bundle logic
    } else {
      // --- This is the standard product logic ---
      var data = $(this).serialize();

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: data,
        success: function () {
          reloadCart(function () {
            openCartDrawer();
            hideLoadingIndicator();
          });
        },
        error: function () {
            hideLoadingIndicator();
        },
      });
    }
  });

  // Scroll to form button.
  $(containerId + ".product-information-scroll-to-form").click(
    productScrollToCartButton
  );

  // Sticky add to cart button.
  if ($("#sticky-add-to-cart").length > 0) {
    // Handle position
    if ($("#sticky-add-to-cart").attr("data-position") == "top") {
      var top = 0;

      if (
        $("#shopify-section-header-menu")
          .css("--header-position")
          .includes("fixed") &&
        window.screen.width > 767
      ) {
        top = $("#header").outerHeight();
      }

      $("#sticky-add-to-cart").css({
        bottom: "initial",
        top: top,
      });
    }

    // Handle scroll.
    setTimeout(function () {
      var scrollTopCartButton = 0;

      if ($("#product-information-cart-button").length > 0) {
        scrollTopCartButton = $("#product-information-cart-button").offset()
          .top;
      }

      $(window).scroll(function () {
        if ($(this).scrollTop() > scrollTopCartButton) {
          $("#sticky-add-to-cart").show();
        } else {
          $("#sticky-add-to-cart").hide();
        }
      });
    }, 100);

    // Handle selection / inventory.
    $("#sticky-add-to-cart select").change(function () {
      var options = [];
      $("#sticky-add-to-cart select").each(function () {
        options.push({
          key:
            "option" + (cr_product.options.indexOf($(this).attr("name")) + 1),
          value: $(this).val(),
        });
      });

      var variant = window.cr_product.variants.find(function (variant) {
        return options.every(function (values) {
          return variant[values.key] === values.value;
        });
      });

      if (!variant) {
        return;
      }

      // Handle sold out.
      if (
        window.cr_variantStock.hasOwnProperty(variant.id) &&
        window.cr_variantStock[variant.id] == 0
      ) {
        $("#sticky-add-to-cart .btn").attr("disabled", true);
      } else {
        $("#sticky-add-to-cart .btn").removeAttr("disabled");
      }
    });

    // Setup click
    $("#sticky-add-to-cart form").submit(function (event) {
      event.preventDefault();

      if ($("#sticky-add-to-cart .btn").attr("disabled")) {
        return;
      }

      var options = [];
      $("#sticky-add-to-cart select").each(function () {
        options.push({
          key:
            "option" + (cr_product.options.indexOf($(this).attr("name")) + 1),
          value: $(this).val(),
        });
      });

      var variant = window.cr_product.variants.find(function (variant) {
        return options.every(function (values) {
          return variant[values.key] === values.value;
        });
      });

      if (variant) {
        $(this).find('input[name="id"]').val(variant.id);
      }

      showLoadingIndicator();

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $(this).serialize(),
        success: function () {
          reloadCart(function () {
            openCartDrawer();
            hideLoadingIndicator();
          });
        },
        error: function (response) {
          hideLoadingIndicator();

          if (
            response &&
            response.responseJSON &&
            response.responseJSON.description
          ) {
            alert(
              response.responseJSON.message +
                "\n\n" +
                response.responseJSON.description
            );
          } else {
            if (isGermanShop()) {
              alert(
                "Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal."
              );
            } else {
              alert("An error has occurred. Please try again.");
            }
          }
        },
      });
    });
  }
  // OLAF MODIFIKATION FÜR AUFKLAPPBARE PRODUKT SETS
  // Volume discount.
  $(".product-set-discounts-entry").click(function (e) {
    if ($(this).hasClass("selected")) {
      return;
    }

    var container = $(this).closest(".product-set-discounts");
    var hideSelectedContent = container.data("hide-selected-content") === true || 
                             container.data("hide-selected-content") === "true";
    var showUpsellWhenHidden = container.data("show-upsell-when-hidden") === true ||
                               container.data("show-upsell-when-hidden") === "true";

    // Check if content should be hidden when selected AND upsell should also be hidden
    if (hideSelectedContent && !showUpsellWhenHidden) {
      // Don't expand anything - both content and upsell should be hidden
      return;
    }

    // Force clear any accumulated animation states to prevent slowdown
    $(".product-upsell-container").each(function() {
      $(this)[0].style.animation = 'none';
      $(this)[0].style.transition = 'none';
      // Force reflow to clear any stuck animations
      $(this)[0].offsetHeight;
      $(this)[0].style.transition = '';
    });
    
    // Remove selected class from all entries (CSS will slide them up)
    $(".product-set-discounts-entry").removeClass("selected");
    
    // Add selected class to clicked entry (CSS will slide it down)
    $(this).addClass("selected");
    
    var content = $(this).find(".product-set-discounts-entry-content");

    // Fix visual issue with out-of-stock message - but only if content should be visible
    if (!hideSelectedContent) {
      $(this)
        .find(".product-set-discounts-entry-content-product-body-out-of-stock")
        .css("overflow", "visible")
        .css("height", "auto")
        .css("min-height", "20px")
        .css("white-space", "nowrap")
        .css("position", "relative")
        .css("z-index", "10")
        .css("padding-top", "3px")
        .css("padding-bottom", "3px")
        .find("div")
        .css("white-space", "nowrap")
        .css("overflow", "visible")
        .css("padding-right", "5px");
    }

    // Immediate updates - no timeouts to avoid accumulation
    var clickedEntry = $(this);
    
    // Handle upsell movement immediately if CSS isn't handling it
    if (!hideSelectedContent) {
      $(".product-set-discounts-entry").removeClass("upsell-active");
      clickedEntry.addClass("upsell-active");
      
      // Only move if upsell isn't already in the right place
      var existingUpsell = clickedEntry.find(".product-upsell-container");
      if (existingUpsell.length === 0) {
        var allUpsells = $(".product-upsell-container");
        if (allUpsells.length > 0) {
          var primaryUpsell = allUpsells.first().detach();
          var contentArea = clickedEntry.find(".product-set-discounts-entry-content");
          if (contentArea.length) {
            contentArea.append(primaryUpsell.show());
          } else {
            clickedEntry.append(primaryUpsell.show());
          }
        }
      }
    }

    // Process updates without nested timeouts
    if (!hideSelectedContent) {
      // Delay updates to match slower CSS animations (0.6s)
      setTimeout(function() {
        content.find("select").first().trigger("change");
        
        // Update cart button
        if (!$("#product-information-cart-button").attr("disabled")) {
          $("#product-information-cart-button span").text(
            $("#product-information-cart-button").attr("data-text-normal")
          );
        }
      }, 600);
    }
  });

  // IMMEDIATE HIDE - Force hide bundle content if setting is enabled
  $(".product-set-discounts[data-hide-selected-content='true']").each(function() {
    $(this).find(".product-set-discounts-entry-content-product").each(function() {
      this.style.setProperty("display", "none", "important");
      this.style.setProperty("visibility", "hidden", "important");
      this.style.setProperty("opacity", "0", "important");
      this.style.setProperty("position", "absolute", "important");
      this.style.setProperty("left", "-9999px", "important");
      this.style.setProperty("top", "-9999px", "important");
      this.style.setProperty("z-index", "-1000", "important");
      this.style.setProperty("height", "0px", "important");
      this.style.setProperty("width", "0px", "important");
    });
  });


  // Set / volume discount.
  if ($(".product-set-discounts").length > 0) {
    // Function to ensure out-of-stock messages are properly styled
    function fixOutOfStockDisplay() {
      $(".product-set-discounts-entry-content-product-body-out-of-stock").each(
        function () {
          $(this)
            .css("overflow", "visible")
            .css("height", "auto")
            .css("min-height", "20px")
            .css("white-space", "nowrap")
            .css("position", "absolute")
            .css("z-index", "10")
            .css("padding-top", "3px")
            .css("padding-bottom", "3px")
            .find("div")
            .css("overflow", "visible")
            .css("white-space", "nowrap")
            .css("padding-right", "5px")
            .css("font-size", "0.95em")
            .css("height", "auto")
            .css("min-height", "16px");

          // Force consistent layout
          var parent = $(this).parent();
          parent.css("position", "relative");
          parent.css("min-height", "80px");
        }
      );
    }

    // Initial fix for the display
    fixOutOfStockDisplay();

    // Fix display when select options change
    $(".product-set-discounts-entry-content-product-body-select select").change(
      function () {
        var changedSelect = $(this);
        var changedOptionName = changedSelect.attr("name");
        var changedValue = changedSelect.val();
        var bundleEntry = changedSelect.closest(".product-set-discounts-entry");
        
        // INDEPENDENT COLOR SELECTION: Only sync attached products with FREE item changes
        var changedProductDiv = changedSelect.closest(".product-set-discounts-entry-content-product");
        var productIndex = bundleEntry.find(".product-set-discounts-entry-content-product").index(changedProductDiv);
        var totalProducts = bundleEntry.find(".product-set-discounts-entry-content-product").length;
        var freeProductCount = parseInt(bundleEntry.attr("data-free-product-count")) || 0;
        var nonFreeProductCount = totalProducts - freeProductCount; // Attached products replace free items, don't add to count
        
        // Check if this is a FREE item being changed
        var isFreeItem = productIndex >= nonFreeProductCount && productIndex < (nonFreeProductCount + freeProductCount);
        
        
        // NEW APPROACH: Store individual free item colors (not just last one)
        if (isFreeItem) {
          // Calculate which free item this is (1st, 2nd, etc.)
          var freeItemIndex = productIndex - nonFreeProductCount + 1; // 1-based index
          var attachedColorKey = "attached_" + changedOptionName + "_" + freeItemIndex;
          bundleEntry.attr("data-" + attachedColorKey.toLowerCase(), changedValue);
          
          // Also sync any existing attached product selects (if they exist)
          var associatedSelectName = "associated_" + changedOptionName;
          
          var foundSelects = bundleEntry.find("select[name='" + associatedSelectName + "']");
          
          foundSelects.each(function() {
            var attachedSelect = $(this);
            var hasMatchingOption = false;
            
            attachedSelect.find("option").each(function() {
              if ($(this).val() === changedValue) {
                hasMatchingOption = true;
                return false;
              }
            });
            
            if (hasMatchingOption) {
              attachedSelect.val(changedValue);
            }
          });
        }
        
        var options = [];
        $(this)
          .parent()
          .find("select")
          .each(function () {
            options.push({
              key:
                "option" +
                (cr_product.options.indexOf($(this).attr("name")) + 1),
              value: $(this).val(),
            });
          });

        var variant = cr_product.variants.find(function (variant) {
          return options.every(function (values) {
            return variant[values.key] === values.value;
          });
        });

        if (!variant) {
          return;
        }

        // Update image.
        if (variant.featured_image && variant.featured_image.src) {
          $(this)
            .parents(".product-set-discounts-entry-content-product")
            .find("img")
            .attr("src", variant.featured_image.src)
            .removeAttr("data-srcset")
            .removeAttr("srcset");
        }

        // Update price.
        var data = $(this).parents(".product-set-discounts-entry").data();
        var compareAtPrice = Math.trunc(
          variant.price * parseFloat(data.discount)
        );

        // Check for custom pricing first
        var entryElement = $(this).parents(".product-set-discounts-entry");
        var customItemPrice = entryElement.attr("data-item-price");
        var customItemComparePrice = entryElement.attr(
          "data-item-compare-price"
        );

        var realPrice;
        var useCustomPricing = false;

        if (customItemPrice && customItemPrice !== "") {
          // Use custom item pricing - this should be the main selling price
          var itemPriceValue = customItemPrice.replace(",", ".");
          // If the value is already in cents (like 2990), use it directly
          // If it's in euros (like 29.90), convert to cents
          if (itemPriceValue.includes(".")) {
            compareAtPrice = parseFloat(itemPriceValue) * 100;
          } else {
            compareAtPrice = parseInt(itemPriceValue); // Already in cents
          }
          useCustomPricing = true;
        }

        if (customItemComparePrice && customItemComparePrice !== "") {
          // Use custom item compare pricing - this should be the strikethrough price
          var itemComparePriceValue = customItemComparePrice.replace(",", ".");
          // If the value is already in cents (like 2990), use it directly
          // If it's in euros (like 29.90), convert to cents
          if (itemComparePriceValue.includes(".")) {
            realPrice = parseFloat(itemComparePriceValue) * 100;
          } else {
            realPrice = parseInt(itemComparePriceValue); // Already in cents
          }
          useCustomPricing = true;
        }

        // Only use hardcoded prices if no custom pricing is set
        if (!useCustomPricing) {
          // OLAF MODIFIKATION REAL PRIICE GIBTS SONST NICHT
          var productTitel = $("h1").text().trim();
          var productName = $(this)
            .closest(".product-set-discounts-entry")
            .find(".product-set-discounts-entry-header-name label")
            .text()
            .trim();
          if (
            productName == "1 + 1 Gratis Stoffwindeln" &&
            productTitel == "Berger - Stoffwindel"
          ) {
            compareAtPrice = 2990;
            realPrice = 4990;
          } else if (
            productName == "3 + 3 Gratis Stoffwindeln" &&
            productTitel == "Berger - Stoffwindel"
          ) {
            compareAtPrice = 2990;
            realPrice = 4990;
          } else if (
            productName == "1 x Sockenschuhe" &&
            productTitel == "Berger - Sockenschuhe"
          ) {
            compareAtPrice = 3990;
            realPrice = 4990;
          } else if (
            productName == "1 + 1 Gratis Sockenschuhe" &&
            productTitel == "Berger - Sockenschuhe"
          ) {
            compareAtPrice = 3990;
            realPrice = 4990;
          } else if (
            productName == "1x Sommer Sockenschuhe" &&
            productTitel == "Berger - Sommer Sockenschuhe"
          ) {
            compareAtPrice = 3490;
            realPrice = 4990;
          } else if (
            productName == "1 + 1 Gratis Sockenschuhe" &&
            productTitel == "Berger - Sommer Sockenschuhe"
          ) {
            compareAtPrice = 3490;
            realPrice = 4990;
          } else if (
            productName == "2 + 1 Gratis Zauber Bleistifte" &&
            productTitel == "Berger - Zauber Bleistift"
          ) {
            compareAtPrice = 2990;
            realPrice = 4990;
          } else if (
            productName == "3 + 3 Gratis Zauber Bleistifte" &&
            productTitel == "Berger - Zauber Bleistift"
          ) {
            compareAtPrice = 4990;
            realPrice = 7485;
          } else if (
            productName == "5x Stoffwindel Einlagen" &&
            productTitel == "Berger - Stoffwindel Einlagen"
          ) {
            compareAtPrice = 1995;
            realPrice = 2995;
          } else if (
            productName == "10x Stoffwindel Einlagen" &&
            productTitel == "Berger - Stoffwindel Einlagen"
          ) {
            compareAtPrice = 2990;
            realPrice = 4485;
          } else {
            realPrice = Math.trunc(
              variant.price * parseFloat(data.discount) * parseFloat(1.5)
            );
          }
        } // Close the if (!useCustomPricing) block

        PriceFormatter.showPriceByElement(
          $(this)
            .parents(".product-set-discounts-entry-content-product-body")
            .find("h4"),
          compareAtPrice,
          realPrice
        );

        // Update total.
        var total = 0;
        var totalCompare = 0;

        // Check for custom bundle pricing first
        var bundleElement = $(this).parents(".product-set-discounts-entry");
        var customBundlePrice = bundleElement.attr("data-custom-price");
        var customBundleComparePrice = bundleElement.attr(
          "data-custom-compare-price"
        );

        if (customBundlePrice && customBundlePrice !== "") {
          var bundlePriceValue = customBundlePrice.replace(",", ".");
          // If the value is already in cents (like 10100), use it directly
          // If it's in euros (like 101.00), convert to cents
          if (bundlePriceValue.includes(".")) {
            totalCompare = parseFloat(bundlePriceValue) * 100;
          } else {
            totalCompare = parseInt(bundlePriceValue); // Already in cents
          }
        }

        if (customBundleComparePrice && customBundleComparePrice !== "") {
          var bundleComparePriceValue = customBundleComparePrice.replace(
            ",",
            "."
          );
          // If the value is already in cents (like 2000), use it directly
          // If it's in euros (like 20.00), convert to cents
          if (bundleComparePriceValue.includes(".")) {
            total = parseFloat(bundleComparePriceValue) * 100;
          } else {
            total = parseInt(bundleComparePriceValue); // Already in cents
          }
        }

        // Only calculate totals from individual items if no custom bundle pricing is set
        if (
          (!customBundlePrice || customBundlePrice === "") &&
          (!customBundleComparePrice || customBundleComparePrice === "")
        ) {
          // OLAF MODIFY
          $(this)
            .parents(".product-set-discounts-entry-content")
            .find("span.price")
            .each(function () {
              var productCount = parseInt(
                $(this)
                  .closest(".product-set-discounts-entry")
                  .attr("data-product-count")
              );

              var price = parseInt($(this).find("span").attr("data-price"));
              var comparePrice = parseInt(
                $(this).find("s").attr("data-compare-price")
              );

              var productTitel = $("h1").text().trim();

              var productName = $(this)
                .closest(".product-set-discounts-entry")
                .find(".product-set-discounts-entry-header-name label")
                .text()
                .trim();
              if (
                productName == "1 + 1 Gratis Stoffwindeln" &&
                productTitel == "Berger - Stoffwindel"
              ) {
                totalCompare = 2990;
                comparePrice = 4990;
              } else if (
                productName == "3 + 3 Gratis Stoffwindeln" &&
                productTitel == "Berger - Stoffwindel"
              ) {
                totalCompare = 4990;
                comparePrice = 7485;
              } else if (
                productName == "1 x Sockenschuhe" &&
                productTitel == "Berger - Sockenschuhe"
              ) {
                totalCompare = 3990;
                comparePrice = 4990;
              } else if (
                productName == "1 + 1 Gratis Sockenschuhe" &&
                productTitel == "Berger - Sockenschuhe"
              ) {
                totalCompare = 3990;
                comparePrice = 9980;
              } else if (
                productName == "2 + 2 Gratis Sockenschuhe" &&
                productTitel == "Berger - Sockenschuhe"
              ) {
                totalCompare = 4990;
                comparePrice = 7485;
              } else if (
                productName == "1x Sommer Sockenschuhe" &&
                productTitel == "Berger - Sommer Sockenschuhe"
              ) {
                totalCompare = 3490;
                comparePrice = 4990;
              } else if (
                productName == "1 + 1 Gratis Sockenschuhe" &&
                productTitel == "Berger - Sommer Sockenschuhe"
              ) {
                totalCompare = 3490;
                comparePrice = 4990;
              } else if (
                productName == "2 + 1 Gratis Zauber Bleistifte" &&
                productTitel == "Berger - Zauber Bleistift"
              ) {
                totalCompare = 2990;
                comparePrice = 4990;
              } else if (
                productName == "3 + 3 Gratis Zauber Bleistifte" &&
                productTitel == "Berger - Zauber Bleistift"
              ) {
                totalCompare = 4990;
                comparePrice = 7485;
              } else if (
                productName == "5x Stoffwindel Einlagen" &&
                productTitel == "Berger - Stoffwindel Einlagen"
              ) {
                totalCompare = 1995;
                comparePrice = 2995;
              } else if (
                productName == "10x Stoffwindel Einlagen" &&
                productTitel == "Berger - Stoffwindel Einlagen"
              ) {
                totalCompare = 2990;
                comparePrice = 4485;
              } else {
                totalCompare += price * productCount;
              }

              total = comparePrice;
            });
        } // Close the custom bundle pricing conditional

        PriceFormatter.showPriceByElement(
          $(this)
            .parents(".product-set-discounts-entry")
            .find(".product-set-discounts-entry-header"),
          totalCompare,
          total
        );

        // Handle sold out.
        if (
          cr_variantStock.hasOwnProperty(variant.id) &&
          cr_variantStock[variant.id] == 0
        ) {
          var outOfStockElement = $(this)
            .parents(".product-set-discounts-entry-content-product-body")
            .find(
              ".product-set-discounts-entry-content-product-body-out-of-stock"
            );

          outOfStockElement
            .css("display", "flex")
            .css("overflow", "visible")
            .css("height", "auto")
            .css("min-height", "20px")
            .css("position", "absolute")
            .css("left", "0")
            .css("white-space", "nowrap")
            .css("z-index", "10")
            .css("padding-top", "3px")
            .css("padding-bottom", "3px");

          outOfStockElement
            .find("div")
            .css("white-space", "nowrap")
            .css("overflow", "visible")
            .css("padding-right", "5px");

          // Ensure parent has correct positioning
          var parent = outOfStockElement.parent();
          parent.css("position", "relative");
          parent.css("min-height", "80px");

          $("#product-information-cart-button").attr("disabled", true);
          $("#product-information-cart-button span").text(
            $("#product-information-cart-button").attr("data-text-disabled")
          );

          // Apply fix after displaying the out-of-stock message
          setTimeout(fixOutOfStockDisplay, 10);
        } else {
          $(this)
            .parents(".product-set-discounts-entry-content-product-body")
            .find(
              ".product-set-discounts-entry-content-product-body-out-of-stock"
            )
            .css("display", "none");

          var displays = [];
          $(this)
            .parents(".product-set-discounts-entry-content")
            .find(
              ".product-set-discounts-entry-content-product-body-out-of-stock"
            )
            .each(function () {
              displays.push($(this).css("display"));
            });

          if (!displays.includes("flex")) {
            $("#product-information-cart-button").removeAttr("disabled");
            $("#product-information-cart-button span").text(
              $("#product-information-cart-button").attr("data-text-normal")
            );

            // Make sure id value is set correctly for the selected variant
            if (variant.id) {
              $('#product-add-to-cart-form input[name="id"]').val(variant.id);
            }
          }
        }
      }
    );

    // Initial update for selected set discount entry
    $(".product-set-discounts-entry.selected").each(function () {
      var parentContainer = $(this).closest(".product-set-discounts");
      var hideSelectedContent = parentContainer.data("hide-selected-content") === true || 
                               parentContainer.data("hide-selected-content") === "true";

      // Don't apply styling if content should be hidden
      if (!hideSelectedContent) {
        var outOfStockItems = $(this)
          .find(".product-set-discounts-entry-content-product-body-out-of-stock")
          .filter(function () {
            return $(this).css("display") === "flex";
          });

        // If no out of stock items in the selected set, ensure button is enabled and shows normal text
        if (outOfStockItems.length === 0) {
          $("#product-information-cart-button").removeAttr("disabled");
          $("#product-information-cart-button span").text(
            $("#product-information-cart-button").attr("data-text-normal")
          );
        }
      }
    });

    $(".product-set-discounts-entry select").change();
  }

  // Select field.
  $(".product-select-options span").click(function () {
    $(this).parent().find("span").removeClass("selected");
    $(this).addClass("selected");

    $(this).parents(".product-select").find("select").val($(this).text());
    $(this).parents(".product-select").find("label span").text($(this).text());
  });

  $(".product-select-options span:first-child").click();

  $(".product-select.button_box label").click(function () {
    var options = $(this).parent().find(".product-select-options");

    if (options.css("display") == "flex") {
      options.css("display", "none");
      $(this).find("svg").css("rotate", "0deg");
    } else {
      options.css("display", "flex");
      $(this).find("svg").css("rotate", "90deg");
    }
  });

  // Desktop images scrolling.
  if (
    $(document).width() > 768 &&
    $(".product-media").length > 0 &&
    $(containerId + ".product-media-main").attr("data-desktop-media-fixed") ==
      "true"
  ) {
    var productDataHeight = $("#product-add-to-cart-form").height();
    var productMedia = $(".product-media");
    var productMediaOffsetTop = productMedia[0].offsetTop;
    var productMediaHeight = productMedia.height();

    $(window).scroll(function () {
      var diff = Math.min(
        $(window).scrollTop() - productMediaOffsetTop,
        productDataHeight - productMediaHeight
      );

      if (diff > 0) {
        productMedia.css("margin-top", diff + "px");
      } else {
        productMedia.css("margin-top", "0px");
      }
    });
  }

  // Page button.
  $(".product-page-button").click(function () {
    var url = $(this).attr("data-page-url").trim();
    if (url) {
      var popup = $(".product-page-button-popup");
      popup.find("iframe").remove();
      popup.append('<iframe src="' + url + '"></iframe>');

      $(".product-page-button-overlay").show();
    }
  });

  $(".product-page-button-overlay, .product-page-button-overlay svg").click(
    function () {
      $(".product-page-button-overlay").hide();
    }
  );

  var hasSizeVariant = false;
  if (window.cr_product && window.cr_product.options) {
    hasSizeVariant = window.cr_product.options.some(function (option) {
      return (
        option.toLowerCase().includes("size") ||
        option.toLowerCase().includes("größe")
      );
    });
  }

  if (
    hasSizeVariant &&
    $("#product-information-cart-button").attr("disabled")
  ) {
    var anyAvailable = false;

    if (window.cr_variantStock) {
      for (var variantId in window.cr_variantStock) {
        if (window.cr_variantStock[variantId] > 0) {
          anyAvailable = true;
          break;
        }
      }
    }

    if (anyAvailable) {
      $("#product-information-cart-button").removeAttr("disabled");
      $(".product-information-quantity").css("opacity", "1");
      $("#product-information-cart-button span").text(
        $("#product-information-cart-button").attr("data-text-normal")
      );
    }
  }
}

function productScrollToCartButton() {
  var scrollTop = 0;

  if ($("#product-information-cart-button").length > 0) {
    scrollTop =
      $("#product-information-cart-button").offset().top -
      window.screen.height / 2;
  }

  $("html, body").animate(
    {
      scrollTop: scrollTop,
    },
    500
  );
}

function setupSelectedVariant(isInitExecution) {
  var options = [];
  $(".product-variant-select").each(function () {
    options.push({
      key: "option" + (cr_product.options.indexOf($(this).attr("name")) + 1),
      value: $(this).val(),
    });
  });

  $(".product-information-variant-picker-button-variant-option").removeClass(
    "product-information-variant-picker-button-variant-option-checked"
  );
  $(".product-variant-radio:checked").each(function () {
    $(this)
      .parent()
      .addClass(
        "product-information-variant-picker-button-variant-option-checked"
      );

    var span = $(this)
      .parents(".product-information-variant-picker-button-variant")
      .find("label span:eq(1)");
    if (span.attr("data-color-swatch") == "true") {
      span.html(
        $(this).val() +
          '<span class="color-swatch" style="background-color: ' +
          $(this).next().css("background-color") +
          ';"></span>'
      );
    } else {
      span.html($(this).val());
    }

    options.push({
      key: "option" + (cr_product.options.indexOf($(this).attr("name")) + 1),
      value: $(this).val(),
    });
  });

  var selectedVariant = cr_product.variants.find(function (variant) {
    return options.every(function (values) {
      return variant[values.key] === values.value;
    });
  });

  // Check if this is a 1+1 bundle product by looking for size options
  var isBundle = cr_product.options.some(function (option) {
    return (
      option.toLowerCase().includes("size") ||
      option.toLowerCase().includes("größe")
    );
  });

  // Disabled atc button when variant not exists.
  if (!selectedVariant) {
    $("#product-information-cart-button").attr("disabled", true);
    $(".product-information-quantity").css("opacity", "0.4");
    $("#product-information-cart-button span").text(
      $("#product-information-cart-button").attr("data-text-disabled")
    );

    return;
  }

  $('#product-add-to-cart-form input[name="id"]').val(selectedVariant.id);

  // Handle inventory.
  $("#product-information-cart-button").removeAttr("disabled");
  $(".product-information-quantity").css("opacity", "1");
  $("#product-information-cart-button span").text(
    $("#product-information-cart-button").attr("data-text-normal")
  );

  if (cr_variantStock.hasOwnProperty(selectedVariant.id)) {
    $('.product-information-quantity button[name="plus"]').attr(
      "data-stock",
      cr_variantStock[selectedVariant.id]
    );

    var input = $(".product-information-quantity-field");
    var value = parseInt(input.val());
    if (value > cr_variantStock[selectedVariant.id]) {
      value = cr_variantStock[selectedVariant.id];
    } else if (value == 0 && cr_variantStock[selectedVariant.id] > 0) {
      value = 1;
    }
    input.val(value);

    $(".product-information-quantity").each(function () {
      $(this).find(".product-information-quantity-input").text(value);

      if (value < 2) {
        $(this)
          .find('button[name="minus"] svg path')
          .css("stroke", "var(--color-border)");
      } else {
        $(this)
          .find('button[name="minus"] svg path')
          .css("stroke", "var(--color-text)");
      }

      // Disable button only if we truly have zero inventory or we don't have a bundle
      if (
        value == 0 &&
        (!isBundle || cr_variantStock[selectedVariant.id] == 0)
      ) {
        $("#product-information-cart-button").attr("disabled", true);
        $(".product-information-quantity").css("opacity", "0.4");
        $("#product-information-cart-button span").text(
          $("#product-information-cart-button").attr("data-text-disabled")
        );
      } else {
        // Ensure the button text is set to normal when product is available
        $("#product-information-cart-button span").text(
          $("#product-information-cart-button").attr("data-text-normal")
        );
      }
    });

    // Disable button only if we truly have zero inventory or we don't have a bundle
    if (
      $(".product-information-quantity").length == 0 &&
      value == 0 &&
      (!isBundle || cr_variantStock[selectedVariant.id] == 0)
    ) {
      $("#product-information-cart-button").attr("disabled", true);
      $(".product-information-quantity").css("opacity", "0.4");
      $("#product-information-cart-button span").text(
        $("#product-information-cart-button").attr("data-text-disabled")
      );
    } else if ($(".product-information-quantity").length == 0) {
      // Ensure the button text is set to normal when product is available
      $("#product-information-cart-button span").text(
        $("#product-information-cart-button").attr("data-text-normal")
      );
    }
  } else {
    $('.product-information-quantity button[name="plus"]').removeAttr(
      "data-stock"
    );

    $(".product-information-quantity").each(function () {
      var input = $(".product-information-quantity-field");
      var value = parseInt(input.val());
      if (value != 0) {
        return;
      }

      value = 1;

      $(".product-information-quantity-input").text(value);
      input.val(value);

      $('button[name="minus"] svg path').css("stroke", "var(--color-border)");
    });

    // Ensure the button text is set to normal for products without inventory tracking
    $("#product-information-cart-button span").text(
      $("#product-information-cart-button").attr("data-text-normal")
    );
  }

  // Show weight.
  if (
    $(".product-weight").length > 0 &&
    cr_productWeight &&
    cr_productWeight[selectedVariant.id]
  ) {
    $(".product-weight-value").html(cr_productWeight[selectedVariant.id]);
  }

  // Show price.
  PriceFormatter.showPrice(
    ".product-information-price",
    selectedVariant.price,
    selectedVariant.compare_at_price
  );

  if (
    !isInitExecution &&
    selectedVariant.featured_image &&
    selectedVariant.featured_image.position &&
    $(".variant-picker").data("selectVariantImage")
  ) {
    window.mainSwiper.slideTo(selectedVariant.featured_image.position - 1);
  }

  // Show unit price.
  if ($(".product-information-unit-price").length > 0) {
    if (selectedVariant.unit_price_measurement) {
      $(".product-information-unit-price").show();

      PriceFormatter.showPrice(
        ".product-information-unit-price-price",
        selectedVariant.unit_price
      );
      $(".product-information-unit-price-unit").text(
        selectedVariant.unit_price_measurement.reference_value +
          "" +
          selectedVariant.unit_price_measurement.reference_unit
      );
    } else {
      $(".product-information-unit-price").hide();
    }
  }

  // Handle price discount badge.
  if ($(".product-information-price-saved").length == 0) {
    return;
  }

  // Check if custom pricing is enabled
  var customPriceContainer = $(".product-information-price")
    .find("div")
    .first();
  var isCustomPrice =
    customPriceContainer.find("span[style*='color: #dd1d1d']").length > 0;

  if (isCustomPrice) {
    // Custom pricing is active, don't override the Liquid template logic
    return;
  }

  if (selectedVariant.compare_at_price > selectedVariant.price) {
    $(".product-information-price-saved").show();
  } else {
    $(".product-information-price-saved").hide();
  }

  if ($(".product-information-price-saved").attr("data-type") == "percentage") {
    var value =
      ((selectedVariant.compare_at_price - selectedVariant.price) * 100) /
      selectedVariant.compare_at_price;
    $(".product-information-price-saved span").html(Math.ceil(value) + "%");
  } else {
    var savings = selectedVariant.compare_at_price - selectedVariant.price;
    PriceFormatter.showPrice(".product-information-price-saved span", savings);
  }

  // Final check to ensure button text matches state
  if (!$("#product-information-cart-button").attr("disabled")) {
    $("#product-information-cart-button span").text(
      $("#product-information-cart-button").attr("data-text-normal")
    );
  } else {
    $("#product-information-cart-button span").text(
      $("#product-information-cart-button").attr("data-text-disabled")
    );
  }
}

/* ==================================== */
/* =============== CART =============== */
/* ==================================== */

function initCart() {
  // Helpers live inside initCart to ensure availability after re-renders

  // Placeholder for optimistic quantity/update/remove in future phases
  function cartDrawerOptimisticUpdate(type, payload){
    try {
      if (type === 'qty' && payload && payload.el && typeof payload.toQty !== 'undefined') {
        optimisticSetQtyUI(payload.el, payload.toQty);
      }
      if (type === 'remove' && payload && payload.el) {
        optimisticRemoveHint(payload.el);
      }
    } catch(e) {}
  }

  function optimisticSetQtyUI(el, toQty){
    try {
      var $el = $(el);
      var lineIndex = $el.attr('data-line-index');
      var $input = $("#cart-drawer-item-quantity-input-" + lineIndex);
      if ($input.length) {
        $input.val(toQty);
        $input.addClass('pulse');
        setTimeout(function(){ $input.removeClass('pulse'); }, 220);
      }
    } catch(e) {}
  }
  function optimisticRemoveHint(el){
    try {
      var $el = $(el);
      $el.css('transition','opacity .18s ease, transform .18s ease');
      $el.css({ opacity: .5, transform: 'scale(0.98)' });
      setTimeout(function(){ $el.css({ opacity: '', transform: '', transition: '' }); }, 220);
    } catch(e) {}
  }
  function setCartItemLoading(lineIndex, isLoading){
    try {
      var $el = $(".cart-drawer-content .cart-drawer-item[data-line-index='" + lineIndex + "']");
      if ($el.length) { $el.toggleClass('is-loading', !!isLoading); }
    } catch(e) {}
  }
  function setCartItemLoadingByKey(lineKey, isLoading){
    try {
      if (!lineKey) return;
      var $el = $(".cart-drawer-content .cart-drawer-item[data-line-key='" + lineKey + "']");
      if ($el.length) { $el.toggleClass('is-loading', !!isLoading); }
    } catch(e) {}
  }
  function setCartItemLoadingEl(triggerEl, isLoading){
    try {
      var $item = $(triggerEl).closest('.cart-drawer-item');
      if ($item.length) { $item.toggleClass('is-loading', !!isLoading); }
    } catch(e) {}
  }
  function setVariantLoading(variantId, isLoading){
    try {
      // Deprecated: do not toggle variant-wide; callers should prefer setCartItemLoading or setCartItemLoadingEl
    } catch(e) {}
  }
  function animateCollapseLineByIndex(lineIndex){
    try {
      var $el = $(".cart-drawer-content .cart-drawer-item[data-line-index='" + lineIndex + "']");
      if (!$el.length) return;
      var h = $el.outerHeight();
      $el.css({ overflow: 'hidden', height: h + 'px' });
      requestAnimationFrame(function(){
        $el.css({ transition: 'height .22s ease, opacity .18s ease', height: '0px', opacity: .0 });
      });
    } catch(e) {}
  }
  function animateCollapseVariantLines(variantId){
    try {
      var $els = $(".cart-drawer-content .cart-drawer-item[data-variant-id='" + variantId + "']");
      $els.each(function(){
        var $el = $(this);
        var h = $el.outerHeight();
        $el.css({ overflow: 'hidden', height: h + 'px' });
        requestAnimationFrame(function(){
          $el.css({ transition: 'height .22s ease, opacity .18s ease', height: '0px', opacity: .0 });
        });
      });
    } catch(e) {}
  }
  try {
    window.animateCollapseLineByIndex = animateCollapseLineByIndex;
    window.animateCollapseVariantLines = animateCollapseVariantLines;
    window.setCartItemLoading = setCartItemLoading;
    window.setVariantLoading = setVariantLoading;
    window.cartDrawerOptimisticUpdate = cartDrawerOptimisticUpdate;
  } catch(e) {}
  // Change line item.
  $(".cart-drawer-content").on(
    "click",
    ".cart-drawer-item-quantity-minus",
    function () {
      var lineIndex = $(this).attr("data-line-index");
      try { setCartItemLoadingEl(this, true); } catch(e) {}
      var input = $("#cart-drawer-item-quantity-input-" + lineIndex);
      var cartItem = $(this).closest(".cart-drawer-item");
      var itemType = cartItem.attr("data-item-type");
      var variantId = cartItem.attr("data-variant-id");
      try { optimisticSetQtyUI(cartItem[0], Math.max(0, parseInt(input.val()) - 1)); } catch(e) {}
      
('MINUS BUTTON CLICKED - lineIndex:', lineIndex, 'itemType:', itemType, 'variantId:', variantId);
      
      if ($(this).hasClass("bundle-aware")) {
        var actualLineQty = parseInt($(this).attr("data-actual-qty"));
        
        
        var newLineQty = Math.max(0, actualLineQty - 1);
        
('Bundle-aware minus: reducing THIS line from', actualLineQty, 'to', newLineQty);
        updateCartItemQuantity(lineIndex, newLineQty);
      } else if (itemType === "paid") {
        var displayedQty = parseInt(input.val());
        var newTotalQty = Math.max(0, displayedQty - 1);
('Paid item minus: reducing displayed quantity from', displayedQty, 'to', newTotalQty);
        updateCartItemQuantityForVariant(lineIndex, variantId, newTotalQty);
      } else {
        var currentQty = parseInt(input.val());
        var newQty = Math.max(0, currentQty - 1);
        input.val(newQty);
('Individual item minus: reducing from', currentQty, 'to', newQty);
        updateCartItemQuantity(lineIndex, newQty);
      }
    }
  );
  $(".cart-drawer-content").on(
    "click",
    ".cart-drawer-item-quantity-plus",
    function () {
      var lineIndex = $(this).attr("data-line-index");
      try { setCartItemLoadingEl(this, true); } catch(e) {}
      var input = $("#cart-drawer-item-quantity-input-" + lineIndex);
      var cartItem = $(this).closest(".cart-drawer-item");
      var itemType = cartItem.attr("data-item-type");
      var variantId = cartItem.attr("data-variant-id");
      try { optimisticSetQtyUI(cartItem[0], Math.max(0, parseInt(input.val()) + 1)); } catch(e) {}
      
('PLUS BUTTON CLICKED - lineIndex:', lineIndex, 'itemType:', itemType, 'variantId:', variantId);
      
      if ($(this).hasClass("bundle-aware")) {
        // For bundle-aware buttons, use the actual line item quantity
        // The input shows total consolidated quantity, not individual line quantity
        var actualLineQty = parseInt($(this).attr("data-actual-qty")); // Get actual line quantity
        var totalDisplayedQty = parseInt($(this).attr("data-total-qty")); // Total displayed quantity
        
        
        // Increase the actual line quantity by 1
        var newLineQty = actualLineQty + 1;
        
        if (
          $(this)[0].hasAttribute("data-stock") &&
          (totalDisplayedQty + 1) > parseInt($(this).attr("data-stock"))
        ) {
('⚠️ Stock limit reached for bundle-aware button');
          return;
        }
        
('Bundle-aware plus: increasing THIS line from', actualLineQty, 'to', newLineQty);
        updateCartItemQuantity(lineIndex, newLineQty);
      } else if (itemType === "paid") {
        // For paid items without bundle-aware class, use variant-level logic
        var displayedQty = parseInt(input.val());
        var newTotalQty = displayedQty + 1;

        if (
          $(this)[0].hasAttribute("data-stock") &&
          newTotalQty > parseInt($(this).attr("data-stock"))
        ) {
('⚠️ Stock limit reached for paid item');
          return;
        }
('Paid item plus: increasing displayed quantity from', displayedQty, 'to', newTotalQty);
        updateCartItemQuantityForVariant(lineIndex, variantId, newTotalQty);
      } else {
        // For attached, free, and upsell items - use individual line item logic
        var currentQty = parseInt(input.val());
        var newQty = currentQty + 1;
        if (
          $(this)[0].hasAttribute("data-stock") &&
          newQty > parseInt($(this).attr("data-stock"))
        ) {
('⚠️ Stock limit reached for individual item');
          return;
        }
        input.val(newQty);
('Individual item plus: increasing from', currentQty, 'to', newQty);
        updateCartItemQuantity(lineIndex, newQty);
      }
    }
  );
  $(".cart-drawer-content").on(
    "click",
    ".cart-drawer-item-remove",
    function () {
      var lineIndex = $(this).attr("data-line-index");
      try { setCartItemLoadingEl(this, true); } catch(e) {}
      var cartItem = $(this).closest(".cart-drawer-item");
      var itemType = cartItem.attr("data-item-type");
      var variantId = cartItem.attr("data-variant-id");
      try { optimisticRemoveHint(cartItem[0]); } catch(e) {}
      
('🗑️ TRASH CAN CLICKED - lineIndex:', lineIndex, 'itemType:', itemType, 'variantId:', variantId);
('   Will determine removal strategy based on item type...');
      
      // If clicking trash on gratis item, clear entire cart  
      if (itemType === "gratis" || itemType === "attached") {
('🧹 GRATIS/ATTACHED ITEM - Clearing entire cart');
        showLoadingIndicator();
        
        // Clear all cart items
        $.ajax({
          type: "POST",
          url: "/cart/clear.js",
          dataType: "json",
          success: function() {
            reloadCart(function() {
              hideLoadingIndicator();
            });
          },
          error: function() {
            // Fallback: Remove each item individually
            $.ajax({
              type: "GET",
              url: "/cart.js",
              dataType: "json",
              success: function(cart) {
                var clearUpdates = {};
                cart.items.forEach(function(item) {
                  clearUpdates[item.key] = 0;
                });
                
                $.ajax({
                  type: "POST",
                  url: "/cart/update.js",
                  dataType: "json",
                  data: JSON.stringify({ updates: clearUpdates }),
                  contentType: "application/json",
                  success: function() {
                    reloadCart(function() {
                      hideLoadingIndicator();
                    });
                  },
                  error: function() {
                    hideLoadingIndicator();
                  }
                });
              },
              error: function() {
                hideLoadingIndicator();
              }
            });
          }
        });
      } else if (itemType === "upsell") {
('🗑️ UPSELL ITEM - Removing individual item');
        updateCartItemQuantity(lineIndex, 0);
      } else if (itemType === "paid") {
('💰 PAID ITEM - Removing entire variant and related attached items');
('   Calling updateCartItemQuantityForVariant with newQuantity: 0');
('   This should remove ALL line items for variant:', variantId);
        updateCartItemQuantityForVariant(lineIndex, variantId, 0);
      } else {
('❓ UNKNOWN ITEM TYPE - Using fallback removal');
        updateCartItemQuantity(lineIndex, 0);
      }
    }
  );

  // Close cart.
  $(".cart-drawer-header-close-icon").click(closeCartDrawer);

  // Cart upselling.
  $(".cart-drawer-content").on(
    "change",
    ".cart-upselling-item-variants-select",
    cartUpsellVariantSelection
  );

  // Variant editor modal: open on cart item click for eligible lines
  if (typeof initCartVariantEditorModal === 'function') {
    initCartVariantEditorModal();
  }
  
  // Initialize and update cart upsell prices
  if (typeof cartUpsellFilterOptions === 'function') { cartUpsellFilterOptions(); }
  cartUpsellVariantSelection();
  
  // Re-run after cart updates
  $(document).on('cart:reloaded', function() {
  setTimeout(function(){
    if (typeof cartUpsellFilterOptions === 'function') { cartUpsellFilterOptions(); }
    cartUpsellVariantSelection();
  }, 100);
  });

  $("#cart-upselling").submit(function (event) {
    event.preventDefault();

    if ($("#cart-upselling button").attr("disabled")) {
      return;
    }

    showLoadingIndicator();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: $(this).serialize(),
      success: function () {
        reloadCart(function () {
          $(".cart-drawer-content").addClass("no-transition");
          openCartDrawer();
          setTimeout(function () {
            $(".cart-drawer-content").removeClass("no-transition");
          }, 400);

          hideLoadingIndicator();
        });
      },
      error: function (response) {
        hideLoadingIndicator();

        if (
          response &&
          response.responseJSON &&
          response.responseJSON.description
        ) {
          alert(
            response.responseJSON.message +
              "\n\n" +
              response.responseJSON.description
          );
        } else {
          if (isGermanShop()) {
            alert(
              "Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal."
            );
          } else {
            alert("An error has occurred. Please try again.");
          }
        }
      },
    });
  });

  // Cart discount.
  $(".cart-drawer-footer-discount-input button").click(function () {
    var discountCode = $(".cart-drawer-footer-discount-input input")
      .val()
      .trim();

    if (!discountCode) {
      return;
    }

    showLoadingIndicator();

    $.ajax({
      type: "GET",
      url: "/discount/" + discountCode,
      success: function () {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: { updates: {} },
          success: function () {
            reloadCart(function() {
              $(".cart-drawer-content").addClass("no-transition");
              openCartDrawer();
              setTimeout(function () {
                $(".cart-drawer-content").removeClass("no-transition");
              }, 400);

              hideLoadingIndicator();
            });
          },
          error: function () {
            $(".cart-drawer-footer-discount-input-failure").show();
            hideLoadingIndicator();
          },
        });
      },
      error: function () {
        $(".cart-drawer-footer-discount-input-failure").show();
        hideLoadingIndicator();
      },
    });
  });

  // Note.
  if ($(".cart-drawer-footer-note-input").length > 0) {
    $(".cart-drawer-footer-note-input input").on("keyup", function () {
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: { note: $(this).val() },
        success: function () {},
        error: function () {},
      });
    });
  }
}

// ================= Variant Editor Modal (Mobile-first) =================
function initCartVariantEditorModal() {
  var $drawer = $(".cart-drawer-content");
  var $block = $drawer.find('[data-cart-variant-editor-block][data-enabled="true"]').first();

  // Acquire and deduplicate modal/backdrop: keep ONE global instance in <body>
  var $allBackdrops = $('[data-cart-variant-modal-backdrop]');
  var $allModals = $('[data-cart-variant-modal]');
  if ((!$allBackdrops.length || !$allModals.length) && $block.length) {
    $allBackdrops = $allBackdrops.add($block.find('[data-cart-variant-modal-backdrop]'));
    $allModals = $allModals.add($block.find('[data-cart-variant-modal]'));
  }
  if (!$allBackdrops.length || !$allModals.length) { return; }

  var $keepBackdrop = $allBackdrops.filter(function(){ return this.parentElement === document.body; }).first();
  if (!$keepBackdrop.length) { $keepBackdrop = $allBackdrops.first(); }
  $keepBackdrop.detach().appendTo('body');
  $allBackdrops.not($keepBackdrop).remove();

  var $keepModal = $allModals.filter(function(){ return this.parentElement === document.body; }).first();
  if (!$keepModal.length) { $keepModal = $allModals.first(); }
  $keepModal.detach().appendTo('body');
  $allModals.not($keepModal).remove();

  var $backdrop = $keepBackdrop;
  var $modal = $keepModal;

  var $title = $modal.find('[data-cart-variant-modal-title]');
  var $subtitle = $modal.find('[data-cart-variant-modal-subtitle]');
  var $price = $modal.find('[data-cart-variant-modal-price]');
  var $options = $modal.find('[data-cart-variant-modal-options]');
  var $media = $modal.find('[data-cart-variant-modal-media]');
  var $mediaImg = null;

  // Ensure modal lives at <body> level (already handled above)

  function normalizeShopFileUrl(url) {
    if (!url) return url;
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url;
  }

  function pickImageForVariant(product, variantId, preferVariant) {
    var variant = (product.variants || []).find(function(v){ return v.id === variantId; });
    var fallback = (product.images && product.images.length > 0) ? (typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src) : null;
    var cartImg = $('.cart-drawer-item[data-variant-id="' + variantId + '"] img').attr('src');
    if (preferVariant) {
      if (variant && variant.featured_image && variant.featured_image.src) return normalizeShopFileUrl(variant.featured_image.src);
      if (cartImg) return normalizeShopFileUrl(cartImg);
      return normalizeShopFileUrl(fallback);
    } else {
      if (cartImg) return normalizeShopFileUrl(cartImg);
      if (variant && variant.featured_image && variant.featured_image.src) return normalizeShopFileUrl(variant.featured_image.src);
      return normalizeShopFileUrl(fallback);
    }
  }

  function setMediaSrc(url) {
    if (!url) return;
    if (!$mediaImg) {
      $mediaImg = $('<img alt="" />');
      $media.empty().append($mediaImg);
    }
    if ($mediaImg.attr('src') === url) return;
    $mediaImg.attr('src', url);
  }

  function findImageByLabel(product, label) {
    if (!label || !product || !product.images || !product.images.length) return null;
    var norm = String(label).toLowerCase().replace(/[^a-z0-9]+/g, '');
    for (var i=0;i<product.images.length;i++) {
      var img = product.images[i];
      var src = typeof img === 'string' ? img : (img && img.src);
      if (!src) continue;
      var srcNorm = src.toLowerCase().replace(/[^a-z0-9]+/g, '');
      if (srcNorm.indexOf(norm) !== -1) return normalizeShopFileUrl(src);
    }
    return null;
  }
  var $viewLink = $modal.find('[data-cart-variant-view-link]');
  var $updateBtn = $modal.find('[data-cart-variant-update]');
  var pickerStyle = $block.find('[data-variant-picker-style]').attr('data-variant-picker-style') || 'chips';

  var openCtx = null; // {lineIndex, variantId, productHandle, quantity}

  function openModal(ctx) {
    if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] openModal called', ctx); } catch(e) {} }
    openCtx = ctx;
    if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] openModal', ctx); } catch(e) {} }
    // Reacquire latest nodes in case of re-render
    $modal = $('[data-cart-variant-modal]');
    $backdrop = $('[data-cart-variant-modal-backdrop]');
    $title = $modal.find('[data-cart-variant-modal-title]');
    $subtitle = $modal.find('[data-cart-variant-modal-subtitle]');
    $price = $modal.find('[data-cart-variant-modal-price]');
    $options = $modal.find('[data-cart-variant-modal-options]');
    $media = $modal.find('[data-cart-variant-modal-media]');
    $viewLink = $modal.find('[data-cart-variant-view-link]');
    $updateBtn = $modal.find('[data-cart-variant-update]');

    $options.empty();
    $updateBtn.prop('disabled', true);
    $backdrop.addClass('is-open');
    // Prefetch and render content first, then slide up (prevents mid-animation layout jumps)
    fetchAndHydrate(ctx, function(){ $modal.removeClass('is-closing').addClass('is-open'); });
  }

  // Expose opener globally so delegated handlers can call it after re-renders
  try { window.__CVM_openModal = openModal; } catch(e) {}
  $(document).off('cartVariantModal:open').on('cartVariantModal:open', function(_, ctx){
    if (typeof window.__CVM_openModal === 'function') { window.__CVM_openModal(ctx || openCtx || {}); }
  });

  function closeModal() {
    $modal.removeClass('is-open').addClass('is-closing');
    $backdrop.removeClass('is-open');
    openCtx = null;
    setTimeout(function(){ try { $modal.removeClass('is-closing'); } catch(e) {} }, 300);
  }

  function closeModalAnimated(callback) {
    try {
      $modal.removeClass('is-open').addClass('is-closing');
      $backdrop.removeClass('is-open');
      setTimeout(function(){ try { $modal.removeClass('is-closing'); } catch(e) {} if (typeof callback === 'function') { try { callback(); } catch(e) {} } }, 280);
    } catch(e) { if (typeof callback === 'function') { try { callback(); } catch(err) {} } }
  }

  $modal.on('click', '[data-cart-variant-modal-close]', closeModal);
  $backdrop.on('click', closeModal);
  $(document).on('keyup.cartVariantModal', function(e){ if (e.key === 'Escape') closeModal(); });

  // Prevent cart item click bubbling from controls that should not open the modal
  $drawer.on('click', '.cart-drawer-item-quantity-plus, .cart-drawer-item-quantity-minus, .cart-drawer-item-remove', function(e){ e.stopPropagation(); });
  $drawer.on('click', '.cart-drawer-item input, .cart-drawer-item select, .cart-drawer-item textarea, .cart-drawer-item a:not(.cart-drawer-item-edit-link)', function(e){ e.stopPropagation(); });

  // Dedicated edit link opens the modal (document-level delegation survives re-renders)
  $(document).off('click.cartVariantEdit').on('click.cartVariantEdit', '.cart-drawer-item-edit-link', function(e){
    e.preventDefault(); e.stopPropagation();
    var $item = $(this).closest('.cart-drawer-item');
    if ($item.length === 0) { return; }
    var itemType = $item.attr('data-item-type');
    // Allow editing for paid, attached, gratis, and upsell items
    if (!(itemType === 'paid' || itemType === 'attached' || itemType === 'gratis' || itemType === 'upsell')) { return; }
    var handle = $item.attr('data-product-handle');
    if (!handle) {
      var href = $item.find('a[href*="/products/"]').attr('href') || '';
      var m = href.match(/\/products\/([^\/?#]+)/);
      if (m && m[1]) { handle = m[1]; }
    }
    var ctx = {
      lineIndex: parseInt($item.attr('data-line-index')),
      lineKey: $item.attr('data-line-key'),
      variantId: parseInt($item.attr('data-variant-id')),
      productHandle: handle,
      quantity: 1,
      // Only mark as attached for true attached/gratis items, not upsells
      isAttached: (itemType === 'attached' || itemType === 'gratis')
    };
    if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] edit-link click', {ctx: ctx, hasOpener: typeof window.__CVM_openModal === 'function'}); } catch(e) {} }
    if (!ctx.productHandle) { try { console.warn('[CART_VARIANT_MODAL] Missing product handle for edit link'); } catch(_) {} return; }
    if (typeof window.__CVM_openModal === 'function') {
      window.__CVM_openModal(ctx);
    } else if (typeof initCartVariantEditorModal === 'function') {
      if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] opener missing, re-initializing modal'); } catch(e) {} }
      try { initCartVariantEditorModal(); } catch(err) {}
      setTimeout(function(){ if (typeof window.__CVM_openModal === 'function') { window.__CVM_openModal(ctx); } }, 0);
    }
  });

  // Whole-row click intentionally disabled; use explicit edit link above

  function fetchAndHydrate(ctx, onReady) {
    if (!ctx || !ctx.productHandle) { return; }
    $.getJSON('/products/' + ctx.productHandle + '.js', function(product){
      if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] product', {handle: ctx.productHandle, variants: (product.variants||[]).length}); } catch(e) {} }
      // Title/subtitle/price
      $title.text(product.title);
      $subtitle.text(product.type || '');
      if ($price.length && typeof Shopify !== 'undefined' && Shopify.formatMoney) { $price.text(Shopify.formatMoney(product.price)); }
    if ($viewLink.length) {
      try {
        var $block = $('[data-cart-variant-editor-block]');
        var viewEnabled = ($block.attr('data-view-link-enabled') === 'true');
        var customUrl = $block.attr('data-view-link-url');
        if (!viewEnabled) { $viewLink.hide(); }
        else {
          var href = customUrl && customUrl.length ? customUrl : ('/products/' + product.handle);
          $viewLink.attr('href', href);
          $viewLink.show();
        }
      } catch(e) { $viewLink.attr('href', '/products/' + product.handle); }
    }

      // Media: show current variant image or first product image
      var variant = product.variants.find(function(v){ return v.id === ctx.variantId; }) || product.variants[0];
      var imageUrl = pickImageForVariant(product, variant ? variant.id : (product.variants && product.variants[0] && product.variants[0].id), false);
      setMediaSrc(imageUrl);

      buildOptionPickers(product, ctx);
      if (typeof onReady === 'function') { try { onReady(); } catch(e) {} }
    });
  }

  function buildOptionPickers(product, ctx) {
    var optDefs = (product.options_with_values && product.options_with_values.length)
      ? product.options_with_values
      : (product.options || []).map(function(n){ return { name: n, values: [] }; });

    function normalizeText(value, fallback){
      if (typeof value === 'string' || typeof value === 'number') return String(value);
      if (!value || typeof value !== 'object') return fallback || '';
      // Prefer English keys if present
      var candidates = ['en', 'en-US', 'en_GB', 'value', 'label', 'name'];
      for (var i=0;i<candidates.length;i++){
        if (typeof value[candidates[i]] === 'string') return value[candidates[i]];
      }
      // Pick first string property
      for (var k in value){ if (typeof value[k] === 'string') return value[k]; }
      return fallback || '';
    }

    function getOptionName(i){
      var raw = optDefs[i] && (optDefs[i].name !== undefined ? optDefs[i].name : optDefs[i]);
      var out = normalizeText(raw, 'Option ' + (i+1));
      return out;
    }

    var selectedOptions = {}; // {OptionName: Value}

    // Helper: find variant for fully-specified options
    function variantByOptions(opts){
      return product.variants.find(function(v){
        for (var i = 0; i < optDefs.length; i++) {
          var name = getOptionName(i);
          if (!opts[name]) return false;
          if (v['option' + (i+1)] !== opts[name]) return false;
        }
        return true;
      });
    }

    // Helper: does there exist an available variant matching current partial selection plus a candidate value for option index?
    function isValueAvailable(optionIndex, value){
      for (var vi = 0; vi < product.variants.length; vi++) {
        var v = product.variants[vi];
        if (v['option' + (optionIndex + 1)] !== value) continue;
        var match = true;
        for (var i = 0; i < optDefs.length; i++) {
          if (i === optionIndex) continue;
          var name = getOptionName(i);
          if (selectedOptions[name] && v['option' + (i+1)] !== selectedOptions[name]) { match = false; break; }
        }
        if (match && v.available) { return true; }
      }
      return false;
    }

    // Unique values per option index in product-defined order
    function valuesForOption(index){
      var fromDefs = optDefs[index] && optDefs[index].values;
      if (fromDefs && fromDefs.length) {
        return fromDefs.map(function(v){ return normalizeText(v, String(v)); });
      }
      var seen = {}, vals = [];
      (product.variants || []).forEach(function(v){
        var val = v['option' + (index + 1)];
        if (val != null && !seen[val]) { seen[val] = true; vals.push(val); }
      });
      return vals;
    }

    // When a user selects an option value, adjust downstream options to the first available combination
    function selectOptionAndResolve(optIndex, nameKey, valStr) {
      selectedOptions[nameKey] = valStr;
      for (var j = optIndex + 1; j < optDefs.length; j++) {
        var jName = getOptionName(j);
        var vals = valuesForOption(j);
        var picked = null;
        for (var k = 0; k < vals.length; k++) {
          var candidate = normalizeText(vals[k], String(vals[k]));
          if (isValueAvailable(j, candidate)) { picked = candidate; break; }
        }
        if (picked) { selectedOptions[jName] = picked; }
      }
    }

    // Determine if a value has ANY available variant regardless of other selections (used for color-like options)
    function isValueGloballyAvailable(optionIndex, valStr) {
      var key = 'option' + (optionIndex + 1);
      for (var i = 0; i < (product.variants || []).length; i++) {
        var v = product.variants[i];
        if (v && v.available && v[key] === valStr) { return true; }
      }
      return false;
    }

    // Initialize selection from current variant
    var currentVariant = (product.variants || []).find(function(v){ return v.id === ctx.variantId; }) || (product.variants || [])[0];
    for (var i = 0; i < optDefs.length; i++) {
      selectedOptions[getOptionName(i)] = currentVariant ? currentVariant['option' + (i+1)] : valuesForOption(i)[0];
    }

    function renderAll() {
      $options.empty();
      for (var i = 0; i < optDefs.length; i++) {
        var name = getOptionName(i);
        var values = valuesForOption(i);
        var $group = $('<div class="cvm-option-group" />');
        var safeTitle = normalizeText(name, 'Option ' + (i+1));
        var $titleEl = $('<div class="cvm-option-title" />').text(safeTitle);
        $group.append($titleEl);

        (function(nameKey, optIndex){
        var nameLc = String(nameKey || '').toLowerCase();
        var isColorLike = (nameLc.indexOf('color') !== -1 || nameLc.indexOf('farbe') !== -1 || nameLc.indexOf('design') !== -1 || nameLc.indexOf('muster') !== -1 || nameLc.indexOf('motiv') !== -1 || optIndex === 0);
        values.forEach(function(val){
          var valStr = normalizeText(val, String(val));
          var comboAvailable = isValueAvailable(optIndex, valStr);
          var displayAvailable = isColorLike ? isValueGloballyAvailable(optIndex, valStr) : comboAvailable;
          var isActive = selectedOptions[nameKey] === valStr;
          var $chip = $('<button type="button" class="cvm-chip" />').text(valStr);
          if (isActive) { $chip.addClass('active'); }
          if (!displayAvailable && !isActive) { $chip.addClass('is-unavailable'); }
          if (!isColorLike && !comboAvailable) {
            // Non-color (e.g., size) that is unavailable: make unclickable
            $chip.attr('aria-disabled','true').prop('disabled', true);
          } else {
            $chip.on('click', function(){ selectOptionAndResolve(optIndex, nameKey, valStr); renderAll(); });
          }
          $group.append($chip);
        });
        })(name, i);
        $options.append($group);
      }

      var selectedVariant = variantByOptions(selectedOptions);
      if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] selected', {opts: selectedOptions, variantId: selectedVariant ? selectedVariant.id : null}); } catch(e) {} }
      // Update media image on option change (fallback to product default)
      if (selectedVariant) {
        // Prefer variant image; if missing, try to infer by selected color/motif label from options
        var url = pickImageForVariant(product, selectedVariant.id, true);
        if (!url) {
          var colorKey = null;
          Object.keys(selectedOptions).forEach(function(k){
            var kl = k.toLowerCase();
            if (!colorKey && (kl.indexOf('color')!==-1 || kl.indexOf('farbe')!==-1 || kl.indexOf('motiv')!==-1 || kl.indexOf('design')!==-1 || kl.indexOf('pattern')!==-1)) {
              colorKey = k;
            }
          });
        if (colorKey) {
            var label = selectedOptions[colorKey];
            var match = findImageByLabel(product, label);
            if (match) url = match;
          }
        }
        setMediaSrc(url || pickImageForVariant(product, selectedVariant.id, false));
      }
      if (selectedVariant && typeof Shopify !== 'undefined' && Shopify.formatMoney && $price.length) {
        $price.text(Shopify.formatMoney(selectedVariant.price));
      }
      $updateBtn.prop('disabled', !(selectedVariant && selectedVariant.available && selectedVariant.id !== ctx.variantId));
      $updateBtn.off('click').on('click', function(){
        if (!selectedVariant || !selectedVariant.available) { return; }
    if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] update click', {lineIndex: ctx.lineIndex, lineKey: ctx.lineKey, oldId: ctx.variantId, newId: selectedVariant.id}); } catch(e) {} }
    try { if (window.__CART_DRAWER_DIFF_MODE__ && ctx.lineKey) { CartDrawerState.state.pendingOp = { type: 'variant-swap', lineKey: ctx.lineKey }; } } catch(e) {}
    performVariantUpdate(ctx.lineIndex, ctx.variantId, selectedVariant.id, ctx.quantity, ctx.lineKey);
      });
    }

    renderAll();
  }

  function performVariantUpdate(lineIndex, oldVariantId, newVariantId, quantity, lineKey) {
    try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, true); else window.setCartItemLoading?.(lineIndex, true); } catch(e) {}
    // Build updates map: remove old line by key then add new variant with same quantity, preserve properties if needed
    $.getJSON('/cart.js', function(cart){
      // Compute target attached from bundle configs (best qualifying tier)
      function computeTargetAttachedCountForProduct(cartObj, productIdStr) {
        try {
          var paidItems = cartObj.items
            .filter(function(it){ return String(it.product_id) === productIdStr; })
            .filter(function(it){ return !it.properties || (it.properties._attached_product !== 'true' && it.properties._is_upsell !== 'true'); });
          var paidCount = paidItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
          var cfgStr = null;
          for (var i = 0; i < paidItems.length; i++) {
            if (paidItems[i].properties && paidItems[i].properties._bundle_configs) { cfgStr = paidItems[i].properties._bundle_configs; break; }
          }
          if (cfgStr) {
            var bestPaidQty = -1; var bestFreeCount = 0;
            cfgStr.split('|').forEach(function(c){
              var p = c.split(':');
              if (p.length >= 4) {
                var totalQty = parseInt(p[0]);
                var freeCount = parseInt(p[3]);
                if (!isNaN(totalQty) && !isNaN(freeCount)) {
                  var paidQty = totalQty - freeCount;
                  if (paidCount >= paidQty && paidQty > bestPaidQty) { bestPaidQty = paidQty; bestFreeCount = freeCount; }
                }
              }
            });
            return bestFreeCount;
          }
          return paidCount;
        } catch(e) { return 0; }
      }
      var targetLine = null;
      if (lineKey) {
        targetLine = cart.items.find(function(it){ return it.key === lineKey; });
      }
      if (!targetLine) {
        targetLine = cart.items[lineIndex - 1];
      }
      var properties = (targetLine && targetLine.properties) ? targetLine.properties : {};
      // Track product and pre-change paid count for safety reconciliation
      var productIdForEdit = targetLine ? String(targetLine.product_id) : '';
      var prePaidCount = 0;
      if (cart && cart.items && productIdForEdit) {
        prePaidCount = cart.items
          .filter(function(it){ return String(it.product_id) === productIdForEdit; })
          .filter(function(it){ return !it.properties || (it.properties._attached_product !== 'true' && it.properties._is_upsell !== 'true'); })
          .reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
      }
      // Determine if edited line is an attached/free item
      var editedWasAttached = false;
      if (properties && (properties._attached_product === 'true' || properties._is_free_item === 'true')) {
        editedWasAttached = true;
      }
      // Only strip markers for paid lines; preserve for attached/free so it still renders as Gratis
      if (!editedWasAttached) {
        delete properties._is_free_item;
        delete properties._attached_product;
        delete properties._is_upsell;
        delete properties._is_cart_drawer_upsell;
      } else {
        // Ensure attached/gratis semantics persist after swap
        properties._attached_product = 'true';
        if (properties._is_free_item === undefined && properties._attached_discount === '0%') {
          // Some flows mark gratis via _is_free_item; keep or set consistently when clearly free
          properties._is_free_item = 'true';
        }
        // Track the chosen attached variant explicitly for downstream logic
        properties._attached_variant_id = String(newVariantId);
        properties._user_selected_variant = 'true';

        // Do not override _source_variant_id here; allow multiple attached items to share the same color
      }

      // Compute accurate current line index using key to avoid stale UI indexes
      var swapLineIndex = lineIndex;
      if (targetLine && targetLine.key) {
        var idxNow = cart.items.findIndex(function(it){ return it.key === targetLine.key; });
        if (idxNow >= 0) { swapLineIndex = idxNow + 1; }
      }

      // If this is a paid bundle line with quantity > 1, split: decrement original by 1 and add new variant as a separate line
      var isPaidBundleLine = !!(properties && properties._bundle_configs) && !editedWasAttached;
      if (isPaidBundleLine && targetLine && parseInt(targetLine.quantity) > 1) {
        var updatesSplit = {};
        updatesSplit[targetLine.key] = parseInt(targetLine.quantity) - 1;
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          dataType: 'json',
          data: JSON.stringify({ updates: updatesSplit }),
          contentType: 'application/json',
          complete: function(){
            // Add the new paid variant with preserved bundle properties
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: { id: newVariantId, quantity: 1, properties: properties },
              complete: function(){
                // After adding new paid, ensure attached count remains the same by adding one attached for the new paid if needed
                $.getJSON('/cart.js', function(cartAfterAdd){
                  try {
                    var productId = targetLine ? String(targetLine.product_id) : '';
                    var oldSourceId = String(oldVariantId);
                    var newSourceId = String(newVariantId);
                    var attachedForProductItems = cartAfterAdd.items.filter(function(it){ return it.properties && it.properties._attached_product === 'true' && it.properties._source_product_id === productId; });
                    var attachedCount = attachedForProductItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
                    var paidForProductItems = cartAfterAdd.items
                      .filter(function(it){ return String(it.product_id) === productId; })
                      .filter(function(it){ return !it.properties || (it.properties._attached_product !== 'true' && it.properties._is_upsell !== 'true'); });
                    var paidCount = paidForProductItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
                    var targetAttached = computeTargetAttachedCountForProduct(cartAfterAdd, productId);
                    var deficit = targetAttached - attachedCount;
                    if (deficit > 0 && window.cr_attached_product_variants) {
                      var pick = window.cr_attached_product_variants[0];
                      if (pick && pick.id) {
                        var uniqueTimestamp = Date.now();
                        var uniqueId = uniqueTimestamp + '_attached_fill_' + Math.random().toString(36).substr(2, 9);
                        var attachedProps = {
                          _attached_product: 'true',
                          _attached_discount: properties && properties._attached_discount ? properties._attached_discount : '0%',
                          _source_product_id: productId,
                          _source_variant_id: newSourceId,
                          _attached_unique_id: uniqueId,
                          _attached_timestamp: String(uniqueTimestamp)
                        };
                        addAttachedItemsBatch(productId, newSourceId, deficit, attachedProps, function(){ closeModalAnimated(function(){ optimizeBundleTiers(function(){ $.getJSON('/cart.js', function(afterCart){ if (typeof window.safeReconcile === 'function') { window.safeReconcile(afterCart, function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }); } else { reloadCart(function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }, { suppressTransitions: true }); } }); }); }); });
                        return;
                      }
                    }
                  } catch(e) {}
          closeModalAnimated(function(){ optimizeBundleTiers(function(){ $.getJSON('/cart.js', function(afterCart){ if (typeof window.safeReconcile === 'function') { window.safeReconcile(afterCart, function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }); } else { reloadCart(function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }, { suppressTransitions: true }); } }); }); });
                });
              }
            });
          }
        });
        return;
      }

      // If this is an attached/gratis item, prefer deterministic remove+add to ensure the edit applies even when another attached already has the same variant
      if (editedWasAttached && targetLine && targetLine.key) {
        var updatesAttached = {}; updatesAttached[targetLine.key] = 0;
        $.ajax({ type: 'POST', url: '/cart/update.js', dataType: 'json', data: JSON.stringify({ updates: updatesAttached }), contentType: 'application/json', complete: function(){
          $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json', data: { id: newVariantId, quantity: 1, properties: properties }, complete: function(){
            closeModalAnimated(function(){ optimizeBundleTiers(function(){ $.getJSON('/cart.js', function(afterCart){ if (typeof window.safeReconcile === 'function') { window.safeReconcile(afterCart, function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }); } else { reloadCart(function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }, { suppressTransitions: true }); } }); }); });
          }});
        }});
        return;
      }

      // If target is paid (qty==1 here) and the new variant already exists as a paid line for this product, prefer remove+add by key for deterministic merge
      if (!editedWasAttached && targetLine && parseInt(targetLine.quantity) === 1) {
        var paidLineForNewExists = cart.items.some(function(it){
          return String(it.product_id) === productIdForEdit && it.variant_id === newVariantId && (!it.properties || (it.properties._attached_product !== 'true' && it.properties._is_upsell !== 'true')) && it.key !== targetLine.key;
        });
        if (paidLineForNewExists) {
          var updatesRm = {};
          updatesRm[targetLine.key] = 0;
          // remove exactly one attached tied to old variant to keep 1:1
          var removeAttachedKey = null;
          for (var rj = 0; rj < cart.items.length; rj++) {
            var rit = cart.items[rj];
            if (rit && rit.properties && rit.properties._attached_product === 'true' && rit.properties._source_variant_id === String(oldVariantId)) { removeAttachedKey = rit.key; break; }
          }
          if (removeAttachedKey) { updatesRm[removeAttachedKey] = 0; }
          $.ajax({ type: 'POST', url: '/cart/update.js', dataType: 'json', data: JSON.stringify({ updates: updatesRm }), contentType: 'application/json', complete: function(){
            $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json', data: { id: newVariantId, quantity: 1, properties: properties }, complete: function(){
              // After add, enforce attached==paid by counts
              $.getJSON('/cart.js', function(cartAfter){
                try {
                  var attachedItems = cartAfter.items.filter(function(it){ return it.properties && it.properties._attached_product === 'true' && it.properties._source_product_id === productIdForEdit; });
                  var attachedCount = attachedItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
                  var paidItems = cartAfter.items.filter(function(it){ return String(it.product_id) === productIdForEdit && (!it.properties || (it.properties._attached_product !== 'true' && it.properties._is_upsell !== 'true')); });
                  var paidCount = paidItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
                  var deficit = paidCount - attachedCount;
                  if (deficit > 0 && window.cr_attached_product_variants) {
                    addAttachedItemsBatch(productIdForEdit, String(newVariantId), deficit, properties, function(){ closeModalAnimated(function(){ optimizeBundleTiers(function(){ $.getJSON('/cart.js', function(afterCart){ if (typeof window.safeReconcile === 'function') { window.safeReconcile(afterCart, function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }); } else { reloadCart(function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }, { suppressTransitions: true }); } }); }); }); });
                    return;
                  }
                } catch(e) {}
                closeModalAnimated(function(){ optimizeBundleTiers(function(){ $.getJSON('/cart.js', function(afterCart){ if (typeof window.safeReconcile === 'function') { window.safeReconcile(afterCart, function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }); } else { reloadCart(function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }, { suppressTransitions: true }); } }); }); });
              });
            }});
          }});
          return;
        }
      }

      // Step 1: Swap the variant in-place on the same line (prevents re-add merge)
      // Use line-based change to swap to the new variant (Shopify API: change line variant via 'id')
      var swapPayload = { line: swapLineIndex, id: newVariantId, quantity: 1, properties: properties };

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: swapPayload,
        success: function(){
          // Step 2: If we edited a paid item, remove attached items pointing to old variant id.
          // If we edited an attached/gratis item, we only swapped that single line, nothing else.
          var updates = {};
          var editedWasAttached = false;
          if (targetLine && targetLine.properties && (targetLine.properties._attached_product === 'true' || targetLine.properties._is_free_item === 'true')) {
            editedWasAttached = true;
          }
          if (!editedWasAttached) {
            // Remove only ONE attached item tied to the old paid variant, not all
            var removeOneKey = null;
            for (var ri = 0; ri < cart.items.length; ri++) {
              var item = cart.items[ri];
              if (item && item.properties && item.properties._attached_product === 'true' && item.properties._source_variant_id === String(oldVariantId)) {
                removeOneKey = item.key; break;
              }
            }
            if (removeOneKey) { updates[removeOneKey] = 0; }
          } else {
            // Attached item edit: ensure line consolidation does not block change when selecting same color
            // If another attached with same _attached_variant_id exists, we still perform the swap on this line
          }

          var afterRemove = function(){
            // Reconcile counts to ensure we didn't accidentally drop a paid unit due to merge nuances
            $.getJSON('/cart.js', function(afterCart){
              var paidItems = afterCart.items
                .filter(function(it){ return String(it.product_id) === productIdForEdit; })
                .filter(function(it){ return !it.properties || (it.properties._attached_product !== 'true' && it.properties._is_upsell !== 'true'); });
              var newPaidCount = paidItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);

              var ensureAttachedThenFinish = function(){
                // Ensure 1:1 attached mapping after reconciliation
                var attachedItems = afterCart.items.filter(function(it){ return it.properties && it.properties._attached_product === 'true' && it.properties._source_product_id === productIdForEdit; });
                var attachedCount = attachedItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
                var paidCountFinal = newPaidCount;
                var deficit = paidCountFinal - attachedCount;
                if (deficit > 0 && window.cr_attached_product_variants) {
                  addAttachedItemsBatch(productIdForEdit, String(newVariantId), deficit, properties, function(){ closeModalAnimated(function(){ optimizeBundleTiers(function(){ $.getJSON('/cart.js', function(afterCart){ if (typeof window.safeReconcile === 'function') { window.safeReconcile(afterCart, function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }); } else { reloadCart(function(){ try { if (lineKey) window.setCartItemLoadingByKey?.(lineKey, false); else window.setCartItemLoading?.(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }, { suppressTransitions: true }); } }); }); }); });
                    return;
                  }
                  closeModalAnimated(function(){ optimizeBundleTiers(function(){ $.getJSON('/cart.js', function(afterCart){ if (typeof window.safeReconcile === 'function') { window.safeReconcile(afterCart, function(){ try { if (lineKey) setCartItemLoadingByKey(lineKey, false); else setCartItemLoading(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }); } else { reloadCart(function(){ try { if (lineKey) setCartItemLoadingByKey(lineKey, false); else setCartItemLoading(lineIndex, false); } catch(_e) {} showCartDrawerWithoutTransition(); hideLoadingIndicator(); }, { suppressTransitions: true }); } }); }); });
              };

              if (newPaidCount < prePaidCount) {
                // Add back one paid unit for the new variant to preserve total paid quantity
                $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json', data: { id: newVariantId, quantity: (prePaidCount - newPaidCount), properties: properties }, complete: function(){
                  // Refresh after add to compute latest attached count correctly
                  $.getJSON('/cart.js', function(afterAddCart){ afterCart = afterAddCart; newPaidCount = prePaidCount; ensureAttachedThenFinish(); });
                }});
              } else {
                ensureAttachedThenFinish();
              }
            });
          };

          if (Object.keys(updates).length > 0) {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              dataType: 'json',
              data: JSON.stringify({ updates: updates }),
              contentType: 'application/json',
              complete: function(){
                // If we removed one attached, ensure the 1:1 attached:paid ratio is restored by adding one for the new variant if needed
                $.getJSON('/cart.js', function(cartAfter){
                  try {
                    var productId = targetLine ? String(targetLine.product_id) : '';
                    var attachedForProductItems = cartAfter.items.filter(function(it){ return it.properties && it.properties._attached_product === 'true' && it.properties._source_product_id === productId; });
                    var attachedCount = attachedForProductItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
                    var paidForProductItems = cartAfter.items
                      .filter(function(it){ return String(it.product_id) === productId; })
                      .filter(function(it){ return !it.properties || (it.properties._attached_product !== 'true' && it.properties._is_upsell !== 'true'); });
                    var paidCount = paidForProductItems.reduce(function(sum, it){ return sum + (parseInt(it.quantity) || 1); }, 0);
                    var deficit = paidCount - attachedCount;
                    if (deficit > 0 && window.cr_attached_product_variants) {
                      var fillOneSwap = function(remaining) {
                        if (remaining <= 0) { afterRemove(); return; }
                        var pick = window.cr_attached_product_variants[0];
                        if (!(pick && pick.id)) { afterRemove(); return; }
                        var uniqueTimestamp = Date.now();
                        var uniqueId = uniqueTimestamp + '_attached_fill_after_swap_' + Math.random().toString(36).substr(2, 9);
                        var attachedProps = { _attached_product: 'true', _attached_discount: properties && properties._attached_discount ? properties._attached_discount : '0%', _source_product_id: productId, _source_variant_id: String(newVariantId), _attached_unique_id: uniqueId, _attached_timestamp: String(uniqueTimestamp) };
                        $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json', data: { id: pick.id, quantity: 1, properties: attachedProps }, complete: function(){ fillOneSwap(remaining - 1); } });
                      };
                      fillOneSwap(deficit);
                      return;
                    }
                  } catch(e) {}
                  afterRemove();
                });
              }
            });
          } else {
            afterRemove();
          }
        },
        error: function(xhr){
          if (window.__CVM_DEBUG) { try { console.log('[CART_VARIANT_MODAL] change.js error, fallback remove+add', { status: xhr.status, response: xhr.responseText }); } catch(e) {} }
          // Fallback: remove exact line then add new variant
          var updates = {};
          if (targetLine && targetLine.key) { updates[targetLine.key] = 0; }
          var afterRemove = function(){
            $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json', data: { id: newVariantId, quantity: 1, properties: properties },
              success: function(){ reloadCart(function(){ showCartDrawerWithoutTransition(); optimizeBundleTiers(function(){ hideLoadingIndicator(); closeModal(); }); }, { suppressTransitions: true }); },
              error: function(){ hideLoadingIndicator(); }
            });
          };
          if (Object.keys(updates).length > 0) {
            $.ajax({ type: 'POST', url: '/cart/update.js', dataType: 'json', data: JSON.stringify({ updates: updates }), contentType: 'application/json', success: afterRemove, error: afterRemove });
          } else { afterRemove(); }
        }
      });
    });
  }
}

function cartUpsellVariantSelection() {
  if (!window.cr_upsell_product) {
    return;
  }

  var options = [];
  $(".cart-upselling-item-variants-select").each(function () {
    options.push({
      key:
        "option" +
        (window.cr_upsell_product.options.indexOf($(this).attr("name")) + 1),
      value: $(this).val(),
    });
  });

  var selectedVariant = window.cr_upsell_product.variants.find(function (
    variant
  ) {
    return options.every(function (values) {
      return variant[values.key] === values.value;
    });
  });

  if (selectedVariant) {
    if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
      $(".cart-upselling-item img")
        .attr("src", selectedVariant.featured_image.src)
        .removeAttr("data-srcset")
        .removeAttr("srcset");
    }

    $('#cart-upselling input[name="id"]').val(selectedVariant.id);

    // Apply smart discount logic like in Liquid template - only if source product is still in cart
    var $upselling = $('.cart-upselling');
    var fixedAmount = parseInt($upselling.attr('data-upsell-discount-amount')) || 0;
    var percentageAmount = parseInt($upselling.attr('data-upsell-discount-percentage')) || 0;
    
    var finalPrice = selectedVariant.price;
    var comparePrice = selectedVariant.price;
    
    // Check if source product is still in cart before applying discount
    var sourceProductStillInCart = false;
    var sourceProductIdInput = $('#cart-upselling input[name="properties[_upsell_source_product_id]"]');
    if (sourceProductIdInput.length > 0) {
      var sourceProductId = sourceProductIdInput.val();
      // Check current cart via AJAX to see if source product is still there
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        async: false, // Make synchronous for immediate result
        success: function(cart) {
          cart.items.forEach(function(item) {
            if (item.product_id.toString() === sourceProductId) {
              sourceProductStillInCart = true;
            }
          });
        }
      });
    }
    
    // Apply discount only if source product is still in cart
    if (sourceProductStillInCart) {
      // Smart logic: If fixed amount > 0 AND percentage = 0, use fixed
      if (fixedAmount > 0 && percentageAmount === 0) {
        finalPrice = Math.max(0, selectedVariant.price - fixedAmount);
('JS Applied FIXED discount:', fixedAmount, 'Final price:', finalPrice);
      } else if (percentageAmount > 0) {
        finalPrice = Math.floor(selectedVariant.price * (100 - percentageAmount) / 100);
('JS Applied PERCENTAGE discount:', percentageAmount + '%', 'Final price:', finalPrice);
      }
    } else {
('Source product not in cart - no discount applied');
    }

    // Update the product-upsell-price section
    if (finalPrice < comparePrice) {
      PriceFormatter.showPrice(
        ".product-upsell-price",
        finalPrice,
        comparePrice
      );
    } else {
      PriceFormatter.showPrice(
        ".product-upsell-price",
        selectedVariant.price,
        selectedVariant.compare_at_price
      );
    }

    $("#cart-upselling button").removeAttr("disabled");

    if (
      window.cr_upsell_product_variantStock.hasOwnProperty(
        selectedVariant.id
      ) &&
      window.cr_upsell_product_variantStock[selectedVariant.id] == 0
    ) {
      $("#cart-upselling button").attr("disabled", true);
    }
  }
}

// New: hierarchical availability filtering for cart upsell selects
function cartUpsellFilterOptions() {
  if (!window.cr_upsell_product) return;
  var product = window.cr_upsell_product;
  var selects = $(".cart-upselling-item-variants-select");
  if (!selects.length) return;
  var ordered = selects
    .toArray()
    .sort(function(a,b){
      var ai = product.options.indexOf($(a).attr('name')) + 1;
      var bi = product.options.indexOf($(b).attr('name')) + 1;
      return ai - bi;
    });
  var colorSelect = ordered.find(function(el){
    var name = ($(el).attr('name')||'').toLowerCase();
    return name.indexOf('color') !== -1;
  }) || ordered[0];
  ordered.forEach(function(selectEl){
    var $select = $(selectEl);
    var pos = product.options.indexOf($select.attr('name')) + 1;
    var constraints = (selectEl === colorSelect)
      ? []
      : [{ key: 'option' + (product.options.indexOf($(colorSelect).attr('name')) + 1), value: $(colorSelect).val() }];
    $select.find('option').each(function(){
      var value = $(this).val();
      var key = 'option' + pos;
      var allowed = product.variants.some(function(v){
        // inventory aware
        var tracked = v.inventory_management === 'shopify';
        var qtyOk = !tracked || (typeof v.inventory_quantity === 'number' ? v.inventory_quantity > 0 : true);
        var inStock = v.available && qtyOk;
        return inStock && v[key] === value && constraints.every(function(c){ return !c.value || v[c.key] === c.value; });
      });
      $(this).prop('disabled', !allowed).toggle(allowed);
      if (!allowed && $(this).is(':selected')) {
        var $firstAllowed = $select.find('option').filter(function(){ return !this.disabled && $(this).is(':visible'); }).first();
        if ($firstAllowed.length) $select.val($firstAllowed.val());
      }
    });
  });
}

// NEW FUNCTION: Update quantity for ALL line items of a specific variant
function updateCartItemQuantityForVariant(line, variantId, newQuantity) {
  // no global loader while cart drawer is open
  try { if (window.__CART_DRAWER_DIFF_MODE__ && parseInt(newQuantity) === 0) window.animateCollapseVariantLines?.(variantId); } catch(e) {}
  try { window.__CART_DRAWER_FORCE_OPEN__ = true; } catch(e) {}
  try { window.setCartItemLoading?.(line, true); } catch(e) {}
  try {
    if (window.__CART_DRAWER_DIFF_MODE__) {
      var $el = $(".cart-drawer-content .cart-drawer-item[data-line-index='" + line + "']");
      var key = $el.attr('data-line-key');
      CartDrawerState.state.pendingOp = { type: (parseInt(newQuantity)===0?'remove':'qty'), lineKey: key };
    }
  } catch(e) {}
  
('🎯 UPDATING VARIANT QUANTITY - variantId:', variantId, 'newQuantity:', newQuantity);

  var refreshCartCallback = function() {
    $.getJSON('/cart.js', function(afterCart){
      if (typeof window.safeReconcile === 'function') {
        window.safeReconcile(afterCart, function(){ try { window.setCartItemLoading?.(line, false); } catch(e) {} hideLoadingIndicator(); });
      } else {
        reloadCart(function(){ try { window.setCartItemLoading?.(line, false); } catch(e) {} hideLoadingIndicator(); }, { suppressTransitions: true });
      }
    });
  };

  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var currentItem = cart.items[line - 1];
      if (!currentItem) {
        hideLoadingIndicator();
        return;
      }
      
('📋 Processing variant update for:', currentItem.product_title, 'variant:', variantId);
      
      var updates = {};
      
      // Find ALL paid items with the same variant_id and product_id
      var sameVariantPaidItems = cart.items.filter(function(item) {
        return item.product_id === currentItem.product_id && 
               item.variant_id === parseInt(variantId) &&
               !item.properties._is_free_item && 
               !item.properties._attached_product && 
               !item.properties._is_upsell;
      });
      
('🔍 Found', sameVariantPaidItems.length, 'paid items with same variant:', variantId);
      
      if (parseInt(newQuantity) === 0) {
        // Remove ALL line items for this variant
        sameVariantPaidItems.forEach(function(item) {
('🗑️ Removing paid item line:', item.key, 'quantity:', item.quantity);
          updates[item.key] = 0;
        });
        
        // CRITICAL: Remove ALL attached items for this PRODUCT (not just this variant)
        // This is necessary for proper tier recalculation
        var allProductAttachedItems = cart.items.filter(function(item) {
          return item.properties && 
                 item.properties._attached_product === "true" && 
                 item.properties._source_product_id === currentItem.product_id.toString();
        });
        
('🧹 Removing ALL', allProductAttachedItems.length, 'attached items for tier recalculation');
        
        allProductAttachedItems.forEach(function(item) {
('🗑️ Removing attached item for tier recalculation:', item.product_title, 'key:', item.key);
          updates[item.key] = 0;
        });
        
      } else {
        // Distribute the new quantity across existing line items
        var targetQuantity = parseInt(newQuantity);
        var itemsToUpdate = [...sameVariantPaidItems]; // Create copy to work with
        
        // Sort by quantity (smallest first) for better distribution
        itemsToUpdate.sort(function(a, b) { return a.quantity - b.quantity; });
        
        var remainingQuantity = targetQuantity;
        
        for (var i = 0; i < itemsToUpdate.length; i++) {
          var item = itemsToUpdate[i];
          
          if (remainingQuantity <= 0) {
            // Remove excess line items
('🗑️ Removing excess line item:', item.key);
            updates[item.key] = 0;
          } else if (remainingQuantity >= item.quantity) {
            // Keep this line item as is
            remainingQuantity -= item.quantity;
('✅ Keeping line item:', item.key, 'quantity:', item.quantity);
          } else {
            // Adjust this line item to remaining quantity
('📝 Adjusting line item:', item.key, 'from', item.quantity, 'to', remainingQuantity);
            updates[item.key] = remainingQuantity;
            remainingQuantity = 0;
          }
        }
        
        // SMART APPROACH: Only remove attached items if we need to downgrade tiers
        // For increases, preserve existing attached items
        var allProductAttachedItems = cart.items.filter(function(item) {
          return item.properties && 
                 item.properties._attached_product === "true" && 
                 item.properties._source_product_id === currentItem.product_id.toString();
        });
        
        var currentAttachedCount = allProductAttachedItems.length;
        
        // Calculate what tier we'll be at after the update
        var futureProductQuantity = 0;
        var variantQuantityAlreadyAdded = false;
        
        cart.items.forEach(function(item) {
          if (item.product_id === currentItem.product_id && 
              !item.properties._is_free_item && 
              !item.properties._attached_product && 
              !item.properties._is_upsell) {
            if (sameVariantPaidItems.some(function(sameItem) { return sameItem.key === item.key; })) {
              // FIXED: Only add the target quantity ONCE for this entire variant, not per line item
              if (!variantQuantityAlreadyAdded) {
                futureProductQuantity += targetQuantity;
                variantQuantityAlreadyAdded = true;
('📊 Adding target quantity for variant:', targetQuantity, 'total so far:', futureProductQuantity);
              }
            } else {
              futureProductQuantity += item.quantity;
('📊 Adding other variant quantity:', item.quantity, 'total so far:', futureProductQuantity);
            }
          }
        });
        
        // Calculate target attached count for future quantity
        var futureTargetAttachedCount = 0;
        if (bundleConfigsForCallback) {
          var configs = bundleConfigsForCallback.split("|");
          configs.forEach(function(config) {
            var parts = config.split(":");
            if (parts.length >= 6) {
              var totalQty = parseInt(parts[0]);
              var freeCount = parseInt(parts[3]);
              var paidQty = totalQty - freeCount;
              
              if (futureProductQuantity >= paidQty && parts[4] && parts[4] !== "" && parts[4] !== "0") {
                futureTargetAttachedCount = Math.max(futureTargetAttachedCount, freeCount);
              }
            }
          });
        }
        
('🎯 SMART TIER MANAGEMENT:');
('   Future target attached count:', futureTargetAttachedCount);
('   Future paid quantity:', futureProductQuantity);
        
        if (currentAttachedCount > futureTargetAttachedCount) {
          // DOWNGRADE: Remove excess attached items
          var excessCount = currentAttachedCount - futureTargetAttachedCount;
('🔻 TIER DOWNGRADE: Removing', excessCount, 'excess attached items');
          
          for (var i = allProductAttachedItems.length - excessCount; i < allProductAttachedItems.length; i++) {
            if (allProductAttachedItems[i]) {
              updates[allProductAttachedItems[i].key] = 0;
            }
          }
        } else if (currentAttachedCount < futureTargetAttachedCount) {
          // UPGRADE: Keep existing attached items, will add more in tier recalculation
('🔺 TIER UPGRADE: Keeping existing', currentAttachedCount, 'attached items, will add', (futureTargetAttachedCount - currentAttachedCount), 'more');
        } else {
          // PERFECT MATCH: Keep all existing attached items
('✅ TIER MAINTAINED: Keeping all', currentAttachedCount, 'existing attached items unchanged');
        }
      }
      
      // FIXED: Capture bundleConfigs in the outer scope for use in callbacks
      var bundleConfigsForCallback = null;
      if (currentItem.properties && currentItem.properties._bundle_configs) {
        bundleConfigsForCallback = currentItem.properties._bundle_configs;
      }
      
('🔧 Bundle recalculation setup:', {
        newQuantity: newQuantity,
        hasBundleConfigs: !!bundleConfigsForCallback,
        bundleConfigs: bundleConfigsForCallback
      });
      
('💾 VARIANT UPDATE - Updates to apply:', updates);
      
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json", 
        data: JSON.stringify({ updates: updates }),
        contentType: "application/json",
        success: function() {
('✅ Variant quantity update successful');
          
          // DIRECT TIER RECALCULATION: Add correct attached items based on new total
('🔄 Recalculating bundle tier and adding correct attached items');
          
          // FIXED: Recalculate even when newQuantity is 0, as long as bundle configs exist
          if (bundleConfigsForCallback) {
('🎯 BUNDLE CONFIGS FOUND - Starting tier recalculation process');
            
            // Get fresh cart data to calculate total paid quantity
            $.ajax({
              type: "GET", 
              url: "/cart.js",
              dataType: "json",
              success: function(freshCart) {
('📋 Fresh cart retrieved for tier recalculation');
                // Calculate total paid quantity for this product after the update
                var totalPaidQty = 0;
                freshCart.items.forEach(function(item) {
                  if (item.product_id === currentItem.product_id && 
                      !item.properties._is_free_item && 
                      !item.properties._attached_product && 
                      !item.properties._is_upsell) {
                    totalPaidQty += item.quantity;
                  }
                });
                
('📊 Total paid quantity after update:', totalPaidQty);
                
                // Find the best qualifying bundle tier
                var configs = bundleConfigsForCallback.split("|");
                var bestConfig = null;
                
                configs.forEach(function(config) {
                  var parts = config.split(":");
                  if (parts.length >= 6) { // Need attached product info
                    var totalQty = parseInt(parts[0]);
                    var freeCount = parseInt(parts[3]);
                    var paidQty = totalQty - freeCount;
                    var attachedProductId = parts[4];
                    var attachedDiscount = parts[5];
                    
('🔍 Checking tier: ' + paidQty + '+' + freeCount + ' (need ' + paidQty + ' paid, have ' + totalPaidQty + ')');
                    
                    if (totalPaidQty >= paidQty && attachedProductId && attachedProductId !== "" && attachedProductId !== "0") {
                      if (!bestConfig || paidQty > bestConfig.paidQty) {
                        bestConfig = { 
                          freeCount: freeCount, 
                          paidQty: paidQty,
                          totalQty: totalQty,
                          attachedProductId: attachedProductId,
                          attachedDiscount: attachedDiscount
                        };
                      }
                    }
                  }
                });
                
                // Check how many attached items currently exist for this product
                var currentAttachedItems = freshCart.items.filter(function(item) {
                  return item.properties && 
                         item.properties._attached_product === "true" && 
                         item.properties._source_product_id === currentItem.product_id.toString();
                });
                
                var currentAttachedCount = currentAttachedItems.length;
                var targetAttachedCount = bestConfig ? bestConfig.freeCount : 0;
                
('🎯 TIER ANALYSIS:');
('   Total paid quantity:', totalPaidQty);
('   Target attached count:', targetAttachedCount);
('   Best tier:', bestConfig ? bestConfig.paidQty + '+' + bestConfig.freeCount : 'none');
                
                if (currentAttachedCount > targetAttachedCount) {
                  // TOO MANY attached items - remove excess
                  var excessCount = currentAttachedCount - targetAttachedCount;
('🗑️ REMOVING ' + excessCount + ' excess attached items (tier downgrade)');
                  
                  var excessUpdates = {};
                  
                  // Remove excess attached items (from the end)
                  for (var i = currentAttachedItems.length - excessCount; i < currentAttachedItems.length; i++) {
                    if (currentAttachedItems[i]) {
('🗑️ Removing excess attached item:', currentAttachedItems[i].product_title, 'key:', currentAttachedItems[i].key);
                      excessUpdates[currentAttachedItems[i].key] = 0;
                    }
                  }
                  
                  $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    dataType: "json",
                    data: JSON.stringify({ updates: excessUpdates }),
                    contentType: "application/json",
                    success: function() {
('✅ Excess attached items removed - tier downgrade complete');
                      reloadCart(refreshCartCallback);
                    },
                    error: function() {
('❌ Failed to remove excess attached items');
                      reloadCart(refreshCartCallback);
                    }
                  });
                  
                } else if (currentAttachedCount < targetAttachedCount && bestConfig) {
                  // TOO FEW attached items - preserve existing ones and add more
                  var neededCount = targetAttachedCount - currentAttachedCount;
('➕ ADDING ' + neededCount + ' more attached items (tier upgrade) - preserving existing selections');
                  
                  // CRITICAL: Don't change existing attached items - preserve user's original selections
('✅ Keeping existing', currentAttachedCount, 'attached items unchanged (preserve user selections)');
                  
                  // Add additional attached items to reach the target count
                  var addAttachedItemsForNewTier = function(index) {
                    if (index >= neededCount) {
('🎉 All needed attached items added for new tier');
                      reloadCart(refreshCartCallback);
                      return;
                    }
                    
                    var currentAttachedVariantId = parseInt(bestConfig.attachedProductId); // Default
                    
                    // For additional items, try to match with available paid items that don't have attached items yet
                    var remainingPaidItems = freshCart.items.filter(function(item) {
                      return item.product_id === currentItem.product_id && 
                             !item.properties._is_free_item && 
                             !item.properties._attached_product && 
                             !item.properties._is_upsell;
                    });
                    
                    // Try to find a paid item that doesn't have an attached item yet
                    var paidItemForNewAttached = null;
                    for (var p = 0; p < remainingPaidItems.length; p++) {
                      var paidItem = remainingPaidItems[p];
                      var hasAttachedItem = currentAttachedItems.some(function(attachedItem) {
                        return attachedItem.properties._source_variant_id === paidItem.variant_id.toString();
                      });
                      
                      if (!hasAttachedItem) {
                        paidItemForNewAttached = paidItem;
('🎯 Found paid item without attached item for new attached:', paidItem.variant_id);
                        break;
                      }
                    }
                    
                    // If we found a paid item without attached, try to match its variant
                    if (paidItemForNewAttached && window.cr_product && window.cr_product.variants && window.cr_attached_product_variants) {
                      var paidVariant = window.cr_product.variants.find(function(v) {
                        return v.id === paidItemForNewAttached.variant_id;
                      });
                      
                      if (paidVariant) {
                        var matchingAttachedVariant = window.cr_attached_product_variants.find(function(attachedVariant) {
                          var optionsMatch = true;
                          
                          if (paidVariant.option1 && attachedVariant.option1) {
                            optionsMatch = optionsMatch && (paidVariant.option1 === attachedVariant.option1);
                          }
                          if (paidVariant.option2 && attachedVariant.option2) {
                            optionsMatch = optionsMatch && (paidVariant.option2 === attachedVariant.option2);
                          }
                          if (paidVariant.option3 && attachedVariant.option3) {
                            optionsMatch = optionsMatch && (paidVariant.option3 === attachedVariant.option3);
                          }
                          
                          return optionsMatch && attachedVariant.available;
                        });
                        
                        if (matchingAttachedVariant) {
                          currentAttachedVariantId = matchingAttachedVariant.id;
('✅ Found matching attached variant for additional item:', matchingAttachedVariant.id);
                        }
                      }
                    }
                    
                    var uniqueTimestamp = Date.now() + index;
                    var uniqueId = uniqueTimestamp + '_tier_add_' + index + '_' + Math.random().toString(36).substr(2, 9);
                    
                    var addData = {
                      quantity: 1,
                      id: currentAttachedVariantId,
                      properties: {
                        _attached_product: "true",
                        _attached_discount: bestConfig.attachedDiscount + "%",
                        _source_product_id: currentItem.product_id.toString(),
                        _source_variant_id: paidItemForNewAttached ? paidItemForNewAttached.variant_id.toString() : "",
                        _attached_for_tier_slot: (currentAttachedCount + index + 1).toString(),
                        _attached_unique_id: uniqueId,
                        _attached_timestamp: uniqueTimestamp.toString(),
                        _user_selected_variant: "false", // This is auto-matched, not user-selected
                        _attached_variant_id: currentAttachedVariantId.toString()
                      }
                    };
                    
                    
                    $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      dataType: 'json',
                      data: addData,
                      success: function() {
                        addAttachedItemsForNewTier(index + 1);
                      },
                      error: function() {
('❌ Failed to add additional attached item ' + (index + 1) + '/' + neededCount);
                        addAttachedItemsForNewTier(index + 1);
                      }
                    });
                  };
                  
                  addAttachedItemsForNewTier(0);
                  
                } else if (currentAttachedCount === targetAttachedCount) {
('✅ Perfect tier match - no adjustments needed');
                  reloadCart(refreshCartCallback);
                } else {
('❌ No qualifying tier found for ' + totalPaidQty + ' paid items');
                  reloadCart(refreshCartCallback);
                }
              },
              error: function() {
('❌ Failed to get fresh cart for tier recalculation');
                reloadCart(refreshCartCallback);
              }
            });
          } else {
            // If no bundle configs, just reload cart
('❌ NO BUNDLE CONFIGS FOUND - skipping tier recalculation');
('bundleConfigsForCallback:', bundleConfigsForCallback);
            reloadCart(refreshCartCallback);
          }
        },
        error: function(xhr, status, error) {
('❌ Variant quantity update failed:', { status: status, error: error });
          reloadCart(refreshCartCallback);
        }
      });
    },
    error: function () {
('❌ Failed to get cart data for variant update');
      hideLoadingIndicator();
    }
  });
}

function updateCartItemQuantity(line, newQuantity) {
  // no global loader while cart drawer is open
  try { if (window.__CART_DRAWER_DIFF_MODE__ && parseInt(newQuantity) === 0) window.animateCollapseLineByIndex?.(line); } catch(e) {}
  try { window.__CART_DRAWER_FORCE_OPEN__ = true; } catch(e) {}
  try {
    if (window.__CART_DRAWER_DIFF_MODE__) {
      var $el = $(".cart-drawer-content .cart-drawer-item[data-line-index='" + line + "']");
      var key = $el.attr('data-line-key');
      CartDrawerState.state.pendingOp = { type: (parseInt(newQuantity)===0?'remove':'qty'), lineKey: key };
    }
  } catch(e) {}

  var refreshCartCallback = function() {
    $.getJSON('/cart.js', function(afterCart){
      if (typeof window.safeReconcile === 'function') {
        window.safeReconcile(afterCart, function(){ try { window.setCartItemLoading?.(line, false); } catch(e) {} hideLoadingIndicator(); });
      } else {
        reloadCart(function(){ try { window.setCartItemLoading?.(line, false); } catch(e) {} hideLoadingIndicator(); }, { suppressTransitions: true });
      }
    });
  };

  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
('=== CART UPDATE DEBUG START ===');
('Full cart items:', cart.items.map(function(item) {
        return {
          title: item.product_title,
          key: item.key,
          quantity: item.quantity,
          properties: item.properties
        };
      }));
      
      // --- FIX: Use the correct array index to find the item ---
      var currentItem = cart.items[line - 1];
      if (!currentItem) {
        hideLoadingIndicator();
        return;
      }

('Current item being updated:', {
        title: currentItem.product_title,
        key: currentItem.key,
        product_id: currentItem.product_id,
        quantity: currentItem.quantity,
        newQuantity: newQuantity,
        properties: currentItem.properties
      });

      // --- START: Handle variant-specific quantity updates (NO CONSOLIDATION) ---
      var finalTotalProductQuantity = parseInt(newQuantity);
      var updates = {};
      
      // Skip bundle logic entirely if this is an upsell item
      if (currentItem.properties && currentItem.properties._is_upsell === "true") {
        updates[currentItem.key] = parseInt(newQuantity);
      } else {
        // FIXED: Only update the specific clicked item, don't consolidate other variants
        // This preserves variant-specific relationships in multi-variant bundles
        updates[currentItem.key] = parseInt(newQuantity);
        
        // Calculate total paid quantity for this product (for bundle tier calculation)
        finalTotalProductQuantity = 0;
      cart.items.forEach(function(item) {
          if (item.product_id === currentItem.product_id && 
              !item.properties._is_free_item && 
              !item.properties._attached_product && 
              !item.properties._is_upsell) {
          if (item.key === currentItem.key) {
              // Count the new quantity for the clicked item
              finalTotalProductQuantity += parseInt(newQuantity);
          } else {
              // Count existing quantities for other variants
              finalTotalProductQuantity += item.quantity;
          }
        }
        });
        
('📊 Product quantity calculation - currentItem:', currentItem.product_title, 'newQty:', newQuantity, 'totalProductQty:', finalTotalProductQuantity);
      }
      // --- END: Handle variant-specific quantity updates ---
      var needsToAddAttached = false;
      var attachedVariantId = null;
      var attachedProductDiscount = 0;
      
      var targetGratisCount = 0;
      var bundleConfigs = null;

      // Skip bundle processing for upsell items
      if (currentItem.properties && currentItem.properties._is_upsell === "true") {
        // Just update the upsell item, no bundle logic needed
      } else {
      for (var prop in currentItem.properties) {
        if (prop === "_bundle_configs") {
          bundleConfigs = currentItem.properties[prop];
          break;
          }
        }
      }



      if (!bundleConfigs && currentItem.properties._is_upsell !== "true") {
        cart.items.forEach(function(otherItem) {
          if (otherItem.product_id === currentItem.product_id && 
              otherItem.properties && 
              otherItem.properties._bundle_configs &&
              !otherItem.properties._is_upsell) {
            bundleConfigs = otherItem.properties._bundle_configs;
            
            if (!currentItem.properties) {
              currentItem.properties = {};
            }
            currentItem.properties._bundle_configs = bundleConfigs;
            return false;
          }
        });
      }

      if (bundleConfigs && currentItem.properties._is_upsell !== "true") {
        var configs = bundleConfigs.split("|");
        var bestConfig = null;
        

        
        configs.forEach(function(config) {
          var parts = config.split(":");
          if (parts.length >= 4) {
            var totalQty = parseInt(parts[0]);
            var freeCount = parseInt(parts[3]);
            var paidQty = totalQty - freeCount;
            
            
            if (finalTotalProductQuantity >= paidQty) {
              if (!bestConfig || paidQty > bestConfig.paidQty || (paidQty === bestConfig.paidQty && freeCount > bestConfig.freeCount)) {
                bestConfig = { 
                  freeCount: freeCount, 
                  paidQty: paidQty,
                  totalQty: totalQty,
                  attachedProductId: parts.length >= 6 ? parts[4] : null,
                  attachedDiscount: parts.length >= 6 ? parts[5] : 0
                };
              }
            }
          }
        });
        
        if (bestConfig) {
          

          var shouldOptimize = false;
          
          var existingAttachedCount = cart.items.filter(function(item) {
            return item.properties &&
                   item.properties._attached_product === "true" &&
                   item.properties._source_product_id === currentItem.product_id.toString();
          }).length;
          
          var isExactBundleScenario = (
            existingAttachedCount === 0 && 
            finalTotalProductQuantity === bestConfig.totalQty && 
            bestConfig.paidQty === 1 && 
            bestConfig.freeCount > 0 
          );
          
          if (isExactBundleScenario) {
            shouldOptimize = true;
          }
          
          if (shouldOptimize) {
            updates[currentItem.key] = bestConfig.paidQty;
            finalTotalProductQuantity = bestConfig.paidQty;
          }
          
          if (bestConfig.attachedProductId && bestConfig.attachedProductId !== '' && bestConfig.attachedProductId !== '0') {
            attachedVariantId = parseInt(bestConfig.attachedProductId);
            attachedProductDiscount = bestConfig.attachedDiscount;
            
          // For display and per-line updates, target attached equals best tier's freeCount (not multiples)
          var completeBundlesForAdd = Math.floor(finalTotalProductQuantity / bestConfig.paidQty);
          targetGratisCount = bestConfig.freeCount;
          } else {
            var completeBundlesForNoAttach = Math.floor(finalTotalProductQuantity / bestConfig.paidQty);
            targetGratisCount = bestConfig.freeCount;
          }
        } else {
          targetGratisCount = 0;
        }
      }
      
      if (parseInt(newQuantity) === 0) {
        if (finalTotalProductQuantity <= 0) {
            targetGratisCount = 0;
        }
      }

      if (currentItem.properties && currentItem.properties._is_upsell === "true") {
        // Skip attached product logic for upsell items
      } else {
        

        
        
        if (parseInt(newQuantity) === 0) {
          
          var variantSpecificAttachedItems = cart.items.filter(function(item) {
            return item.properties && 
                   item.properties._attached_product === "true" && 
                   item.properties._source_variant_id === currentItem.variant_id.toString();
          });
          
          
          variantSpecificAttachedItems.forEach(function(item) {
            updates[item.key] = 0;
          });
          
          // Preserve product-level attached items; they will be normalized based on tier

          // After removing variant-specific attachments, ensure we still meet targetGratisCount for the product
          var remainingProductAttached = cart.items.filter(function(item) {
            return item.properties &&
                   item.properties._attached_product === "true" &&
                   item.properties._source_product_id === currentItem.product_id.toString() &&
                   item.properties._source_variant_id !== currentItem.variant_id.toString();
          }).length;

          // Trim excess attached items if tier downgraded (e.g., 3+3 → 2+1)
          if (typeof targetGratisCount !== 'undefined') {
            var remainingAttachedItemsList = cart.items.filter(function(item) {
              return item.properties &&
                     item.properties._attached_product === "true" &&
                     item.properties._source_product_id === currentItem.product_id.toString() &&
                     item.properties._source_variant_id !== currentItem.variant_id.toString();
            });
            var currentRemainingAttached = remainingAttachedItemsList.length;
            if (currentRemainingAttached > targetGratisCount) {
              var excessToRemove = currentRemainingAttached - targetGratisCount;
              for (var ri = remainingAttachedItemsList.length - 1; ri >= 0 && excessToRemove > 0; ri--) {
                var ritm = remainingAttachedItemsList[ri];
                if (ritm && !updates.hasOwnProperty(ritm.key)) {
                  updates[ritm.key] = 0;
                  excessToRemove--;
                }
              }
            }
          }

          if (typeof targetGratisCount !== 'undefined' && targetGratisCount > remainingProductAttached) {
            var needToAdd = targetGratisCount - remainingProductAttached;
            if (attachedVariantId) {
              needsToAddAttached = true;
              targetGratisCount = needToAdd; // number of items to add
            }
          }
          

          var remainingPaidItems = cart.items.filter(function(item) {
            return !item.properties._is_free_item && 
                   !item.properties._attached_product && 
                   !item.properties._is_upsell &&
                   item.key !== currentItem.key;
          });
          
          if (remainingPaidItems.length === 0) {
            
            var allAttachedItems = cart.items.filter(function(item) {
              return item.properties && 
                     (item.properties._attached_product === "true" || item.properties._is_free_item === "true");
            });
            
            allAttachedItems.forEach(function(item) {
              updates[item.key] = 0;
            });
          }
          
        } else {
          
          var allProductAttachedItems = cart.items.filter(function(item) {
            return item.properties && 
                   item.properties._attached_product === "true" && 
                   item.properties._source_product_id === currentItem.product_id.toString();
          });
          
          var currentAttachedCount = allProductAttachedItems.length;
          
          
          // SAFEGUARD: Ensure targetGratisCount honors qualifying tier for current total paid
          if (typeof bestConfig !== 'undefined' && bestConfig && typeof finalTotalProductQuantity !== 'undefined') {
            if (finalTotalProductQuantity >= bestConfig.paidQty && targetGratisCount < bestConfig.freeCount) {
              targetGratisCount = bestConfig.freeCount;
            }
          }

          if (currentAttachedCount > targetGratisCount) {
            var excessCount = currentAttachedCount - targetGratisCount;
            
            for (var i = allProductAttachedItems.length - excessCount; i < allProductAttachedItems.length; i++) {
              if (allProductAttachedItems[i]) {
                updates[allProductAttachedItems[i].key] = 0;
              }
            }
          } else if (currentAttachedCount < targetGratisCount) {
            var neededCount = targetGratisCount - currentAttachedCount;
            
            if (attachedVariantId) {
          needsToAddAttached = true;
              targetGratisCount = neededCount;
            }
        } else {

            needsToAddAttached = false;
          }
        }
      }
      
      function performCartUpdates() {
        
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: JSON.stringify({ updates: updates }),
          contentType: "application/json",
          success: function(response) {
            
            if (needsToAddAttached && attachedVariantId && targetGratisCount > 0) {
              
              var addAttachedItemsSequentially = function(index) {
                if (index >= targetGratisCount) {
                  reloadCart(refreshCartCallback);
                  return;
                }
                
                var currentAttachedVariantId = attachedVariantId;
                
                if (window.cr_attached_product_variants && currentItem.variant_id) {
                  var currentPaidVariant = null;
                  if (window.cr_product && window.cr_product.variants) {
                    currentPaidVariant = window.cr_product.variants.find(function(v) {
                      return v.id === currentItem.variant_id;
                    });
                  }
                  
                  if (currentPaidVariant) {
                    var matchingAttachedVariant = window.cr_attached_product_variants.find(function(attachedVariant) {
                      var optionsMatch = true;
                      
                      if (currentPaidVariant.option1 && attachedVariant.option1) {
                        optionsMatch = optionsMatch && (currentPaidVariant.option1 === attachedVariant.option1);
                      }
                      if (currentPaidVariant.option2 && attachedVariant.option2) {
                        optionsMatch = optionsMatch && (currentPaidVariant.option2 === attachedVariant.option2);
                      }
                      if (currentPaidVariant.option3 && attachedVariant.option3) {
                        optionsMatch = optionsMatch && (currentPaidVariant.option3 === attachedVariant.option3);
                      }
                      
                      return optionsMatch && attachedVariant.available;
                    });
                    
                    if (matchingAttachedVariant) {
                      currentAttachedVariantId = matchingAttachedVariant.id;
                    }
                  }
                }
                
                var uniqueTimestamp = Date.now();
                var uniqueId = uniqueTimestamp + '_attached_update_' + (index + 1) + '_' + Math.random().toString(36).substr(2, 9);
                
              var data = {
                  quantity: 1,
                  id: currentAttachedVariantId,
                  properties: {
                    _attached_product: "true",
                    _attached_discount: attachedProductDiscount + "%",
                    _source_product_id: currentItem.product_id.toString(),
                    _source_variant_id: currentItem.variant_id.toString(),
                    _attached_for_free_slot: (index + 1).toString(),
                    _attached_unique_id: uniqueId, 
                    _attached_timestamp: uniqueTimestamp.toString()
                  }
                };
                
                
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function() {
                    addAttachedItemsSequentially(index + 1);
                },
                error: function() {
                    addAttachedItemsSequentially(index + 1);
                }
              });
              };
              
              addAttachedItemsSequentially(0);
            } else {
              reloadCart(refreshCartCallback);
            }
          },
          error: function(xhr, status, error) {
            reloadCart(refreshCartCallback);
          }
        });
      }
      
      performCartUpdates();
    },
    error: function () {
      hideLoadingIndicator();
    }
  });
}

function renderCartDrawer(sectionsHtml, callback) {
  if (sectionsHtml) {
    var $drawer = $("#shopify-section-cart-drawer");
    var $content = $(".cart-drawer-content", $drawer);
    var suppress = window.__CVM_SUPPRESS_CART_TRANSITIONS === true;
    var hadNoTransition = $content && $content.length ? $content.hasClass("no-transition") : true;
    if (suppress && $content && $content.length && !hadNoTransition) { $content.addClass("no-transition"); }

    $("#shopify-section-cart-drawer").replaceWith(sectionsHtml);

    if ($(".template-cart").length > 0) {
      $("main .shopify-section").replaceWith(sectionsHtml);
    }

    initCart();
    if (typeof initCartVariantEditorModal === 'function') { initCartVariantEditorModal(); }

    var totalQuantity = parseInt(
      $(".cart-drawer-content").attr("data-item-count")
    );
    $("#header-cart-drawer-item-count").text(totalQuantity);

    if (parseInt(totalQuantity) > 0) {
      $("#header-cart-drawer-item-count").show();
      $("#header-cart-drawer-item-count").removeClass("hide");
    } else {
      $("#header-cart-drawer-item-count").hide();
    }

    if (callback) { callback(); }
    if (suppress && $content && $content.length && !hadNoTransition) { setTimeout(function(){ $(".cart-drawer-content").removeClass("no-transition"); }, 0); }
  } else {
    window.location.href = '/cart';
  }
}


// Batch add attached items in a single request to speed up fills
function addAttachedItemsBatch(productIdStr, sourceVariantIdStr, count, templateProps, done) {
  try {
    if (count <= 0) { if (typeof done === 'function') done(); return; }
    if (!(window.cr_attached_product_variants && window.cr_attached_product_variants[0] && window.cr_attached_product_variants[0].id)) {
      if (typeof done === 'function') done(); return;
    }
    var pickId = window.cr_attached_product_variants[0].id;
    var items = [];
    for (var i = 0; i < count; i++) {
      var uniqueTimestamp = Date.now() + i;
      var uniqueId = uniqueTimestamp + '_attached_batch_' + Math.random().toString(36).substr(2, 9);
      var props = {
        _attached_product: 'true',
        _attached_discount: (templateProps && templateProps._attached_discount) ? templateProps._attached_discount : '0%',
        _source_product_id: productIdStr,
        _source_variant_id: String(sourceVariantIdStr || ''),
        _attached_unique_id: uniqueId,
        _attached_timestamp: String(uniqueTimestamp)
      };
      items.push({ id: pickId, quantity: 1, properties: props });
    }
    $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json', data: { items: items }, complete: function(){ if (typeof done === 'function') done(); } });
  } catch(e) { if (typeof done === 'function') done(); }
}

function reloadCart(callback, options) {
  options = options || {};
  var suppressTransitions = options.suppressTransitions === true;
  var wasOpen = false;
  try {
    var vis = $("#cart-drawer").css("visibility");
    var op = parseFloat($("#cart-drawer-overlay").css("opacity")) || 0;
    wasOpen = (vis === "visible") || (op > 0.01);
  } catch(e) {}
  $.ajax({
    type: "GET",
    url: "/?sections=cart-drawer",
    dataType: "json",
    success: function (data) {
      
      if (data && data["cart-drawer"]) {
        var prev = window.__CVM_SUPPRESS_CART_TRANSITIONS;
        window.__CVM_SUPPRESS_CART_TRANSITIONS = suppressTransitions;
        renderCartDrawer(data["cart-drawer"], callback);
        window.__CVM_SUPPRESS_CART_TRANSITIONS = prev;
        try {
          if (wasOpen || window.__CART_DRAWER_FORCE_OPEN__) {
            showCartDrawerWithoutTransition();
            window.__CART_DRAWER_FORCE_OPEN__ = false;
          }
        } catch(e) {}
      } else {
        if (isGermanShop()) {
          alert(
            "Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal."
          );
        } else {
          alert("An error has occurred. Please try again.");
        }
      }
    },
    error: function () {
      if (isGermanShop()) {
        alert("Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.");
      } else {
        alert("An error has occurred. Please try again.");
      }
    }
  });
}

function handleCollectionPage() {
  var currentPage = 1;
  var allowFetchPages = true;
  var isLoading = false;

  $(window).scroll(function () {
    if (!allowFetchPages || isLoading) {
      return;
    }

    var scrollPosition = $(window).scrollTop() + window.screen.height * 1.3;
    var gridBottom =
      $(".collection-product-grid").offset().top +
      $(".collection-product-grid").height();

    if (scrollPosition < gridBottom) {
      return;
    }

    currentPage++;
    isLoading = true;

    $(".collection-product-grid-loading").show();

    $.ajax({
      url: "?page=" + currentPage,
      success: function (data) {
        $(".collection-product-grid-loading").hide();
        isLoading = false;

        if (!data) {
          return;
        }

        var html = $(data);
        if (html.find(".card-product").length > 0) {
          $(".collection-product-grid-cards").append(
            html.find(".collection-product-grid-cards").html()
          );
          return;
        }

        allowFetchPages = false;
      },
      error: function () {
        $(".collection-product-grid-loading").hide();
        isLoading = false;
      },
    });
  });
}

function initSearchPopup() {
  $("#search-popup .search-popup-header input").on("input", function () {
    if ($(this).val() == "") {
      $(".search-popup-contents").empty();
      return;
    }

    showLoadingIndicator();

    $.ajax({
      url:
        "/search/suggest?q=" + $(this).val() + "&section_id=search-predictive",
      success: function (data) {
        $(".search-popup-contents").empty();
        $(".search-popup-contents").html(data);

        hideLoadingIndicator();
      },
    });
  });

  $("#search-popup .search-popup-header svg:last-child").click(
    closeSearchPopup
  );
}

function handleSections(containerId) {
  if (containerId) {
    containerId = "#" + containerId + " ";
  } else {
    containerId = "";
  }

  $(containerId + ".collapsible-content-row-header").click(function () {
    $(this).find("svg").css("rotate", "90deg");
    $(this).find("h3 span:last-child").text("-");
    $(this).next().toggle();

    if ($(this).next().css("display") == "none") {
      $(this).find("svg").css("rotate", "0deg");
      $(this).find("h3 span:last-child").text("+");
    }
  });

  $(containerId + ".section-collection-cards").each(function () {
    if ($(this).attr("data-use-slider") != "true") {
      return true;
    }

    var config = {
      slidesPerView: parseFloat($(this).attr("data-product-count-mobile")),
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: parseFloat($(this).attr("data-product-count-desktop")),
        },
      },
    };

    if (
      $(this).attr("data-show-navigation") == "true" &&
      $(this).attr("data-use-slider") == "true"
    ) {
      config.navigation = {
        nextEl: $(this).find(".swiper-button-next")[0],
        prevEl: $(this).find(".swiper-button-prev")[0],
      };
    }

    new Swiper($(this)[0], config);
  });

  new Swiper(containerId + ".custom-reviews-cards", {
    loop: true,
    navigation: {
      nextEl: containerId + ".custom-reviews-cards .swiper-button-next",
      prevEl: containerId + ".custom-reviews-cards .swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  $(containerId + ".video-banner").each(function () {
    if ($(this).find("video").length == 0) {
      return;
    }

    videoBannerVideoLoaded($(this), $(this).find("video"));
  });

  $(containerId + ".selling-point-slider").each(function () {
    new Swiper($(this)[0], {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: parseInt($(this).attr("data-slideshow-speed")) * 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: parseInt($(this).attr("data-desktop-slides-per-view")),
        },
      },
    });
  });

  $(containerId + ".bundle button").click(function () {
    var variants = bundleGetSelectedVariants(containerId);
    if (!variants || $(this).attr("disabled")) {
      return;
    }

    showLoadingIndicator();

    var data = {
      form_type: "product",
      items: [
        {
          id: variants.first.id,
          quantity: 1,
        },
        {
          id: variants.second.id,
          quantity: 1,
        },
      ],
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: data,
      success: function () {
        reloadCart(function () {
          openCartDrawer();

          hideLoadingIndicator();
        });
      },
      error: function (response) {
        hideLoadingIndicator();

        if (
          response &&
          response.responseJSON &&
          response.responseJSON.description
        ) {
          alert(
            response.responseJSON.message +
              "\n\n" +
              response.responseJSON.description
          );
        } else {
          if (isGermanShop()) {
            alert(
              "Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal."
            );
          } else {
            alert("An error has occurred. Please try again.");
          }
        }
      },
    });
  });

  var updateVariants = function () {
    var variants = bundleGetSelectedVariants(containerId);
    if (!variants) {
      return;
    }

    var total = variants.first.price + variants.second.price;

    var discountType = $(containerId + ".bundle .bundle-add-to-cart").attr(
      "data-discount-type"
    );
    var discountValue = parseInt(
      $(containerId + ".bundle .bundle-add-to-cart").attr("data-discount-value")
    );
    var bundleTotal = variants.first.price;

    if (discountType == "percentage") {
      if (discountValue > 100) {
        discountValue = 100;
      }

      bundleTotal += parseInt(
        Math.trunc(variants.second.price * ((100 - discountValue) / 100))
      );
    } else {
      bundleTotal += parseInt(
        Math.trunc(variants.second.price - discountValue)
      );
    }

    if (variants.first.featured_image && variants.first.featured_image.src) {
      $(containerId + ".bundle .bundle-product:eq(0) .bundle-product-image img")
        .attr("src", variants.first.featured_image.src)
        .removeAttr("data-srcset")
        .removeAttr("srcset");
    }
    if (variants.second.featured_image && variants.second.featured_image.src) {
      $(containerId + ".bundle .bundle-product:eq(1) .bundle-product-image img")
        .attr("src", variants.second.featured_image.src)
        .removeAttr("data-srcset")
        .removeAttr("srcset");
    }

    PriceFormatter.showPrice(
      containerId + ".bundle .bundle-product:eq(0)",
      (variants.first.price * bundleTotal) / total,
      variants.first.price
    );
    PriceFormatter.showPrice(
      containerId + ".bundle .bundle-product:eq(1)",
      bundleTotal - Math.trunc((variants.first.price * bundleTotal) / total),
      variants.second.price
    );

    var anyOutOfStock = false;

    if (cr_bundle_product_1_variantStock.hasOwnProperty(variants.first.id)) {
      $(
        containerId + ".bundle .bundle-product:eq(0) .bundle-product-available"
      )[
        cr_bundle_product_1_variantStock[variants.first.id] > 0
          ? "addClass"
          : "removeClass"
      ]("in-stock");
      $(
        containerId + ".bundle .bundle-product:eq(0) .bundle-product-available"
      )[
        cr_bundle_product_1_variantStock[variants.first.id] == 0
          ? "addClass"
          : "removeClass"
      ]("out-of-stock");

      anyOutOfStock =
        cr_bundle_product_1_variantStock[variants.first.id] == 0 &&
        !Object.keys(cr_bundle_product_1_variantStock).some(function (
          variantId
        ) {
          var variant = cr_bundle_product_1.variants.find(function (v) {
            return v.id == variantId;
          });
          if (!variant) return false;

          var isSameProduct = true;
          cr_bundle_product_1.options.forEach(function (option, index) {
            if (
              option.toLowerCase().includes("size") ||
              option.toLowerCase().includes("größe")
            ) {
              return;
            }

            var optionKey = "option" + (index + 1);
            if (variant[optionKey] !== variants.first[optionKey]) {
              isSameProduct = false;
            }
          });

          return (
            isSameProduct && cr_bundle_product_1_variantStock[variantId] > 0
          );
        });
    } else {
      $(containerId + ".bundle .bundle-product:eq(0) .bundle-product-available")
        .addClass("in-stock")
        .removeClass("out-of-stock");
    }

    if (cr_bundle_product_2_variantStock.hasOwnProperty(variants.second.id)) {
      $(
        containerId + ".bundle .bundle-product:eq(1) .bundle-product-available"
      )[
        cr_bundle_product_2_variantStock[variants.second.id] > 0
          ? "addClass"
          : "removeClass"
      ]("in-stock");
      $(
        containerId + ".bundle .bundle-product:eq(1) .bundle-product-available"
      )[
        cr_bundle_product_2_variantStock[variants.second.id] == 0
          ? "addClass"
          : "removeClass"
      ]("out-of-stock");

      var secondProductOutOfStock =
        cr_bundle_product_2_variantStock[variants.second.id] == 0 &&
        !Object.keys(cr_bundle_product_2_variantStock).some(function (
          variantId
        ) {
          var variant = cr_bundle_product_2.variants.find(function (v) {
            return v.id == variantId;
          });
          if (!variant) return false;

          var isSameProduct = true;
          cr_bundle_product_2.options.forEach(function (option, index) {
            if (
              option.toLowerCase().includes("size") ||
              option.toLowerCase().includes("größe")
            ) {
              return;
            }

            var optionKey = "option" + (index + 1);
            if (variant[optionKey] !== variants.second[optionKey]) {
              isSameProduct = false;
            }
          });

          return (
            isSameProduct && cr_bundle_product_2_variantStock[variantId] > 0
          );
        });

      anyOutOfStock = anyOutOfStock || secondProductOutOfStock;
    } else {
      $(containerId + ".bundle .bundle-product:eq(1) .bundle-product-available")
        .addClass("in-stock")
        .removeClass("out-of-stock");
    }

    PriceFormatter.showPrice(
      containerId + ".bundle .bundle-add-to-cart",
      bundleTotal,
      total
    );

    $(
      containerId +
        ".bundle .bundle-add-to-cart .bundle-add-to-cart-price-saved span"
    ).text(Math.trunc(100 - (bundleTotal / total) * 100) + "%");

    var button = $(containerId + ".bundle .bundle-add-to-cart button");
    button[anyOutOfStock ? "attr" : "removeAttr"]("disabled", "disabled");

    if (anyOutOfStock) {
      button.text(button.attr("data-sold-out-text"));
    } else {
      button.text(button.attr("data-available-text"));
    }
  };
  $(containerId + ".bundle select").change(updateVariants);
  updateVariants();
}

function bundleGetSelectedVariants(containerId) {
  if (!window.cr_bundle_product_1 || !window.cr_bundle_product_2) {
    return null;
  }

  var options = [];
  $(containerId + ".bundle-product")
    .eq(0)
    .find("select")
    .each(function () {
      options.push({
        key:
          "option" +
          (cr_bundle_product_1.options.indexOf($(this).attr("name")) + 1),
        value: $(this).val(),
      });
    });

  var variant_1 = cr_bundle_product_1.variants.find(function (variant) {
    return options.every(function (values) {
      return variant[values.key] === values.value;
    });
  });

  options = [];
  $(containerId + ".bundle-product")
    .eq(1)
    .find("select")
    .each(function () {
      options.push({
        key:
          "option" +
          (cr_bundle_product_2.options.indexOf($(this).attr("name")) + 1),
        value: $(this).val(),
      });
    });

  var variant_2 = cr_bundle_product_2.variants.find(function (variant) {
    return options.every(function (values) {
      return variant[values.key] === values.value;
    });
  });

  if (!variant_1 || !variant_2) {
    return null;
  }

  return {
    first: variant_1,
    second: variant_2,
  };
}

function videoBannerVideoLoaded(videoBanner, video) {
  if (video[0].readyState != 4) {
    setTimeout(function () {
      videoBannerVideoLoaded(videoBanner, video);
    }, 50);
    return;
  }

  videoBanner.css(
    "padding-bottom",
    (video.height() / video.width()) * 100 + "%"
  );
}

function optimizeBundleTiers(callback) {
  if (typeof callback !== 'function') {
    return;
  }
  
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function(cart) {
      if (cart.items.length < 3) {
        if (callback) callback();
        return;
      }
      
      let productCounts = {};
      let hasBundleDuplicates = false;
      let productIdHasOnePlusOne = {};
      
      cart.items.forEach(function(item) {
        if (item.properties._bundle_configs && !item.properties._is_free_item && !item.properties._attached_product && !item.properties._is_upsell) {
          productCounts[item.product_id] = (productCounts[item.product_id] || 0) + item.quantity;

          // Detect if this product has a 1+1 tier in its bundle configs
          if (!productIdHasOnePlusOne[item.product_id]) {
            let configs = String(item.properties._bundle_configs).split('|');
            for (let i = 0; i < configs.length; i++) {
              let parts = configs[i].split(':');
              if (parts.length >= 4) {
                let totalQty = parseInt(parts[0]);
                let freeCount = parseInt(parts[3]);
                let paidQty = totalQty - freeCount;
                if (paidQty === 1 && freeCount > 0) {
                  productIdHasOnePlusOne[item.product_id] = true;
                  break;
                }
              }
            }
          }
        }
      });
      
      Object.values(productCounts).forEach(function(count) {
        if (count >= 4) { 
          hasBundleDuplicates = true;
        }
      });

      // Also optimize when there are duplicates for 1+1 tiers (e.g., 2 paid added separately)
      Object.keys(productCounts).forEach(function(pid) {
        let pidNum = parseInt(pid);
        if (productIdHasOnePlusOne[pidNum] && productCounts[pidNum] >= 2) {
          hasBundleDuplicates = true;
        }
      });
      
      if (!hasBundleDuplicates) {
        if (callback) callback();
        return;
      }
      
      let needsOptimization = false;
      let addsToPerform = [];
      let updates = {};
      
      let productGroups = {};
      
      cart.items.forEach(function(item) {
        if (item.properties._is_free_item || item.properties._attached_product || item.properties._is_upsell) {
          return;
        }
        
        let productId = item.product_id;
        if (!productGroups[productId]) {
          productGroups[productId] = {
            paidItems: [],
            bundleConfigs: null,
            totalPaidQty: 0
          };
        }
        
        productGroups[productId].paidItems.push(item);
        productGroups[productId].totalPaidQty += item.quantity;
        
        if (item.properties._bundle_configs && !productGroups[productId].bundleConfigs) {
          productGroups[productId].bundleConfigs = item.properties._bundle_configs;
        }
      });
      
      Object.values(productGroups).forEach(function(group) {
        if (!group.bundleConfigs) return;
        
        let configs = group.bundleConfigs.split('|');
        let qualifyingTiers = [];
        
        configs.forEach(function(config) {
          let parts = config.split(':');
          if (parts.length >= 4) {
            let totalQty = parseInt(parts[0]);
            let freeCount = parseInt(parts[3]);
            let paidQty = totalQty - freeCount;
            
            if (group.totalPaidQty >= paidQty) {
              qualifyingTiers.push({
                config: config,
                paidQty: paidQty,
                freeQty: freeCount,
                totalQty: totalQty
              });
            }
          }
        });
        
        qualifyingTiers.sort(function(a, b) {
          if (a.freeQty !== b.freeQty) {
            return b.freeQty - a.freeQty; 
          }
          return a.paidQty - b.paidQty; 
        });
        
        if (qualifyingTiers.length > 0) {
          let bestTier = qualifyingTiers[0];
          
          if (bestTier.paidQty < group.totalPaidQty) {
            needsOptimization = true;
            
            // Do not trim paid items; only normalize attached items per product
            // Normalize attached items per product: keep exactly the desired attached count at qty 1, remove the rest
            let productIdForGroup = (group.paidItems.length > 0) ? group.paidItems[0].product_id : null;
            if (productIdForGroup) {
              // Collect attached items linked to this product via _source_product_id
              let attachedItemsForProduct = cart.items.filter(function(item) {
                return item.properties &&
                       item.properties._attached_product === "true" &&
                       item.properties._source_product_id === String(productIdForGroup);
              });

              // Stable ordering: by timestamp, then by key
              attachedItemsForProduct.sort(function(a, b) {
                let ta = a.properties && a.properties._attached_timestamp ? parseInt(a.properties._attached_timestamp) : 0;
                let tb = b.properties && b.properties._attached_timestamp ? parseInt(b.properties._attached_timestamp) : 0;
                if (ta !== tb) return ta - tb;
                return a.key > b.key ? 1 : (a.key < b.key ? -1 : 0);
              });

              // Compute desired attached count: use only best tier's free count (no multiples),
              // so 1+1 twice -> 1 attached, 3+3 twice -> 3 attached
              let desiredAttachedCount = bestTier.freeQty;

              attachedItemsForProduct.forEach(function(item, idx) {
                if (idx < desiredAttachedCount) {
                  updates[item.key] = 1;
                } else {
                  updates[item.key] = 0;
                }
              });
            }
          }

          // Ensure we have enough attached items even when paidQty equals tier paidQty
          // Determine current attached items for this product
          let productIdForGroupAlways = (group.paidItems.length > 0) ? group.paidItems[0].product_id : null;
          if (productIdForGroupAlways) {
            let currentAttachedForProduct = cart.items.filter(function(item) {
              return item.properties &&
                     item.properties._attached_product === "true" &&
                     item.properties._source_product_id === String(productIdForGroupAlways);
            });

            // Desired attached count equals best tier freeQty (no multiples)
            let desiredCount = bestTier.freeQty;
            if (currentAttachedForProduct.length < desiredCount) {
              let missing = desiredCount - currentAttachedForProduct.length;

              // Parse attached variant id and discount from best tier config
              let parts = bestTier.config.split(':');
              let attachedVariantId = parts.length >= 5 ? parseInt(parts[4]) : null;
              let attachedDiscount = parts.length >= 6 ? parts[5] : 0;

              if (attachedVariantId) {
                // Build a list of paid variant_ids without an attached item yet
                let existingSourceIds = new Set(
                  currentAttachedForProduct
                    .map(function(att) { return att.properties && att.properties._source_variant_id; })
                    .filter(function(v) { return !!v; })
                );

                let paidVariantsWithoutAttached = group.paidItems
                  .map(function(pi) { return pi.variant_id; })
                  .filter(function(vid) { return !existingSourceIds.has(String(vid)); });

                for (let i = 0; i < missing; i++) {
                  let uniqueTimestamp = Date.now();
                  let uniqueId = uniqueTimestamp + '_attached_opt_' + i + '_' + Math.random().toString(36).substr(2, 9);
                  let sourceVariantId = paidVariantsWithoutAttached[i] ? String(paidVariantsWithoutAttached[i]) : '';

                  addsToPerform.push({
                    quantity: 1,
                    id: attachedVariantId,
                    properties: {
                      _attached_product: "true",
                      _attached_discount: attachedDiscount + "%",
                      _source_product_id: String(productIdForGroupAlways),
                      _source_variant_id: sourceVariantId,
                      _attached_unique_id: uniqueId,
                      _attached_timestamp: String(uniqueTimestamp)
                    }
                  });
                }

                needsOptimization = true;
              }
            }
          }
        }
      });
      
      function processAddQueue(index) {
        if (!addsToPerform || addsToPerform.length === 0) {
          if (callback) callback();
          return;
        }
        if (index >= addsToPerform.length) {
          if (callback) callback();
          return;
        }
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: addsToPerform[index],
          success: function() { processAddQueue(index + 1); },
          error: function() { processAddQueue(index + 1); }
        });
      }

      if (needsOptimization && Object.keys(updates).length > 0) {
        for (let key in updates) {
          if (isNaN(updates[key]) || updates[key] < 0) {
            delete updates[key];
          }
        }
        
        if (Object.keys(updates).length === 0) {
          if (addsToPerform.length > 0) {
            processAddQueue(0);
          } else if (callback) callback();
          return;
        }
        
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: JSON.stringify({ updates: updates }),
          contentType: "application/json",
          success: function() {
            if (addsToPerform.length > 0) {
              processAddQueue(0);
            } else if (callback) callback();
          },
          error: function() {
            if (addsToPerform.length > 0) {
              processAddQueue(0);
            } else if (callback) callback();
          }
        });
      } else if (needsOptimization && addsToPerform.length > 0) {
        processAddQueue(0);
      } else {
        if (callback) callback();
      }
    },
    error: function() {
      if (callback) callback();
    }
  });
}

// CART DRAWER DIFF MODE (feature-flagged)
window.__CART_DRAWER_DIFF_MODE__ = (window.__CART_DRAWER_DIFF_MODE__ !== undefined) ? window.__CART_DRAWER_DIFF_MODE__ : true;
window.__CART_DRAWER_FORCE_OPEN__ = window.__CART_DRAWER_FORCE_OPEN__ || false;

var CartDrawerState = (function(){
	var state = {
		lastCartJson: null,
		lineKeyToEl: new Map(),
		isInitialized: false
	};
	function snapshotDom() {
		try {
			state.lineKeyToEl.clear();
			$(".cart-drawer-content .cart-drawer-item").each(function(){
				var key = this.getAttribute("data-line-key");
				if (key) state.lineKeyToEl.set(key, this);
			});
		} catch(e) {}
	}
	function setCart(cartJson){ state.lastCartJson = cartJson; }
	function getCart(){ return state.lastCartJson; }
	function initOnce(){ if (state.isInitialized) return; snapshotDom(); state.isInitialized = true; }
	return { initOnce: initOnce, snapshotDom: snapshotDom, setCart: setCart, getCart: getCart, state: state };
})();

function initCartDrawerDiffMode(){
	if (!window.__CART_DRAWER_DIFF_MODE__) return;
	CartDrawerState.initOnce();
}

// Hook into existing cart init/render flows
(function(){
	var originalRenderCartDrawer = typeof renderCartDrawer === 'function' ? renderCartDrawer : null;
	if (originalRenderCartDrawer && !originalRenderCartDrawer.__wrappedForDiff){
		renderCartDrawer = function(sectionsHtml, callback){
			return originalRenderCartDrawer.call(this, sectionsHtml, function(){
				try { initCartDrawerDiffMode(); CartDrawerState.snapshotDom(); } catch(e) {}
				try { if (window.__CART_DRAWER_FORCE_OPEN__) { showCartDrawerWithoutTransition(); window.__CART_DRAWER_FORCE_OPEN__ = false; } } catch(e) {}
				if (typeof callback === 'function') callback();
			});
		};
		renderCartDrawer.__wrappedForDiff = true;
	}

	var originalReloadCart = typeof reloadCart === 'function' ? reloadCart : null;
	if (originalReloadCart && !originalReloadCart.__wrappedForDiff){
		reloadCart = function(cb, options){
			if (!window.__CART_DRAWER_DIFF_MODE__) return originalReloadCart.call(this, cb, options);
			// In diff mode we still fall back to original behavior for now, but capture latest DOM mapping after
			return originalReloadCart.call(this, function(){
				try { CartDrawerState.snapshotDom(); } catch(e) {}
				if (typeof cb === 'function') cb();
			}, options);
		};
		reloadCart.__wrappedForDiff = true;
	}
})();

// Remove duplicate placeholder: cartDrawerOptimisticUpdate defined earlier